var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoWaitingElement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_4996",
    "data-name": "Groupe 4996",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 680.003,
    height: 644.886,
    viewBox: "0 0 680.003 644.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3004",
    "data-name": "Rectangle 3004",
    width: 680.003,
    height: 644.886,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2857",
    "data-name": "Rectangle 2857",
    width: 80.28,
    height: 56.008,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2858",
    "data-name": "Rectangle 2858",
    width: 17.316,
    height: 12.357,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2859",
    "data-name": "Rectangle 2859",
    width: 10.593,
    height: 8.199,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2860",
    "data-name": "Rectangle 2860",
    width: 17.315,
    height: 12.357,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2861",
    "data-name": "Rectangle 2861",
    width: 10.594,
    height: 8.199,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2864",
    "data-name": "Rectangle 2864",
    width: 17.315,
    height: 12.355,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2867",
    "data-name": "Rectangle 2867",
    width: 21.219,
    height: 14.611,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2868",
    "data-name": "Rectangle 2868",
    width: 21.294,
    height: 12.295,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2870",
    "data-name": "Rectangle 2870",
    width: 21.219,
    height: 14.61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2871",
    "data-name": "Rectangle 2871",
    width: 21.294,
    height: 12.293,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2877",
    "data-name": "Rectangle 2877",
    width: 21.295,
    height: 12.295,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2880",
    "data-name": "Rectangle 2880",
    width: 249.915,
    height: 331.091,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2882",
    "data-name": "Rectangle 2882",
    width: 233.69,
    height: 337.464,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2883",
    "data-name": "Rectangle 2883",
    width: 228.475,
    height: 334.646,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2884",
    "data-name": "Rectangle 2884",
    width: 57.389,
    height: 33.077,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2885",
    "data-name": "Rectangle 2885",
    width: 170.432,
    height: 100.717,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2886",
    "data-name": "Rectangle 2886",
    width: 275.173,
    height: 313.453,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2887",
    "data-name": "Rectangle 2887",
    width: 233.177,
    height: 134.699,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2888",
    "data-name": "Rectangle 2888",
    width: 47.215,
    height: 181.774,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2889",
    "data-name": "Rectangle 2889",
    width: 13.906,
    height: 21.203,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2891",
    "data-name": "Rectangle 2891",
    width: 123.456,
    height: 74.128,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2894",
    "data-name": "Rectangle 2894",
    width: 73.745,
    height: 42.576,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2895",
    "data-name": "Rectangle 2895",
    width: 36.874,
    height: 42.576,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2896",
    "data-name": "Rectangle 2896",
    width: 16.734,
    height: 35.665,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2899",
    "data-name": "Rectangle 2899",
    width: 48.921,
    height: 26.338,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2900",
    "data-name": "Rectangle 2900",
    width: 46.382,
    height: 23.803,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2902",
    "data-name": "Rectangle 2902",
    width: 45.966,
    height: 20.649,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2903",
    "data-name": "Rectangle 2903",
    width: 3.308,
    height: 6.873,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2904",
    "data-name": "Rectangle 2904",
    width: 5.984,
    height: 3.33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2905",
    "data-name": "Rectangle 2905",
    width: 27.857,
    height: 13.413,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2906",
    "data-name": "Rectangle 2906",
    width: 2.752,
    height: 3.538,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2907",
    "data-name": "Rectangle 2907",
    width: 2.139,
    height: 3.895,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2908",
    "data-name": "Rectangle 2908",
    width: 2.754,
    height: 4.526,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2910",
    "data-name": "Rectangle 2910",
    width: 36.875,
    height: 42.576,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2913",
    "data-name": "Rectangle 2913",
    width: 73.744,
    height: 42.576,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2917",
    "data-name": "Rectangle 2917",
    width: 45.966,
    height: 20.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2918",
    "data-name": "Rectangle 2918",
    width: 3.308,
    height: 6.875,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2920",
    "data-name": "Rectangle 2920",
    width: 27.857,
    height: 13.411,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2923",
    "data-name": "Rectangle 2923",
    width: 2.754,
    height: 4.525,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2926",
    "data-name": "Rectangle 2926",
    width: 16.735,
    height: 35.665,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2939",
    "data-name": "Rectangle 2939",
    width: 73.745,
    height: 42.578,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2940",
    "data-name": "Rectangle 2940",
    width: 36.874,
    height: 42.578,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2951",
    "data-name": "Rectangle 2951",
    width: 2.751,
    height: 3.538,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2956",
    "data-name": "Rectangle 2956",
    width: 16.734,
    height: 35.664,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2958",
    "data-name": "Rectangle 2958",
    width: 73.745,
    height: 42.577,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2959",
    "data-name": "Rectangle 2959",
    width: 48.921,
    height: 26.339,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2960",
    "data-name": "Rectangle 2960",
    width: 46.382,
    height: 23.802,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2964",
    "data-name": "Rectangle 2964",
    width: 5.984,
    height: 3.329,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2967",
    "data-name": "Rectangle 2967",
    width: 2.139,
    height: 3.896,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2972",
    "data-name": "Rectangle 2972",
    width: 16.735,
    height: 35.664,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2986",
    "data-name": "Rectangle 2986",
    width: 31.988,
    height: 34.338,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2987",
    "data-name": "Rectangle 2987",
    width: 52.473,
    height: 29.429,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2988",
    "data-name": "Rectangle 2988",
    width: 41.368,
    height: 252.873,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2989",
    "data-name": "Rectangle 2989",
    width: 40.664,
    height: 20.929,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2990",
    "data-name": "Rectangle 2990",
    width: 19.655,
    height: 350.682,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2991",
    "data-name": "Rectangle 2991",
    width: 2.282,
    height: 1.324,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2992",
    "data-name": "Rectangle 2992",
    width: 2.282,
    height: 1.323,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2994",
    "data-name": "Rectangle 2994",
    width: 2.281,
    height: 1.324,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2998",
    "data-name": "Rectangle 2998",
    width: 35.194,
    height: 21.229,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3000",
    "data-name": "Rectangle 3000",
    width: 19.813,
    height: 25.425,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3001",
    "data-name": "Rectangle 3001",
    width: 71.053,
    height: 40.935,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3002",
    "data-name": "Rectangle 3002",
    width: 9.218,
    height: 82.524,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4995",
    "data-name": "Groupe 4995",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4513",
    "data-name": "Trac\\xE9 4513",
    d: "M192.153,494.5v-6.651H180.631V481.2H169.112V474.55H157.592V467.9H146.071v-6.651H134.55v-6.653H123.032v-8.328L384.364,295.385v7.429h11.518v6.652h11.522v6.651h11.519v6.652h11.522v6.651h11.518v6.651h11.522v6.652h14.426L205.02,494.5Z",
    transform: "translate(46.129 110.751)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4561",
    "data-name": "Groupe 4561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4560",
    "data-name": "Groupe 4560",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4514",
    "data-name": "Trac\\xE9 4514",
    d: "M475.47,213.6l-87.333,50.347a9.738,9.738,0,0,1-8.806,0l-98.58-56.916a22.42,22.42,0,0,1-6.945-6.943l-3.176-5.5a5.1,5.1,0,0,1,1.855-6.955L351.269,141.9a9.7,9.7,0,0,1,8.8-.01l115.4,66.628c2.432,1.4,2.431,3.678,0,5.08",
    transform: "translate(101.213 52.806)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4515",
    "data-name": "Trac\\xE9 4515",
    d: "M186.906,449.223,19.7,352.5c-6.833-3.945-6.833-10.4,0-14.345L292.73,180.542a11.35,11.35,0,0,1,10.23,0l183.062,96.677a3.051,3.051,0,0,1,0,5.284L197.136,449.223a11.349,11.349,0,0,1-10.23,0",
    transform: "translate(5.466 67.236)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4516",
    "data-name": "Trac\\xE9 4516",
    d: "M22.721,338.907c-16.561,9.561-16.561,25.064,0,34.625s43.412,9.561,59.972,0,16.561-25.064,0-34.625-43.411-9.561-59.972,0",
    transform: "translate(3.862 124.381)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4517",
    "data-name": "Trac\\xE9 4517",
    d: "M63.147,362.523c-16.561,9.561-16.561,25.064,0,34.625s43.412,9.561,59.972,0,16.561-25.064,0-34.625-43.411-9.561-59.972,0",
    transform: "translate(19.019 133.235)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4629",
    "data-name": "Groupe 4629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4628",
    "data-name": "Groupe 4628",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4520",
    "data-name": "Trac\\xE9 4520",
    d: "M270.448,170.082v11.435a5.953,5.953,0,0,0,.7,1.943l10.274,17.763a26.34,26.34,0,0,0,8.211,8.211l87.236,50.387a11.494,11.494,0,0,0,10.412,0l79.064-45.66a3.654,3.654,0,0,0,2.163-3v-9.392a3.68,3.68,0,0,0-2.163-3l-87.236-50.389a26.465,26.465,0,0,1-8.211-8.19L360.647,122.4a6.024,6.024,0,0,0-8.211-2.2l-79.084,45.66a5.926,5.926,0,0,0-2.9,4.225",
    transform: "translate(101.401 44.765)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4521",
    "data-name": "Trac\\xE9 4521",
    d: "M351.61,141.7l84.306,48.7a3.68,3.68,0,0,1,2.164,3v9.392a3.653,3.653,0,0,1-2.164,3l-79.063,45.66a10.667,10.667,0,0,1-5.243,1.244Z",
    transform: "translate(131.832 53.129)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4522",
    "data-name": "Trac\\xE9 4522",
    d: "M270.473,172.125a5.941,5.941,0,0,0,.7,1.943l1.141,1.983,9.132,15.78a26.327,26.327,0,0,0,8.211,8.211l87.236,50.387a11.494,11.494,0,0,0,10.412,0l76.14-43.957,2.924-1.7a3.168,3.168,0,0,0,0-6.009l-87.236-50.387a26.486,26.486,0,0,1-8.211-8.192L360.671,122.4a6.023,6.023,0,0,0-8.211-2.2l-79.084,45.66a5.929,5.929,0,0,0-2.9,4.225,5.857,5.857,0,0,0,0,2.043",
    transform: "translate(101.377 44.765)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4523",
    "data-name": "Trac\\xE9 4523",
    d: "M358.629,139.167l-5.923-9.8a4.1,4.1,0,0,0-5.54-1.426L280.89,166.2a3.911,3.911,0,0,0-1.4,5.431l5.923,9.8a4.1,4.1,0,0,0,5.54,1.426L357.232,144.6a3.911,3.911,0,0,0,1.4-5.431",
    transform: "translate(104.578 47.766)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4564",
    "data-name": "Groupe 4564",
    transform: "translate(383.499 175.163)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4563",
    "data-name": "Groupe 4563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4562",
    "data-name": "Groupe 4562",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4524",
    "data-name": "Trac\\xE9 4524",
    d: "M358.629,139.167l-5.923-9.8a4.1,4.1,0,0,0-5.54-1.426L280.89,166.2a3.911,3.911,0,0,0-1.4,5.431l5.923,9.8a4.1,4.1,0,0,0,5.54,1.426L357.232,144.6a3.911,3.911,0,0,0,1.4-5.431",
    transform: "translate(-278.921 -127.397)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4525",
    "data-name": "Trac\\xE9 4525",
    d: "M312.691,177l-8.3,4.79a3.641,3.641,0,0,1-3.294,0l-4.434-2.559a1.1,1.1,0,0,1-.645-.917v-2.39a1.1,1.1,0,0,1,.645-.912l8.3-4.79a3.641,3.641,0,0,1,3.294,0l4.434,2.559a1.1,1.1,0,0,1,.643.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.643.917",
    transform: "translate(110.989 63.674)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4567",
    "data-name": "Groupe 4567",
    transform: "translate(407.009 233.498)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4566",
    "data-name": "Groupe 4566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4565",
    "data-name": "Groupe 4565",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4526",
    "data-name": "Trac\\xE9 4526",
    d: "M312.691,177l-8.3,4.79a3.641,3.641,0,0,1-3.294,0l-4.434-2.559a1.1,1.1,0,0,1-.645-.917v-2.39a1.1,1.1,0,0,1,.645-.912l8.3-4.79a3.641,3.641,0,0,1,3.294,0l4.434,2.559a1.1,1.1,0,0,1,.643.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.643.917",
    transform: "translate(-296.02 -169.824)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4527",
    "data-name": "Trac\\xE9 4527",
    d: "M304.973,170.218l-8.3,4.79a1,1,0,0,0,0,1.9l4.433,2.559a3.641,3.641,0,0,0,3.294,0l8.3-4.79a1,1,0,0,0,0-1.9l-4.433-2.559a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(110.979 63.674)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4570",
    "data-name": "Groupe 4570",
    transform: "translate(413.73 237.655)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4569",
    "data-name": "Groupe 4569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4568",
    "data-name": "Groupe 4568",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4528",
    "data-name": "Trac\\xE9 4528",
    d: "M311.5,172.848v2.091a1.106,1.106,0,0,1-.646.925l-8.3,4.789a3.257,3.257,0,0,1-1.647.393v-2.32a3.307,3.307,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(-300.908 -172.848)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4529",
    "data-name": "Trac\\xE9 4529",
    d: "M326.746,168.884l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-4.433-2.559a1.1,1.1,0,0,1-.645-.917v-2.39a1.1,1.1,0,0,1,.645-.912l8.3-4.79a3.633,3.633,0,0,1,3.294,0l4.433,2.559a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(116.259 60.632)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4573",
    "data-name": "Groupe 4573",
    transform: "translate(426.335 222.344)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4572",
    "data-name": "Groupe 4572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4571",
    "data-name": "Groupe 4571",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4530",
    "data-name": "Trac\\xE9 4530",
    d: "M326.746,168.884l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-4.433-2.559a1.1,1.1,0,0,1-.645-.917v-2.39a1.1,1.1,0,0,1,.645-.912l8.3-4.79a3.633,3.633,0,0,1,3.294,0l4.433,2.559a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(-310.076 -161.712)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4531",
    "data-name": "Trac\\xE9 4531",
    d: "M319.028,162.106l-8.3,4.79a1,1,0,0,0,0,1.9l4.433,2.559a3.641,3.641,0,0,0,3.294,0l8.3-4.79a1,1,0,0,0,0-1.9l-4.433-2.559a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(116.249 60.632)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4576",
    "data-name": "Groupe 4576",
    transform: "translate(433.055 226.502)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4575",
    "data-name": "Groupe 4575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4574",
    "data-name": "Groupe 4574",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4532",
    "data-name": "Trac\\xE9 4532",
    d: "M325.557,164.736v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.256,3.256,0,0,1-1.647.393v-2.32a3.306,3.306,0,0,0,1.647-.392l8.3-4.79a1.394,1.394,0,0,0,.646-.7",
    transform: "translate(-314.963 -164.736)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4533",
    "data-name": "Trac\\xE9 4533",
    d: "M340.8,160.771l-8.3,4.79a3.644,3.644,0,0,1-3.3,0L324.777,163a1.1,1.1,0,0,1-.645-.917V159.7a1.1,1.1,0,0,1,.645-.912l8.3-4.79a3.644,3.644,0,0,1,3.3,0l4.433,2.559a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(121.53 57.59)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4579",
    "data-name": "Groupe 4579",
    transform: "translate(445.662 211.189)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4578",
    "data-name": "Groupe 4578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4577",
    "data-name": "Groupe 4577",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4534",
    "data-name": "Trac\\xE9 4534",
    d: "M340.8,160.771l-8.3,4.79a3.644,3.644,0,0,1-3.3,0L324.777,163a1.1,1.1,0,0,1-.645-.917V159.7a1.1,1.1,0,0,1,.645-.912l8.3-4.79a3.644,3.644,0,0,1,3.3,0l4.433,2.559a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(-324.132 -153.599)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4535",
    "data-name": "Trac\\xE9 4535",
    d: "M333.084,153.993l-8.3,4.79a1,1,0,0,0,0,1.9l4.433,2.559a3.641,3.641,0,0,0,3.294,0l8.3-4.79a1,1,0,0,0,0-1.9l-4.433-2.559a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(121.519 57.59)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4582",
    "data-name": "Groupe 4582",
    transform: "translate(452.381 215.347)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4581",
    "data-name": "Groupe 4581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4580",
    "data-name": "Groupe 4580",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4536",
    "data-name": "Trac\\xE9 4536",
    d: "M339.613,156.623v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.257,3.257,0,0,1-1.647.393V162.5a3.306,3.306,0,0,0,1.647-.392l8.3-4.79a1.394,1.394,0,0,0,.646-.7",
    transform: "translate(-329.019 -156.623)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4537",
    "data-name": "Trac\\xE9 4537",
    d: "M354.857,152.658l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-4.433-2.559a1.1,1.1,0,0,1-.645-.917v-2.39a1.1,1.1,0,0,1,.645-.912l8.3-4.79a3.644,3.644,0,0,1,3.3,0l4.433,2.559a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(126.799 54.549)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4585",
    "data-name": "Groupe 4585",
    transform: "translate(464.986 200.036)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4584",
    "data-name": "Groupe 4584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4583",
    "data-name": "Groupe 4583",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4538",
    "data-name": "Trac\\xE9 4538",
    d: "M354.857,152.658l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-4.433-2.559a1.1,1.1,0,0,1-.645-.917v-2.39a1.1,1.1,0,0,1,.645-.912l8.3-4.79a3.644,3.644,0,0,1,3.3,0l4.433,2.559a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(-338.187 -145.487)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4539",
    "data-name": "Trac\\xE9 4539",
    d: "M347.14,145.88l-8.3,4.79a1,1,0,0,0,0,1.9l4.433,2.559a3.641,3.641,0,0,0,3.294,0l8.3-4.79a1,1,0,0,0,0-1.9l-4.433-2.559a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(126.789 54.549)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4588",
    "data-name": "Groupe 4588",
    transform: "translate(471.706 204.192)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4587",
    "data-name": "Groupe 4587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4586",
    "data-name": "Groupe 4586",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4540",
    "data-name": "Trac\\xE9 4540",
    d: "M353.668,148.51V150.6a1.106,1.106,0,0,1-.646.925l-8.3,4.789a3.258,3.258,0,0,1-1.647.393v-2.32a3.308,3.308,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(-343.074 -148.51)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4541",
    "data-name": "Trac\\xE9 4541",
    d: "M327.837,185.74l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917v-2.388a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(115.204 66.107)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4542",
    "data-name": "Trac\\xE9 4542",
    d: "M316.214,176.708l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.79a1,1,0,0,0,0-1.9l-8.338-4.814a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(115.194 66.107)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4543",
    "data-name": "Trac\\xE9 4543",
    d: "M325.583,180.978v2.091a1.106,1.106,0,0,1-.646.925l-8.3,4.789a3.257,3.257,0,0,1-1.647.393v-2.32a3.307,3.307,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(118.102 67.856)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4544",
    "data-name": "Trac\\xE9 4544",
    d: "M322.787,181.248v-.279a.971.971,0,0,0-.342-.709.9.9,0,0,1,.342.989",
    transform: "translate(120.897 67.586)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4545",
    "data-name": "Trac\\xE9 4545",
    d: "M341.872,177.588l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.093,1.093,0,0,1-.643-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.643-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(120.467 63.051)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4546",
    "data-name": "Trac\\xE9 4546",
    d: "M330.249,168.556l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.79a1,1,0,0,0,0-1.9l-8.338-4.814a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(120.456 63.051)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4547",
    "data-name": "Trac\\xE9 4547",
    d: "M339.618,172.826v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.257,3.257,0,0,1-1.647.393v-2.32a3.3,3.3,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(123.364 64.799)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4548",
    "data-name": "Trac\\xE9 4548",
    d: "M336.822,173.1v-.279a.971.971,0,0,0-.342-.709.9.9,0,0,1,.342.989",
    transform: "translate(126.159 64.53)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4549",
    "data-name": "Trac\\xE9 4549",
    d: "M355.907,169.436l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.643-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(125.729 59.994)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4550",
    "data-name": "Trac\\xE9 4550",
    d: "M344.284,160.4l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.64,3.64,0,0,0,3.294,0l8.3-4.79a1,1,0,0,0,0-1.9l-8.336-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(125.719 59.994)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4551",
    "data-name": "Trac\\xE9 4551",
    d: "M353.653,164.674v2.091a1.105,1.105,0,0,1-.646.925l-8.3,4.789a3.261,3.261,0,0,1-1.647.393v-2.32a3.31,3.31,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(128.626 61.743)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4552",
    "data-name": "Trac\\xE9 4552",
    d: "M350.857,164.944v-.279a.971.971,0,0,0-.342-.709.9.9,0,0,1,.342.989",
    transform: "translate(131.422 61.473)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4553",
    "data-name": "Trac\\xE9 4553",
    d: "M340.456,193.024l-8.3,4.79a3.643,3.643,0,0,1-3.3,0L320.526,193a1.1,1.1,0,0,1-.645-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.644-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(119.936 68.838)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4554",
    "data-name": "Trac\\xE9 4554",
    d: "M328.832,183.992l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.338-4.814a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(119.925 68.838)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4555",
    "data-name": "Trac\\xE9 4555",
    d: "M338.2,188.262v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.257,3.257,0,0,1-1.647.393v-2.32a3.306,3.306,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(122.833 70.587)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4556",
    "data-name": "Trac\\xE9 4556",
    d: "M335.406,188.532v-.279a.971.971,0,0,0-.342-.709.9.9,0,0,1,.342.989",
    transform: "translate(125.628 70.317)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4557",
    "data-name": "Trac\\xE9 4557",
    d: "M354.491,184.872l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.644-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.907c0,.1,0,2.3,0,2.394a1.1,1.1,0,0,1-.645.917",
    transform: "translate(125.198 65.782)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4558",
    "data-name": "Trac\\xE9 4558",
    d: "M342.868,175.84l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.336-4.814a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(125.188 65.782)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4559",
    "data-name": "Trac\\xE9 4559",
    d: "M352.237,180.11V182.2a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.257,3.257,0,0,1-1.647.393v-2.32a3.306,3.306,0,0,0,1.647-.392l8.3-4.79a1.394,1.394,0,0,0,.646-.7",
    transform: "translate(128.095 67.53)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4560",
    "data-name": "Trac\\xE9 4560",
    d: "M349.441,180.38V180.1a.971.971,0,0,0-.342-.709.9.9,0,0,1,.342.989",
    transform: "translate(130.891 67.261)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4561",
    "data-name": "Trac\\xE9 4561",
    d: "M368.526,176.72l-8.3,4.79a3.643,3.643,0,0,1-3.3,0L348.6,176.7a1.1,1.1,0,0,1-.645-.917v-2.388a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(130.46 62.725)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4562",
    "data-name": "Trac\\xE9 4562",
    d: "M356.9,167.688l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.64,3.64,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.338-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(130.45 62.725)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4563",
    "data-name": "Trac\\xE9 4563",
    d: "M366.272,171.958v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.256,3.256,0,0,1-1.647.393v-2.32a3.3,3.3,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(133.357 64.474)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4564",
    "data-name": "Trac\\xE9 4564",
    d: "M363.476,172.228v-.279a.971.971,0,0,0-.343-.71.9.9,0,0,1,.343.989",
    transform: "translate(136.153 64.204)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4565",
    "data-name": "Trac\\xE9 4565",
    d: "M353.075,200.308l-8.3,4.79a3.641,3.641,0,0,1-3.294,0l-8.339-4.814a1.1,1.1,0,0,1-.645-.917V196.98a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.339,4.814a1.1,1.1,0,0,1,.643.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.643.917",
    transform: "translate(124.667 71.569)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4566",
    "data-name": "Trac\\xE9 4566",
    d: "M341.452,191.276l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.79a1,1,0,0,0,0-1.9l-8.338-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(124.657 71.569)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4567",
    "data-name": "Trac\\xE9 4567",
    d: "M350.82,195.546v2.091a1.106,1.106,0,0,1-.646.925l-8.3,4.789a3.256,3.256,0,0,1-1.647.393v-2.319a3.306,3.306,0,0,0,1.647-.392l8.3-4.79a1.394,1.394,0,0,0,.646-.7",
    transform: "translate(127.564 73.318)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4568",
    "data-name": "Trac\\xE9 4568",
    d: "M348.024,195.816v-.279a.972.972,0,0,0-.342-.71.9.9,0,0,1,.342.989",
    transform: "translate(130.359 73.048)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4569",
    "data-name": "Trac\\xE9 4569",
    d: "M367.11,192.156l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917v-2.388a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(129.929 68.513)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4570",
    "data-name": "Trac\\xE9 4570",
    d: "M355.487,183.124l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.815a3.649,3.649,0,0,0,3.294,0l8.3-4.793a1,1,0,0,0,0-1.9l-8.338-4.814a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(129.919 68.513)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4571",
    "data-name": "Trac\\xE9 4571",
    d: "M364.855,187.394v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.257,3.257,0,0,1-1.647.393v-2.32a3.306,3.306,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(132.826 70.261)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4572",
    "data-name": "Trac\\xE9 4572",
    d: "M362.059,187.664v-.279a.971.971,0,0,0-.342-.71.9.9,0,0,1,.342.989",
    transform: "translate(135.622 69.992)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4573",
    "data-name": "Trac\\xE9 4573",
    d: "M381.144,184l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.093,1.093,0,0,1-.643-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.643-.913l8.3-4.79a3.64,3.64,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(135.192 65.456)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4574",
    "data-name": "Trac\\xE9 4574",
    d: "M369.522,174.972l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.336-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(135.181 65.456)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4575",
    "data-name": "Trac\\xE9 4575",
    d: "M378.891,179.242v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.257,3.257,0,0,1-1.647.393v-2.319a3.307,3.307,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(138.089 67.205)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4576",
    "data-name": "Trac\\xE9 4576",
    d: "M376.1,179.512v-.279a.971.971,0,0,0-.342-.71.9.9,0,0,1,.342.989",
    transform: "translate(140.884 66.935)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4577",
    "data-name": "Trac\\xE9 4577",
    d: "M365.693,207.592l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917v-2.388a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.64,3.64,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(129.398 74.3)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4578",
    "data-name": "Trac\\xE9 4578",
    d: "M354.071,198.561l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.338-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(129.388 74.301)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4579",
    "data-name": "Trac\\xE9 4579",
    d: "M363.439,202.83v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.257,3.257,0,0,1-1.647.393v-2.319a3.307,3.307,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(132.295 76.049)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4580",
    "data-name": "Trac\\xE9 4580",
    d: "M360.643,203.1v-.279a.971.971,0,0,0-.342-.709.9.9,0,0,1,.342.989",
    transform: "translate(135.091 75.779)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4581",
    "data-name": "Trac\\xE9 4581",
    d: "M379.728,199.44l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.643-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.907c0,.1,0,2.3,0,2.394a1.1,1.1,0,0,1-.645.917",
    transform: "translate(134.66 71.244)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4582",
    "data-name": "Trac\\xE9 4582",
    d: "M368.106,190.409l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.338-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(134.65 71.244)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4583",
    "data-name": "Trac\\xE9 4583",
    d: "M377.474,194.678v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.256,3.256,0,0,1-1.647.393v-2.32a3.306,3.306,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(137.557 72.992)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4584",
    "data-name": "Trac\\xE9 4584",
    d: "M374.678,194.948v-.279a.971.971,0,0,0-.342-.709.9.9,0,0,1,.342.988",
    transform: "translate(140.353 72.723)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4585",
    "data-name": "Trac\\xE9 4585",
    d: "M393.763,191.288l-8.3,4.79a3.643,3.643,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917V187.96a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(139.923 68.187)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4586",
    "data-name": "Trac\\xE9 4586",
    d: "M382.141,182.257l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.336-4.814a3.644,3.644,0,0,0-3.3,0",
    transform: "translate(139.913 68.188)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4591",
    "data-name": "Groupe 4591",
    transform: "translate(523.736 256.462)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4590",
    "data-name": "Groupe 4590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4589",
    "data-name": "Groupe 4589",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4587",
    "data-name": "Trac\\xE9 4587",
    d: "M391.509,186.526v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.258,3.258,0,0,1-1.647.393v-2.32a3.307,3.307,0,0,0,1.647-.392l8.3-4.79a1.393,1.393,0,0,0,.646-.7",
    transform: "translate(-380.916 -186.526)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4588",
    "data-name": "Trac\\xE9 4588",
    d: "M369.942,161.284l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917v-2.388a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(130.991 56.938)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4594",
    "data-name": "Groupe 4594",
    transform: "translate(480.358 208.795)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4593",
    "data-name": "Groupe 4593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4592",
    "data-name": "Groupe 4592",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4589",
    "data-name": "Trac\\xE9 4589",
    d: "M369.942,161.284l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917v-2.388a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(-349.367 -151.858)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4590",
    "data-name": "Trac\\xE9 4590",
    d: "M358.32,152.252l-8.3,4.79a1,1,0,0,0,0,1.9l8.339,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.338-4.814a3.641,3.641,0,0,0-3.294,0",
    transform: "translate(130.981 56.938)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4597",
    "data-name": "Groupe 4597",
    transform: "translate(480.321 208.795)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4596",
    "data-name": "Groupe 4596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4595",
    "data-name": "Groupe 4595",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4591",
    "data-name": "Trac\\xE9 4591",
    d: "M358.32,152.252l-8.3,4.79a1,1,0,0,0,0,1.9l8.339,4.814a3.641,3.641,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.338-4.814a3.641,3.641,0,0,0-3.294,0",
    transform: "translate(-349.34 -151.858)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4600",
    "data-name": "Groupe 4600",
    transform: "translate(490.982 215.208)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4599",
    "data-name": "Groupe 4599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4598",
    "data-name": "Groupe 4598",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4592",
    "data-name": "Trac\\xE9 4592",
    d: "M367.688,156.522v2.091a1.106,1.106,0,0,1-.646.925l-8.3,4.789a3.256,3.256,0,0,1-1.647.393V162.4a3.306,3.306,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(-357.094 -156.522)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4593",
    "data-name": "Trac\\xE9 4593",
    d: "M382.561,168.568l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.094,1.094,0,0,1-.643-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.643-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(135.723 59.669)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4603",
    "data-name": "Groupe 4603",
    transform: "translate(497.708 218.812)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4602",
    "data-name": "Groupe 4602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4601",
    "data-name": "Groupe 4601",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4594",
    "data-name": "Trac\\xE9 4594",
    d: "M382.561,168.568l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.094,1.094,0,0,1-.643-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.643-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(-361.986 -159.143)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4595",
    "data-name": "Trac\\xE9 4595",
    d: "M370.938,159.536l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.637,3.637,0,0,0,3.294,0l8.3-4.789a1,1,0,0,0,0-1.9l-8.336-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(135.712 59.669)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4606",
    "data-name": "Groupe 4606",
    transform: "translate(497.671 218.812)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4605",
    "data-name": "Groupe 4605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4604",
    "data-name": "Groupe 4604",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4596",
    "data-name": "Trac\\xE9 4596",
    d: "M370.938,159.536l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.637,3.637,0,0,0,3.294,0l8.3-4.789a1,1,0,0,0,0-1.9l-8.336-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(-361.959 -159.143)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4609",
    "data-name": "Groupe 4609",
    transform: "translate(508.333 225.223)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4608",
    "data-name": "Groupe 4608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4607",
    "data-name": "Groupe 4607",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4597",
    "data-name": "Trac\\xE9 4597",
    d: "M380.307,163.806V165.9a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.257,3.257,0,0,1-1.647.393v-2.32a3.306,3.306,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(-369.713 -163.806)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4598",
    "data-name": "Trac\\xE9 4598",
    d: "M395.18,175.852l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.643-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(140.454 62.4)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4612",
    "data-name": "Groupe 4612",
    transform: "translate(515.059 228.827)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4611",
    "data-name": "Groupe 4611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4610",
    "data-name": "Groupe 4610",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4599",
    "data-name": "Trac\\xE9 4599",
    d: "M395.18,175.852l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917c0-.092,0-2.293,0-2.388a1.1,1.1,0,0,1,.643-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(-374.605 -166.427)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4600",
    "data-name": "Trac\\xE9 4600",
    d: "M383.557,166.82l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.64,3.64,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.336-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(140.443 62.4)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4615",
    "data-name": "Groupe 4615",
    transform: "translate(515.022 228.827)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4614",
    "data-name": "Groupe 4614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4613",
    "data-name": "Groupe 4613",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4601",
    "data-name": "Trac\\xE9 4601",
    d: "M383.557,166.82l-8.3,4.79a1,1,0,0,0,0,1.9l8.338,4.814a3.64,3.64,0,0,0,3.294,0l8.3-4.792a1,1,0,0,0,0-1.9l-8.336-4.814a3.643,3.643,0,0,0-3.3,0",
    transform: "translate(-374.578 -166.427)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4618",
    "data-name": "Groupe 4618",
    transform: "translate(525.683 235.238)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4617",
    "data-name": "Groupe 4617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4616",
    "data-name": "Groupe 4616",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4602",
    "data-name": "Trac\\xE9 4602",
    d: "M392.926,171.09v2.091a1.106,1.106,0,0,1-.646.925l-8.3,4.789a3.256,3.256,0,0,1-1.647.393v-2.319a3.3,3.3,0,0,0,1.647-.392l8.3-4.79a1.389,1.389,0,0,0,.646-.7",
    transform: "translate(-382.332 -171.09)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4603",
    "data-name": "Trac\\xE9 4603",
    d: "M407.8,183.136l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917v-2.388a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(145.185 65.131)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4621",
    "data-name": "Groupe 4621",
    transform: "translate(532.409 238.842)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4620",
    "data-name": "Groupe 4620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4619",
    "data-name": "Groupe 4619",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4604",
    "data-name": "Trac\\xE9 4604",
    d: "M407.8,183.136l-8.3,4.79a3.644,3.644,0,0,1-3.3,0l-8.338-4.814a1.1,1.1,0,0,1-.645-.917v-2.388a1.1,1.1,0,0,1,.645-.913l8.3-4.79a3.641,3.641,0,0,1,3.294,0l8.338,4.814a1.1,1.1,0,0,1,.645.906c0,.1,0,2.3,0,2.4a1.1,1.1,0,0,1-.645.917",
    transform: "translate(-387.224 -173.711)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4605",
    "data-name": "Trac\\xE9 4605",
    d: "M396.176,174.1l-8.3,4.792a1,1,0,0,0,0,1.9l8.338,4.814a3.637,3.637,0,0,0,3.294,0l8.3-4.789a1,1,0,0,0,0-1.9l-8.336-4.815a3.653,3.653,0,0,0-3.3,0",
    transform: "translate(145.175 65.131)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4624",
    "data-name": "Groupe 4624",
    transform: "translate(532.371 238.842)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4623",
    "data-name": "Groupe 4623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4622",
    "data-name": "Groupe 4622",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4606",
    "data-name": "Trac\\xE9 4606",
    d: "M396.176,174.1l-8.3,4.792a1,1,0,0,0,0,1.9l8.338,4.814a3.637,3.637,0,0,0,3.294,0l8.3-4.789a1,1,0,0,0,0-1.9l-8.336-4.815a3.653,3.653,0,0,0-3.3,0",
    transform: "translate(-387.196 -173.711)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4627",
    "data-name": "Groupe 4627",
    transform: "translate(543.033 245.253)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4626",
    "data-name": "Groupe 4626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4625",
    "data-name": "Groupe 4625",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4607",
    "data-name": "Trac\\xE9 4607",
    d: "M405.544,178.374v2.091a1.1,1.1,0,0,1-.646.924l-8.3,4.79a3.256,3.256,0,0,1-1.647.393v-2.32a3.307,3.307,0,0,0,1.647-.392l8.3-4.79a1.4,1.4,0,0,0,.646-.7",
    transform: "translate(-394.951 -178.374)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4634",
    "data-name": "Groupe 4634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4633",
    "data-name": "Groupe 4633",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4608",
    "data-name": "Trac\\xE9 4608",
    d: "M31.8,336.625c0,4,3,8.98,6.693,11.112l145.7,84.135a14.79,14.79,0,0,0,13.384,0L454.132,283.749c3.7-2.133,6.692-7.108,6.692-11.112s-3-8.978-6.692-11.111l-145.7-84.137a14.8,14.8,0,0,0-13.384,0L38.491,325.514c-3.7,2.133-6.692,7.109-6.692,11.111",
    transform: "translate(11.923 65.91)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4609",
    "data-name": "Trac\\xE9 4609",
    d: "M417.446,249.025c0,4.007-3,8.974-6.7,11.109L154.19,408.265a13.794,13.794,0,0,1-6.684,1.6V395.368a13.662,13.662,0,0,0,6.684-1.607L410.75,245.642c3.237-1.866,3.641-4.752,1.214-6.875,3.109,2.416,5.482,6.706,5.482,10.258",
    transform: "translate(55.306 89.523)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4610",
    "data-name": "Trac\\xE9 4610",
    d: "M190.886,378.042v14.481a13.654,13.654,0,0,1-6.692-1.591l-145.7-84.141C34.8,304.659,31.8,299.683,31.8,295.68c0-3.756,2.643-8.361,6.013-10.679-3,2.148-2.766,5.3.679,7.294l145.7,84.139a13.646,13.646,0,0,0,6.692,1.607",
    transform: "translate(11.922 106.858)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4611",
    "data-name": "Trac\\xE9 4611",
    d: "M50.513,322.683l238.142-137.49a7.4,7.4,0,0,1,6.692,0l6.928,3.641c1.848,1.067,1.848,2.8,0,3.862L64.1,330.164a7.4,7.4,0,0,1-6.692,0l-6.893-3.617c-1.848-1.067-1.848-2.8,0-3.864",
    transform: "translate(18.42 69.136)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4612",
    "data-name": "Trac\\xE9 4612",
    d: "M64.149,330.791,302.288,193.3a6.824,6.824,0,0,1,6.114-.334l61.985,35.79c1.529.883,1.27,2.463-.579,3.529l-237.862,137.3a6.859,6.859,0,0,1-6.121.344L63.578,334.311c-1.533-.877-1.277-2.453.571-3.52",
    transform: "translate(23.462 72.135)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4613",
    "data-name": "Trac\\xE9 4613",
    d: "M267.033,249.027l7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.318.183-.363.451-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.061m-10.4-14.617-7.456,4.3c-.316.183-.363.452-.1.6l6.578,3.8a1.17,1.17,0,0,0,1.044-.059l7.456-4.3c.316-.183.363-.454.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.059M232.54,248.319,219.921,255.6c-.316.183-.363.454-.1.6L226.4,260a1.167,1.167,0,0,0,1.044-.061l12.618-7.284c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.061m13.191-7.617-7.456,4.3c-.316.183-.363.454-.1.6l6.578,3.8a1.168,1.168,0,0,0,1.042-.059l7.456-4.3c.316-.184.363-.454.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.059M216.48,257.59l-7.456,4.3c-.318.183-.363.452-.1.6l6.578,3.8a1.17,1.17,0,0,0,1.044-.059L224,261.929c.316-.182.363-.452.1-.6l-6.576-3.8a1.162,1.162,0,0,0-1.044.059m-10.9,6.292-7.456,4.3c-.318.183-.363.452-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.165,1.165,0,0,0-1.044.059M233.213,280.5l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.061l-7.456,4.3c-.318.183-.364.452-.1.6l6.578,3.8a1.167,1.167,0,0,0,1.044-.06m-10.9,6.292,7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.061l-7.456,4.3c-.318.183-.363.452-.1.6l6.578,3.8a1.171,1.171,0,0,0,1.044-.061m-10.9,6.292,7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.061m-10.9,6.292,7.456-4.3c.318-.183.363-.452.1-.6l-6.576-3.8a1.171,1.171,0,0,0-1.044.06l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.059m55.615-44.053,7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.163,1.163,0,0,0-1.042.061l-7.456,4.3c-.318.183-.364.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.061M244.111,274.2l16.633-9.6c.316-.184.363-.452.1-.6l-16.92-9.77a1.171,1.171,0,0,0-1.044.06l-8.6,4.968c-.318.183-.363.452-.1.6l9.4,5.43c.26.148.212.419-.1.6l-6.882,3.974c-.318.183-.364.452-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.06m-49.426-4.031-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.316-.183.363-.454.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.061m-10.9,6.292-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.316-.181.363-.452.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.059m-60.592,67.009a1.164,1.164,0,0,0,1.042-.06l7.458-4.3c.316-.183.362-.454.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.061l-7.455,4.3c-.318.184-.363.454-.1.6ZM96.606,326.8l-7.455,4.3c-.318.183-.364.452-.1.6l6.578,3.8a1.158,1.158,0,0,0,1.042-.059l7.458-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.059m13.377,12.358a1.163,1.163,0,0,0,1.042-.059l7.458-4.3c.316-.183.363-.454.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.059l-7.456,4.3c-.318.184-.364.452-.1.6Zm30.334,6.917,7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.061l-7.456,4.3c-.316.182-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.059m-11.941,6.351a1.165,1.165,0,0,0,1.044-.059l7.456-4.305c.316-.183.363-.452.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.059l-7.456,4.306c-.316.183-.363.452-.1.6ZM107.5,320.507l-7.456,4.3c-.316.183-.362.452-.1.6l6.578,3.8a1.164,1.164,0,0,0,1.042-.06l7.456-4.3c.318-.183.364-.452.1-.6l-6.578-3.8a1.167,1.167,0,0,0-1.044.06m54.489-31.459-7.458,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.318-.183.363-.452.1-.6l-6.578-3.8a1.159,1.159,0,0,0-1.042.059M118.4,314.215l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06l7.456-4.3c.318-.183.363-.452.1-.6l-6.576-3.8a1.171,1.171,0,0,0-1.044.06m54.487-31.459-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.162,1.162,0,0,0,1.044-.061l7.456-4.3c.318-.184.363-.454.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.061M151.1,295.34l-7.456,4.3c-.316.183-.364.452-.1.6l6.578,3.8a1.167,1.167,0,0,0,1.044-.06l7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.163,1.163,0,0,0-1.042.059m-10.9,6.292-7.456,4.3c-.316.183-.363.452-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.06l7.456-4.3c.316-.184.363-.454.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.061m-10.9,6.292-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.167,1.167,0,0,0-1.044.06m49.425,4.031,7.456-4.3c.318-.183.364-.452.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.061l-7.456,4.3c-.316.184-.362.454-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06M280.718,220.5l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06l7.456-4.3c.318-.184.363-.454.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.06m-13.191,7.616-7.456,4.3c-.318.183-.363.452-.1.6l6.578,3.8a1.167,1.167,0,0,0,1.042-.059l7.458-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.163,1.163,0,0,0-1.042.059m24.089-13.908-7.456,4.3c-.316.183-.363.452-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.06l7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.171,1.171,0,0,0-1.044.061M230.9,269.889l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.318.183-.363.452-.1.6l6.578,3.8a1.171,1.171,0,0,0,1.044-.061m72.657-62.029a1.166,1.166,0,0,0-1.044.059l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.163,1.163,0,0,0,1.042-.061l7.458-4.3c.316-.183.363-.452.1-.6Zm-113.934,97.8,7.456-4.3c.318-.183.363-.452.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.059l-7.456,4.306c-.316.183-.363.452-.1.6l6.576,3.8a1.161,1.161,0,0,0,1.044-.059m133.638-77.156,7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.163,1.163,0,0,0-1.042.06l-7.456,4.3c-.316.183-.364.452-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.06m-21.241.32,7.456-4.306c.316-.181.363-.451.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.059l-7.456,4.3c-.316.184-.363.452-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.059m11.881-15a1.165,1.165,0,0,0-1.044.059L305.4,218.2c-.316.181-.363.452-.1.6l6.576,3.8a1.167,1.167,0,0,0,1.042-.059l7.458-4.3c.316-.183.363-.452.1-.6Zm2.293-1.324,16.921,9.769a1.163,1.163,0,0,0,1.042-.06l7.456-4.3c.318-.184.364-.454.1-.6L324.8,207.539a1.167,1.167,0,0,0-1.044.06l-7.455,4.3c-.316.183-.364.454-.1.6m-25.132,13.968-7.456,4.3c-.316.183-.363.454-.1.6l6.578,3.8a1.159,1.159,0,0,0,1.042-.06l7.456-4.3c.316-.184.363-.454.1-.6l-6.578-3.8a1.162,1.162,0,0,0-1.044.061m-82.018,47.352-7.456,4.306c-.316.183-.363.452-.1.6l6.576,3.8a1.165,1.165,0,0,0,1.044-.059l7.456-4.3c.318-.183.363-.452.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.059M311.32,234.859a1.166,1.166,0,0,0,1.044-.06l7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.061l-7.456,4.3c-.316.183-.363.452-.1.6Zm-91.378,32.677-7.456,4.3c-.318.183-.363.452-.1.6l6.576,3.8A1.171,1.171,0,0,0,220,276.18l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.06m-85.85,69.645a1.161,1.161,0,0,0,1.044-.059l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.059l-7.456,4.306c-.316.182-.363.452-.1.6ZM121.864,324.16l-7.458,4.306c-.316.182-.363.452-.1.6l6.578,3.8a1.163,1.163,0,0,0,1.042-.059l7.456-4.305c.318-.183.364-.452.1-.6l-6.578-3.8a1.163,1.163,0,0,0-1.042.059m24.169,6.67,7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.162,1.162,0,0,0-1.044.06l-7.456,4.3c-.316.181-.363.452-.1.6l6.578,3.8a1.163,1.163,0,0,0,1.042-.059m10.9-6.292,7.456-4.3c.316-.183.363-.452.1-.6l-6.579-3.8a1.164,1.164,0,0,0-1.042.06l-7.456,4.3c-.316.184-.363.454-.1.6l6.576,3.8a1.162,1.162,0,0,0,1.044-.059m10.9-6.292,7.455-4.3c.318-.183.364-.452.1-.6l-6.576-3.8a1.169,1.169,0,0,0-1.045.06l-7.455,4.3c-.318.182-.363.452-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.059m-35.068-.377-7.455,4.3c-.318.183-.364.454-.1.6l6.578,3.8a1.159,1.159,0,0,0,1.042-.061l7.456-4.3c.318-.183.363-.454.1-.6l-6.578-3.8a1.161,1.161,0,0,0-1.044.06m10.9-6.293-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.059l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.059m43.59-25.165-7.456,4.3c-.316.184-.363.454-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.059l7.456-4.3c.318-.183.363-.452.1-.6l-6.578-3.8a1.161,1.161,0,0,0-1.044.061m-10.9,6.29-7.456,4.3c-.318.183-.364.454-.1.6l6.578,3.8a1.168,1.168,0,0,0,1.042-.059l7.456-4.3c.318-.183.364-.452.1-.6l-6.578-3.8a1.167,1.167,0,0,0-1.042.059m21.794-12.583-7.456,4.3c-.316.184-.363.454-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.318-.183.363-.452.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.059m-43.59,25.167-7.456,4.3c-.316.183-.364.454-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.059l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.059m10.9-6.292L158,303.3c-.318.184-.364.454-.1.6l6.578,3.8a1.162,1.162,0,0,0,1.044-.059l7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.17,1.17,0,0,0-1.044.059m-14.237,40.789,7.456-4.3c.316-.183.362-.452.1-.6l-6.578-3.8a1.159,1.159,0,0,0-1.042.061l-7.456,4.3c-.318.184-.364.454-.1.6l6.578,3.8a1.171,1.171,0,0,0,1.044-.06M93.33,336.828l-6.576-3.8a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.318.183-.363.452-.1.6l6.578,3.8a1.167,1.167,0,0,0,1.044-.061l7.456-4.3c.316-.183.363-.452.1-.6m14.358,3.653-6.578-3.8a1.159,1.159,0,0,0-1.042.06L88.6,343.367c-.318.183-.363.452-.1.6l6.576,3.8a1.162,1.162,0,0,0,1.044-.06l11.471-6.622c.316-.184.363-.454.1-.6M83.648,329.25l-6.578-3.8a1.164,1.164,0,0,0-1.042.06l-9.178,5.3c-.316.183-.363.454-.1.6l6.576,3.8a1.17,1.17,0,0,0,1.044-.059l9.178-5.3c.316-.182.362-.452.1-.6m7.036-4.062a1.164,1.164,0,0,0,1.042-.061l7.456-4.3c.318-.183.364-.452.1-.6l-6.578-3.8a1.167,1.167,0,0,0-1.044.06l-7.455,4.3c-.318.183-.363.452-.1.6ZM120.9,344.8l-6.576-3.8a1.166,1.166,0,0,0-1.044.06l-14.339,8.277c-.318.184-.363.454-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06L120.8,345.4c.318-.183.364-.452.1-.6m5.182,8.952-6.578-3.8a1.166,1.166,0,0,0-1.044.059l-9.176,5.3c-.318.183-.363.452-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.061l9.176-5.3c.318-.183.363-.452.1-.6m45.625-75.341a1.163,1.163,0,0,0,1.042-.059l7.456-4.306c.318-.181.364-.451.1-.6l-6.576-3.8a1.169,1.169,0,0,0-1.045.059l-7.455,4.3c-.318.183-.363.452-.1.6Zm-21.8,12.583a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.316-.181.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.059l-7.456,4.3c-.316.183-.363.452-.1.6ZM101.58,318.9a1.162,1.162,0,0,0,1.044-.061l7.456-4.3c.316-.181.364-.452.1-.6l-6.578-3.8a1.171,1.171,0,0,0-1.044.06l-7.456,4.3c-.316.183-.363.452-.1.6Zm59.23-34.2a1.162,1.162,0,0,0,1.044-.061l7.456-4.3c.316-.181.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.059l-7.456,4.3c-.316.183-.363.452-.1.6Zm-21.8,12.583a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.318-.182.363-.452.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.059l-7.456,4.3c-.316.183-.363.452-.1.6ZM132.143,354.6a1.162,1.162,0,0,0-1.044.06l-11.471,6.622c-.318.183-.363.454-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.059L138.616,359c.316-.183.363-.452.1-.6Zm-8.768-48.286a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.318-.184.363-.454.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.316.183-.363.452-.1.6Zm-10.9,6.292a1.17,1.17,0,0,0,1.044-.059l7.456-4.306c.316-.183.363-.452.1-.6l-6.578-3.8a1.161,1.161,0,0,0-1.044.059l-7.456,4.3c-.316.183-.363.452-.1.6Zm221.556-74.567a1.166,1.166,0,0,0-1.044.061l-18.353,10.6c-.318.183-.364.454-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.059l18.353-10.6c.316-.183.363-.452.1-.6Zm-24.089,13.909a1.166,1.166,0,0,0-1.044.059l-7.456,4.3c-.318.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06l7.456-4.3c.316-.181.363-.452.1-.6ZM162.113,333.491l7.456-4.305c.316-.183.363-.452.1-.6l-6.578-3.8a1.163,1.163,0,0,0-1.042.06l-7.456,4.3c-.318.183-.364.451-.1.6l6.578,3.8a1.167,1.167,0,0,0,1.044-.061m126.037-68.961a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06l7.456-4.3c.318-.183.363-.452.1-.6Zm56.782-32.783a1.17,1.17,0,0,0-1.044.059l-7.456,4.306c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.059l7.456-4.3c.316-.183.363-.452.1-.6Zm17.474-2.494-16.921-9.769a1.163,1.163,0,0,0-1.042.059l-7.456,4.3c-.318.183-.364.454-.1.6l16.921,9.77a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.316-.183.363-.452.1-.6M247.428,288.041a1.166,1.166,0,0,0-1.044.061l-9.178,5.3c-.316.183-.363.452-.1.6l6.576,3.8a1.162,1.162,0,0,0,1.044-.06l9.176-5.3c.318-.183.364-.454.1-.6Zm27.53-15.894a1.165,1.165,0,0,0-1.044.059l-11.471,6.623c-.316.183-.363.452-.1.6l6.578,3.8a1.167,1.167,0,0,0,1.044-.061l11.471-6.623c.316-.181.363-.451.1-.6Zm-52.767,30.465a1.166,1.166,0,0,0-1.044.06L159.778,338.1c-.318.183-.364.452-.1.6l6.578,3.8a1.163,1.163,0,0,0,1.042-.059l61.37-35.432c.318-.183.363-.452.1-.6ZM157.379,340.03a1.168,1.168,0,0,0-1.042.059l-9.178,5.3c-.318.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06l9.178-5.3c.316-.183.362-.452.1-.6Zm77.43-44.7a1.162,1.162,0,0,0-1.044.059l-9.176,5.3c-.316.184-.363.454-.1.6l6.578,3.8a1.162,1.162,0,0,0,1.044-.059l9.176-5.3c.318-.183.363-.451.1-.6Zm-90.047,51.988a1.167,1.167,0,0,0-1.044.06l-9.176,5.3c-.318.184-.363.454-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06l9.176-5.3c.316-.184.363-.454.1-.6Zm115.285-66.558a1.166,1.166,0,0,0-1.044.059l-9.178,5.3c-.315.183-.363.452-.1.6l6.578,3.8a1.163,1.163,0,0,0,1.042-.059l9.178-5.3c.316-.182.363-.452.1-.6Zm39-22.519A1.166,1.166,0,0,0,298,258.3l-7.456,4.3c-.318.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06l7.456-4.3c.316-.183.363-.452.1-.6Zm23.66-17.467,7.456-4.3c.316-.184.363-.454.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.059l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.162,1.162,0,0,0,1.044-.061m-44.776,1.965,7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.162,1.162,0,0,0-1.044.061l-7.456,4.3c-.318.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.059m-28.639,40.422,21.8-12.583c.316-.183.363-.452.1-.6l-6.576-3.8a1.171,1.171,0,0,0-1.044.06l-21.8,12.583c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.061m61.474-36.034a1.166,1.166,0,0,0,1.044-.06l7.456-4.3c.318-.184.363-.454.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.059l-7.456,4.3c-.316.183-.363.454-.1.6Zm-9.3-6.032,7.456-4.3c.316-.183.364-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.061l-7.455,4.3c-.318.183-.364.452-.1.6l6.578,3.8a1.163,1.163,0,0,0,1.042-.06m-63.071,48.358,7.456-4.3c.318-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06m48.282-28.417a1.171,1.171,0,0,0,1.044-.06l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.316.184-.363.454-.1.6Zm-102.77,59.876,7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.061l-7.456,4.3c-.316.183-.363.452-.1.6l6.578,3.8a1.171,1.171,0,0,0,1.044-.06m10.9-6.292,7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.316.181-.363.452-.1.6l6.578,3.8a1.166,1.166,0,0,0,1.044-.059M173.01,327.2l7.455-4.3c.318-.183.364-.452.1-.6l-6.578-3.8a1.166,1.166,0,0,0-1.044.06l-7.456,4.3c-.316.182-.363.452-.1.6l6.576,3.8a1.173,1.173,0,0,0,1.045-.06m43.59-25.167,7.455-4.3c.318-.183.364-.452.1-.6l-6.576-3.8a1.169,1.169,0,0,0-1.045.06l-7.456,4.3c-.316.183-.362.452-.1.6l6.578,3.8a1.167,1.167,0,0,0,1.044-.061m-10.9,6.292,7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.162,1.162,0,0,0-1.044.061l-7.455,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.17,1.17,0,0,0,1.044-.06M227.5,295.74l7.456-4.3c.316-.183.363-.452.1-.6l-6.578-3.8a1.171,1.171,0,0,0-1.044.06l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.06m60.217-87.094a1.166,1.166,0,0,0,1.044-.059l7.456-4.3c.316-.183.363-.452.1-.6l-1.75-1.012a1.166,1.166,0,0,0-1.044.061l-7.456,4.3c-.316.183-.363.452-.1.6Zm-54.368,34.175a1.163,1.163,0,0,0,1.042-.059l7.456-4.3c.318-.183.364-.452.1-.6l-6.578-3.8a1.159,1.159,0,0,0-1.042.059l-7.456,4.3c-.318.183-.364.452-.1.6ZM255.14,230.24a1.166,1.166,0,0,0,1.044-.061l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.061l-7.456,4.3c-.316.183-.363.452-.1.6Zm-35.1,20.265a1.166,1.166,0,0,0,1.044-.059l7.458-4.3c.316-.183.362-.452.1-.6l-6.578-3.8a1.162,1.162,0,0,0-1.044.06l-7.455,4.3c-.318.183-.364.452-.1.6Zm24.206-13.973a1.167,1.167,0,0,0,1.044-.061l7.455-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.161,1.161,0,0,0-1.044.059l-7.455,4.3c-.318.183-.364.452-.1.6Zm-46,26.557a1.162,1.162,0,0,0,1.044-.061l7.456-4.3c.316-.183.363-.454.1-.6l-6.576-3.8a1.166,1.166,0,0,0-1.044.059l-7.456,4.3c-.318.184-.363.452-.1.6Zm10.9-6.292a1.166,1.166,0,0,0,1.044-.059l7.456-4.3c.316-.183.363-.452.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.059l-7.456,4.3c-.318.183-.363.452-.1.6Zm56.777-35.567a1.17,1.17,0,0,0,1.044-.059l7.456-4.306c.318-.181.363-.451.1-.6l-1.752-1.012a1.163,1.163,0,0,0-1.042.061l-7.456,4.3c-.318.183-.364.452-.1.6Zm32.693-18.875a1.166,1.166,0,0,0,1.044-.059l7.456-4.3c.316-.183.363-.452.1-.6l-1.75-1.012a1.17,1.17,0,0,0-1.044.061l-7.456,4.3c-.316.183-.363.452-.1.6Zm13.817,7.977a1.166,1.166,0,0,0,1.044-.061l7.455-4.3c.318-.184.364-.454.1-.6l-6.578-3.8a1.159,1.159,0,0,0-1.042.059l-7.458,4.3c-.316.183-.363.452-.1.6ZM333.6,234.48l7.456-4.306c.316-.182.363-.451.1-.6l-6.576-3.8a1.17,1.17,0,0,0-1.044.059l-7.456,4.3c-.316.183-.363.452-.1.6l6.576,3.8a1.166,1.166,0,0,0,1.044-.059m-56.789-19.542a1.165,1.165,0,0,0,1.044-.059l7.456-4.3c.318-.183.363-.454.1-.6l-1.75-1.011a1.161,1.161,0,0,0-1.044.059l-7.456,4.3c-.316.183-.363.452-.1.6Zm-89.47,54.442a1.165,1.165,0,0,0,1.044-.059l7.456-4.3c.316-.184.363-.454.1-.6l-6.576-3.8a1.165,1.165,0,0,0-1.044.059l-7.456,4.306c-.316.181-.363.451-.1.6Z",
    transform: "translate(24.963 73.593)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4614",
    "data-name": "Trac\\xE9 4614",
    d: "M178.68,301.978l1.529.881L220.816,326.3l72.215-41.695,1.5-.857L252.4,259.428Z",
    transform: "translate(66.994 97.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4615",
    "data-name": "Trac\\xE9 4615",
    d: "M291.757,284.31,251.8,261.256l-71.517,41.307,39.934,23.052Z",
    transform: "translate(67.594 97.955)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4616",
    "data-name": "Trac\\xE9 4616",
    d: "M28.127,386.2c-3.271-2.307-3.278-5.382-3.278-9.649V175.307a14.789,14.789,0,0,1,6.692-11.591L288.1,15.591c3.7-2.134,7.1-.587,10.572,1.415s5.679,3.729,5.679,8V226.248a14.793,14.793,0,0,1-6.693,11.591L41.1,385.962c-5.595,3.771-9.407,2.751-12.968.239",
    transform: "translate(9.316 5.461)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4617",
    "data-name": "Trac\\xE9 4617",
    d: "M41.1,343.927c-5.593,3.766-9.414,2.747-12.968.232-3.267-2.3-3.278-5.381-3.278-9.647V133.272a13.774,13.774,0,0,1,1.948-6.589l9.559,5.559a13.581,13.581,0,0,0-1.95,6.568V340.062c0,4.264,2.99,5.992,6.689,3.865",
    transform: "translate(9.317 47.498)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4618",
    "data-name": "Trac\\xE9 4618",
    d: "M31.8,179.309V380.555c0,4.268,3,6,6.692,3.864L295.05,236.3a14.791,14.791,0,0,0,6.692-11.591V23.459c0-4.268-3-6-6.692-3.864L38.491,167.719A14.791,14.791,0,0,0,31.8,179.309",
    transform: "translate(11.923 7.004)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4619",
    "data-name": "Trac\\xE9 4619",
    d: "M40.379,171.774,287.734,29c2.218-1.28,4.015-.242,4.015,2.318v183.4a8.877,8.877,0,0,1-4.015,6.956L40.379,364.443c-2.218,1.28-4.015.242-4.015-2.319V178.729a8.874,8.874,0,0,1,4.015-6.954",
    transform: "translate(13.634 10.668)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4620",
    "data-name": "Trac\\xE9 4620",
    d: "M40.379,171.4a8.874,8.874,0,0,0-4.015,6.954v182.2l245.9-141.931a8.874,8.874,0,0,0,4.015-6.954V29.462Z",
    transform: "translate(13.634 11.046)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4632",
    "data-name": "Groupe 4632",
    transform: "translate(49.998 40.508)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4631",
    "data-name": "Groupe 4631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4630",
    "data-name": "Groupe 4630",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4621",
    "data-name": "Trac\\xE9 4621",
    d: "M40.379,171.4a8.874,8.874,0,0,0-4.015,6.954v182.2l245.9-141.931a8.874,8.874,0,0,0,4.015-6.954V29.462Z",
    transform: "translate(-36.363 -29.462)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4622",
    "data-name": "Trac\\xE9 4622",
    d: "M50.322,327.838c-1.283,0-2.049-1.046-2.049-2.8V183.28L270.909,54.741V195.876a9.749,9.749,0,0,1-4.407,7.632L52.139,327.272a3.758,3.758,0,0,1-1.818.566",
    transform: "translate(18.099 20.525)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4623",
    "data-name": "Trac\\xE9 4623",
    d: "M270.517,55.931v140.2a9.3,9.3,0,0,1-4.136,7.165L52.017,327.059a3.223,3.223,0,0,1-1.548.494c-1.361,0-1.508-1.58-1.508-2.258V183.847Zm1.079-1.87L47.881,183.223V325.3c0,2.115,1.053,3.338,2.588,3.338a4.246,4.246,0,0,0,2.089-.639L266.921,204.23a10.337,10.337,0,0,0,4.676-8.1Z",
    transform: "translate(17.952 20.27)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4624",
    "data-name": "Trac\\xE9 4624",
    d: "M47.88,183.223v20.246L271.594,74.309V54.06Z",
    transform: "translate(17.952 20.269)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4625",
    "data-name": "Trac\\xE9 4625",
    d: "M149.973,106.325v4.359c0,.891.631,1.255,1.4.81l68.781-39.711v-7.6L151.375,103.9a3.112,3.112,0,0,0-1.4,2.429",
    transform: "translate(56.231 24.065)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4626",
    "data-name": "Trac\\xE9 4626",
    d: "M208.39,61.14c.774-.447,1.4-.085,1.4.81v4.359a3.1,3.1,0,0,1-1.4,2.43l-7.371,4.255V65.4Z",
    transform: "translate(75.37 22.852)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4627",
    "data-name": "Trac\\xE9 4627",
    d: "M207.152,66.31l-.822-.256a4.568,4.568,0,0,0,.132-1.06,1.938,1.938,0,0,0-.749-1.756,1.164,1.164,0,0,0-1.2.059,4.2,4.2,0,0,0-1.643,3.418,1.937,1.937,0,0,0,.749,1.756,1.033,1.033,0,0,0,.521.14,1.371,1.371,0,0,0,.678-.2,3.464,3.464,0,0,0,1.328-1.778l.824.257a.3.3,0,0,0,.091.014.305.305,0,0,0,.091-.6m-2.638,1.576a.567.567,0,0,1-.589.058,1.429,1.429,0,0,1-.444-1.228,3.662,3.662,0,0,1,1.338-2.89.753.753,0,0,1,.368-.117.422.422,0,0,1,.22.059,1.427,1.427,0,0,1,.444,1.226,3.668,3.668,0,0,1-1.338,2.892",
    transform: "translate(76.064 23.658)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4628",
    "data-name": "Trac\\xE9 4628",
    d: "M47.88,177.008a10.339,10.339,0,0,1,4.676-8.1L266.919,45.146c2.583-1.49,4.676-.282,4.676,2.7v9.8L47.88,186.8Z",
    transform: "translate(17.952 16.688)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4629",
    "data-name": "Trac\\xE9 4629",
    d: "M192.046,57.817a4.849,4.849,0,0,0-2.193,3.8c0,1.4.982,1.966,2.193,1.268a4.849,4.849,0,0,0,2.193-3.8c0-1.4-.982-1.966-2.193-1.266",
    transform: "translate(71.183 21.565)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4630",
    "data-name": "Trac\\xE9 4630",
    d: "M197.629,54.6a4.849,4.849,0,0,0-2.193,3.8c0,1.4.982,1.966,2.193,1.268a4.849,4.849,0,0,0,2.193-3.8c0-1.4-.982-1.966-2.193-1.266",
    transform: "translate(73.276 20.36)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4631",
    "data-name": "Trac\\xE9 4631",
    d: "M203.211,51.387a4.849,4.849,0,0,0-2.193,3.8c0,1.4.982,1.966,2.193,1.266a4.845,4.845,0,0,0,2.193-3.8c0-1.4-.982-1.966-2.193-1.266",
    transform: "translate(75.369 19.154)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4632",
    "data-name": "Trac\\xE9 4632",
    d: "M50.322,294c-1.283,0-2.049-1.046-2.049-2.8V169.69l42.789-24.7V270.963L52.139,293.435a3.758,3.758,0,0,1-1.818.566",
    transform: "translate(18.099 54.361)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4633",
    "data-name": "Trac\\xE9 4633",
    d: "M90.669,146.176v124.73L52.016,293.223a3.218,3.218,0,0,1-1.548.494c-1.361,0-1.507-1.58-1.507-2.259v-121.2Zm1.079-1.87L47.88,169.634V291.457c0,2.116,1.053,3.338,2.588,3.338a4.243,4.243,0,0,0,2.089-.638l39.193-22.629Z",
    transform: "translate(17.952 54.106)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4634",
    "data-name": "Trac\\xE9 4634",
    d: "M58.856,167.34l20.986-12.13c.775-.448,1.4-.085,1.4.808v1.826a3.1,3.1,0,0,1-1.4,2.431l-20.987,12.13c-.774.447-1.4.085-1.4-.81v-1.825a3.1,3.1,0,0,1,1.4-2.431",
    transform: "translate(21.541 58.122)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4635",
    "data-name": "Trac\\xE9 4635",
    d: "M55.458,167.863v1.826a3.1,3.1,0,0,1-1.4,2.429l-1.581.913c-.774.447-1.4.084-1.4-.81V170.4a3.1,3.1,0,0,1,1.4-2.43l1.581-.913c.774-.447,1.4-.085,1.4.81",
    transform: "translate(19.149 62.563)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4636",
    "data-name": "Trac\\xE9 4636",
    d: "M58.856,174.681l20.986-12.13c.775-.448,1.4-.085,1.4.809v1.826a3.1,3.1,0,0,1-1.4,2.431l-20.987,12.13c-.774.448-1.4.085-1.4-.81v-1.825a3.1,3.1,0,0,1,1.4-2.431",
    transform: "translate(21.541 60.875)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4637",
    "data-name": "Trac\\xE9 4637",
    d: "M55.458,175.2v1.826a3.1,3.1,0,0,1-1.4,2.429l-1.581.913c-.774.447-1.4.084-1.4-.81v-1.826a3.1,3.1,0,0,1,1.4-2.43l1.581-.913c.774-.447,1.4-.085,1.4.81",
    transform: "translate(19.149 65.315)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4638",
    "data-name": "Trac\\xE9 4638",
    d: "M58.856,182.021l20.986-12.13c.775-.448,1.4-.085,1.4.808v1.826a3.1,3.1,0,0,1-1.4,2.431l-20.987,12.13c-.774.447-1.4.085-1.4-.81v-1.825a3.105,3.105,0,0,1,1.4-2.431",
    transform: "translate(21.541 63.627)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4639",
    "data-name": "Trac\\xE9 4639",
    d: "M55.458,182.544v1.826a3.1,3.1,0,0,1-1.4,2.43l-1.581.913c-.774.447-1.4.084-1.4-.81v-1.826a3.1,3.1,0,0,1,1.4-2.43l1.581-.913c.774-.447,1.4-.085,1.4.81",
    transform: "translate(19.149 68.067)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4640",
    "data-name": "Trac\\xE9 4640",
    d: "M58.856,206.363l20.986-12.13c.775-.448,1.4-.085,1.4.809v1.826a3.1,3.1,0,0,1-1.4,2.431l-20.987,12.13c-.774.448-1.4.085-1.4-.81v-1.825a3.1,3.1,0,0,1,1.4-2.431",
    transform: "translate(21.541 72.754)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4641",
    "data-name": "Trac\\xE9 4641",
    d: "M55.458,206.885v1.826a3.1,3.1,0,0,1-1.4,2.43l-1.581.913c-.774.447-1.4.084-1.4-.81v-1.826a3.1,3.1,0,0,1,1.4-2.43l1.581-.913c.774-.447,1.4-.085,1.4.81",
    transform: "translate(19.149 77.194)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4642",
    "data-name": "Trac\\xE9 4642",
    d: "M58.856,212.864l20.986-12.13c.775-.448,1.4-.085,1.4.808v1.826a3.1,3.1,0,0,1-1.4,2.431l-20.987,12.13c-.774.448-1.4.085-1.4-.81V215.3a3.1,3.1,0,0,1,1.4-2.431",
    transform: "translate(21.541 75.191)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4643",
    "data-name": "Trac\\xE9 4643",
    d: "M55.458,213.387v1.826a3.1,3.1,0,0,1-1.4,2.43l-1.581.913c-.774.447-1.4.084-1.4-.81V215.92a3.1,3.1,0,0,1,1.4-2.43l1.581-.913c.774-.447,1.4-.085,1.4.81",
    transform: "translate(19.149 79.632)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4644",
    "data-name": "Trac\\xE9 4644",
    d: "M58.856,219.366l20.986-12.13c.775-.448,1.4-.085,1.4.809v1.826a3.1,3.1,0,0,1-1.4,2.431l-20.987,12.13c-.774.448-1.4.085-1.4-.81V221.8a3.105,3.105,0,0,1,1.4-2.431",
    transform: "translate(21.541 77.629)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4645",
    "data-name": "Trac\\xE9 4645",
    d: "M55.458,219.888v1.826a3.1,3.1,0,0,1-1.4,2.43l-1.581.913c-.774.447-1.4.084-1.4-.81v-1.826a3.1,3.1,0,0,1,1.4-2.43l1.581-.913c.774-.447,1.4-.085,1.4.81",
    transform: "translate(19.149 82.069)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4646",
    "data-name": "Trac\\xE9 4646",
    d: "M57.453,186.673v3.149l2.727-3.149Z",
    transform: "translate(21.541 69.991)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4647",
    "data-name": "Trac\\xE9 4647",
    d: "M60.643,189.432c0,.584.419.818.936.52l17.532-10.1a2.056,2.056,0,0,0,.936-1.611c0-.593-.419-.831-.936-.534L61.578,187.835a2.05,2.05,0,0,0-.935,1.6",
    transform: "translate(22.737 66.583)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4648",
    "data-name": "Trac\\xE9 4648",
    d: "M57.453,190.356V193.5l2.727-3.149Z",
    transform: "translate(21.541 71.372)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4649",
    "data-name": "Trac\\xE9 4649",
    d: "M60.643,193.115c0,.584.419.817.936.52l17.532-10.1a2.058,2.058,0,0,0,.936-1.611c0-.593-.419-.832-.936-.533L61.578,191.518a2.048,2.048,0,0,0-.935,1.6",
    transform: "translate(22.737 67.963)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4650",
    "data-name": "Trac\\xE9 4650",
    d: "M57.453,194.039v3.149l2.727-3.149Z",
    transform: "translate(21.541 72.753)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4651",
    "data-name": "Trac\\xE9 4651",
    d: "M60.643,196.8c0,.584.419.817.936.52l17.532-10.1a2.058,2.058,0,0,0,.936-1.611c0-.593-.419-.832-.936-.533L61.578,195.2a2.048,2.048,0,0,0-.935,1.6",
    transform: "translate(22.737 69.344)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4652",
    "data-name": "Trac\\xE9 4652",
    d: "M57.453,197.722v3.149l2.727-3.149Z",
    transform: "translate(21.541 74.133)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4653",
    "data-name": "Trac\\xE9 4653",
    d: "M60.643,200.481c0,.584.419.817.936.52l17.532-10.1a2.056,2.056,0,0,0,.936-1.611c0-.593-.419-.832-.936-.533L61.578,198.884a2.048,2.048,0,0,0-.935,1.6",
    transform: "translate(22.737 70.725)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4654",
    "data-name": "Trac\\xE9 4654",
    d: "M89.357,154.641v26.392c0,1.1.775,1.552,1.731,1l29.021-16.755a3.827,3.827,0,0,0,1.732-3v-21.7c0-1.1-.775-1.552-1.732-1l-16.84,9.722c-.956.553-1.731.1-1.731-1v-.689c0-1.1-.774-1.552-1.731-1l-8.718,5.034a3.827,3.827,0,0,0-1.731,3",
    transform: "translate(33.503 52.243)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4655",
    "data-name": "Trac\\xE9 4655",
    d: "M93.506,177.374v1.69c0,.829.58,1.165,1.3.751l21.768-12.568a2.875,2.875,0,0,0,1.3-2.249v-1.69c0-.829-.582-1.165-1.3-.751L94.805,175.125a2.866,2.866,0,0,0-1.3,2.249",
    transform: "translate(35.059 60.882)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4656",
    "data-name": "Trac\\xE9 4656",
    d: "M118.7,137.79v26.392c0,1.1.775,1.552,1.731,1l29.022-16.755a3.829,3.829,0,0,0,1.731-3v-21.7c0-1.1-.775-1.552-1.731-1l-16.842,9.722c-.956.553-1.731.1-1.731-1v-.69c0-1.1-.774-1.551-1.731-1l-8.718,5.034a3.827,3.827,0,0,0-1.731,3",
    transform: "translate(44.506 45.925)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4657",
    "data-name": "Trac\\xE9 4657",
    d: "M122.851,160.523v1.69c0,.829.582,1.165,1.3.751L145.918,150.4a2.871,2.871,0,0,0,1.3-2.249v-1.69c0-.829-.58-1.165-1.3-.751l-21.769,12.568a2.873,2.873,0,0,0-1.3,2.249",
    transform: "translate(46.062 54.564)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4658",
    "data-name": "Trac\\xE9 4658",
    d: "M89.357,193.2V219.6c0,1.1.775,1.552,1.731,1l29.021-16.755a3.829,3.829,0,0,0,1.732-3v-21.7c0-1.1-.775-1.552-1.732-1l-16.84,9.722c-.956.553-1.731.1-1.731-1v-.69c0-1.1-.774-1.551-1.731-1l-8.718,5.035a3.827,3.827,0,0,0-1.731,3",
    transform: "translate(33.503 66.702)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4659",
    "data-name": "Trac\\xE9 4659",
    d: "M93.506,215.936v1.69c0,.829.58,1.165,1.3.751l21.768-12.57a2.87,2.87,0,0,0,1.3-2.248v-1.69c0-.829-.582-1.165-1.3-.751L94.805,213.687a2.867,2.867,0,0,0-1.3,2.249",
    transform: "translate(35.059 75.341)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4660",
    "data-name": "Trac\\xE9 4660",
    d: "M118.7,176.353v26.392c0,1.1.775,1.552,1.731,1l29.022-16.755a3.832,3.832,0,0,0,1.731-3v-21.7c0-1.1-.775-1.552-1.731-1l-16.842,9.722c-.956.553-1.731.1-1.731-1v-.69c0-1.1-.774-1.551-1.731-1l-8.718,5.035a3.827,3.827,0,0,0-1.731,3",
    transform: "translate(44.506 60.384)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4661",
    "data-name": "Trac\\xE9 4661",
    d: "M122.851,199.085v1.69c0,.829.582,1.165,1.3.751l21.769-12.568a2.871,2.871,0,0,0,1.3-2.249v-1.69c0-.829-.58-1.165-1.3-.751l-21.769,12.568a2.873,2.873,0,0,0-1.3,2.249",
    transform: "translate(46.062 69.022)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4662",
    "data-name": "Trac\\xE9 4662",
    d: "M148.391,120.013v26.392c0,1.1.775,1.552,1.731,1l29.022-16.755a3.829,3.829,0,0,0,1.731-3v-21.7c0-1.1-.776-1.552-1.731-1L162.3,114.669c-.956.553-1.731.1-1.731-1v-.689c0-1.1-.774-1.552-1.731-1l-8.718,5.034a3.827,3.827,0,0,0-1.731,3",
    transform: "translate(55.638 39.26)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4663",
    "data-name": "Trac\\xE9 4663",
    d: "M152.2,143.672v1.69c0,.829.582,1.165,1.3.751l21.768-12.568a2.872,2.872,0,0,0,1.3-2.249v-1.69c0-.829-.582-1.165-1.3-.751L153.5,141.423a2.87,2.87,0,0,0-1.3,2.249",
    transform: "translate(57.064 48.246)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4664",
    "data-name": "Trac\\xE9 4664",
    d: "M177.393,104.088v26.393c0,1.1.775,1.552,1.731,1l29.022-16.755a3.831,3.831,0,0,0,1.731-3v-21.7c0-1.1-.775-1.552-1.731-1L191.3,98.745c-.956.553-1.731.1-1.731-1v-.689c0-1.105-.774-1.552-1.731-1l-8.718,5.032a3.829,3.829,0,0,0-1.731,3",
    transform: "translate(66.511 33.289)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4665",
    "data-name": "Trac\\xE9 4665",
    d: "M181.541,126.821v1.69c0,.829.582,1.165,1.3.751l21.769-12.568a2.871,2.871,0,0,0,1.3-2.249v-1.69c0-.829-.58-1.165-1.3-.751l-21.769,12.568a2.873,2.873,0,0,0-1.3,2.249",
    transform: "translate(68.067 41.928)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4666",
    "data-name": "Trac\\xE9 4666",
    d: "M152.2,182.22v1.69c0,.829.582,1.165,1.3.751l21.768-12.568a2.873,2.873,0,0,0,1.3-2.249v-1.69c0-.829-.582-1.165-1.3-.751L153.5,179.971a2.87,2.87,0,0,0-1.3,2.249",
    transform: "translate(57.064 62.699)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4667",
    "data-name": "Trac\\xE9 4667",
    d: "M153.1,154.777l22.578-13.036c1.034-.6,1.871-.113,1.871,1.081v26.066a4.134,4.134,0,0,1-1.871,3.241L153.1,185.165c-1.033.6-1.871.113-1.871-1.079V158.017a4.138,4.138,0,0,1,1.871-3.239",
    transform: "translate(56.703 53.049)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4668",
    "data-name": "Trac\\xE9 4668",
    d: "M153.1,154.777l22.578-13.036c1.034-.6,1.871-.113,1.871,1.081v26.066a4.134,4.134,0,0,1-1.871,3.241L153.1,185.165c-1.033.6-1.871.113-1.871-1.079V158.017A4.138,4.138,0,0,1,153.1,154.777Z",
    transform: "translate(56.703 53.049)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 0.785
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4669",
    "data-name": "Trac\\xE9 4669",
    d: "M172.828,144.3l-5.032,2.905a4.136,4.136,0,0,0-1.87,3.241v5.811c0,1.192.837,1.676,1.87,1.079l5.032-2.905a4.136,4.136,0,0,0,1.87-3.239v-5.812c0-1.192-.837-1.676-1.87-1.079",
    transform: "translate(62.212 54.009)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4670",
    "data-name": "Trac\\xE9 4670",
    d: "M154.1,155.01l11.31-6.508c.517-.3.935-.055.935.542v.36a2.063,2.063,0,0,1-.935,1.618l-11.312,6.52c-.516.3-.935.055-.935-.54v-.374a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(57.427 55.632)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4671",
    "data-name": "Trac\\xE9 4671",
    d: "M154.1,158.689l11.31-6.508c.517-.3.935-.055.935.542v.36a2.062,2.062,0,0,1-.935,1.618l-11.312,6.52c-.516.3-.935.055-.935-.542v-.373a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(57.427 57.011)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4672",
    "data-name": "Trac\\xE9 4672",
    d: "M154.1,162.368l11.31-6.508c.517-.3.935-.055.935.542v.36a2.063,2.063,0,0,1-.935,1.618L154.1,164.9c-.516.3-.935.055-.935-.542v-.373a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(57.427 58.391)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4673",
    "data-name": "Trac\\xE9 4673",
    d: "M154.1,167.227l18.79-10.833c.517-.3.936-.055.936.542v.36a2.069,2.069,0,0,1-.935,1.62L154.1,169.759c-.516.3-.935.055-.935-.542v-.373a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(57.427 58.59)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4674",
    "data-name": "Trac\\xE9 4674",
    d: "M154.1,170.906l18.79-10.833c.517-.3.936-.054.936.542v.36a2.067,2.067,0,0,1-.935,1.62L154.1,173.438c-.516.3-.935.055-.935-.54v-.374a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(57.427 59.97)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4675",
    "data-name": "Trac\\xE9 4675",
    d: "M180.909,165.643v1.69c0,.829.582,1.165,1.3.751l21.769-12.568a2.871,2.871,0,0,0,1.3-2.249v-1.69c0-.829-.58-1.165-1.3-.751l-21.769,12.568a2.873,2.873,0,0,0-1.3,2.249",
    transform: "translate(67.83 56.484)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4676",
    "data-name": "Trac\\xE9 4676",
    d: "M181.816,138.2l22.578-13.034c1.034-.6,1.871-.114,1.871,1.079v26.067a4.134,4.134,0,0,1-1.871,3.239l-22.578,13.036c-1.033.6-1.87.113-1.87-1.079V141.44a4.136,4.136,0,0,1,1.87-3.239",
    transform: "translate(67.469 46.834)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4677",
    "data-name": "Trac\\xE9 4677",
    d: "M181.816,138.2l22.578-13.034c1.034-.6,1.871-.114,1.871,1.079v26.067a4.134,4.134,0,0,1-1.871,3.239l-22.578,13.036c-1.033.6-1.87.113-1.87-1.079V141.44A4.136,4.136,0,0,1,181.816,138.2Z",
    transform: "translate(67.469 46.834)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 0.785
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4678",
    "data-name": "Trac\\xE9 4678",
    d: "M201.543,127.726l-5.034,2.905a4.136,4.136,0,0,0-1.87,3.241v5.811c0,1.192.837,1.676,1.87,1.079l5.034-2.905a4.138,4.138,0,0,0,1.869-3.239v-5.812c0-1.192-.837-1.676-1.869-1.079",
    transform: "translate(72.978 47.793)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4679",
    "data-name": "Trac\\xE9 4679",
    d: "M182.813,138.433l11.31-6.508c.517-.3.935-.055.935.542v.36a2.063,2.063,0,0,1-.935,1.618l-11.312,6.52c-.516.3-.935.055-.935-.54v-.374a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(68.193 49.416)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4680",
    "data-name": "Trac\\xE9 4680",
    d: "M182.813,142.112l11.31-6.508c.517-.3.935-.055.935.542v.36a2.063,2.063,0,0,1-.935,1.618l-11.312,6.52c-.516.3-.935.055-.935-.54v-.374a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(68.193 50.796)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4681",
    "data-name": "Trac\\xE9 4681",
    d: "M182.813,145.791l11.31-6.506c.517-.3.935-.055.935.539v.362a2.06,2.06,0,0,1-.935,1.618l-11.312,6.52c-.516.3-.935.056-.935-.54v-.374a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(68.193 52.175)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4682",
    "data-name": "Trac\\xE9 4682",
    d: "M182.813,150.651l18.79-10.833c.517-.3.936-.055.936.542v.36a2.069,2.069,0,0,1-.935,1.62l-18.793,10.844c-.516.3-.935.055-.935-.542v-.373a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(68.193 52.375)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4683",
    "data-name": "Trac\\xE9 4683",
    d: "M182.813,154.33,201.6,143.5c.517-.3.936-.055.936.542v.36a2.069,2.069,0,0,1-.935,1.62l-18.793,10.844c-.516.3-.935.055-.935-.542v-.373a2.062,2.062,0,0,1,.936-1.618",
    transform: "translate(68.193 53.755)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4660",
    "data-name": "Groupe 4660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4659",
    "data-name": "Groupe 4659",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4684",
    "data-name": "Trac\\xE9 4684",
    d: "M350.566,271.359v12.792L128.911,412.107v.012l-6.821,3.931c-2.876-1.657-5.214-5.882-5.214-9.428V191.108a2.322,2.322,0,0,1,.32-1.092,2.379,2.379,0,0,1,.8-.836l50.518-29.169c.616-.346,4.213,1.156,4.8,1.517l.385.217a3.826,3.826,0,0,1,.885.784,3.119,3.119,0,0,1,.642,1.067l4.573,13.2L344.233,78.848a2.534,2.534,0,0,1,2.159-.038l3.057,1.772a2.3,2.3,0,0,1,.784.822,2.22,2.22,0,0,1,.322,1.1v45.006Z",
    transform: "translate(43.821 29.465)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4637",
    "data-name": "Groupe 4637",
    transform: "translate(160.697 108.052)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4636",
    "data-name": "Groupe 4636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4635",
    "data-name": "Groupe 4635",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4685",
    "data-name": "Trac\\xE9 4685",
    d: "M350.566,271.359v12.792L128.911,412.107v.012l-6.821,3.931c-2.876-1.657-5.214-5.882-5.214-9.428V191.108a2.322,2.322,0,0,1,.32-1.092,2.379,2.379,0,0,1,.8-.836l50.518-29.169c.616-.346,4.213,1.156,4.8,1.517l.385.217a3.826,3.826,0,0,1,.885.784,3.119,3.119,0,0,1,.642,1.067l4.573,13.2L344.233,78.848a2.534,2.534,0,0,1,2.159-.038l3.057,1.772a2.3,2.3,0,0,1,.784.822,2.22,2.22,0,0,1,.322,1.1v45.006Z",
    transform: "translate(-116.876 -78.587)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4686",
    "data-name": "Trac\\xE9 4686",
    d: "M349.144,283.384l-228.476,131.9V192.061l52.5-30.3a3.127,3.127,0,0,1,.642,1.066l4.573,13.2.873,2.5,169.559-97.9a2.225,2.225,0,0,1,.322,1.105Z",
    transform: "translate(45.243 30.234)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4640",
    "data-name": "Groupe 4640",
    transform: "translate(165.912 110.87)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4639",
    "data-name": "Groupe 4639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4638",
    "data-name": "Groupe 4638",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4687",
    "data-name": "Trac\\xE9 4687",
    d: "M349.144,283.384l-228.476,131.9V192.061l52.5-30.3a3.127,3.127,0,0,1,.642,1.066l4.573,13.2.873,2.5,169.559-97.9a2.225,2.225,0,0,1,.322,1.105Z",
    transform: "translate(-120.669 -80.636)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4688",
    "data-name": "Trac\\xE9 4688",
    d: "M174.5,140.4l-52.5,30.3-4.893-2.813a2.379,2.379,0,0,1,.8-.836l50.517-29.169a2.409,2.409,0,0,1,2.2.014l2.992,1.721a3.832,3.832,0,0,1,.887.784",
    transform: "translate(43.909 51.598)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4643",
    "data-name": "Groupe 4643",
    transform: "translate(161.019 189.218)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4642",
    "data-name": "Groupe 4642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4641",
    "data-name": "Groupe 4641",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4689",
    "data-name": "Trac\\xE9 4689",
    d: "M174.5,140.4l-52.5,30.3-4.893-2.813a2.379,2.379,0,0,1,.8-.836l50.517-29.169a2.409,2.409,0,0,1,2.2.014l2.992,1.721a3.832,3.832,0,0,1,.887.784",
    transform: "translate(-117.11 -137.619)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4690",
    "data-name": "Trac\\xE9 4690",
    d: "M333.073,81.4,163.514,179.3l-.873-2.505L327.074,78.847a2.539,2.539,0,0,1,2.159-.038l3.057,1.774a2.315,2.315,0,0,1,.784.822",
    transform: "translate(60.98 29.465)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4646",
    "data-name": "Groupe 4646",
    transform: "translate(223.621 108.052)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4645",
    "data-name": "Groupe 4645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4644",
    "data-name": "Groupe 4644",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4691",
    "data-name": "Trac\\xE9 4691",
    d: "M333.073,81.4,163.514,179.3l-.873-2.505L327.074,78.847a2.539,2.539,0,0,1,2.159-.038l3.057,1.774a2.315,2.315,0,0,1,.784.822",
    transform: "translate(-162.641 -78.587)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4692",
    "data-name": "Trac\\xE9 4692",
    d: "M168.748,366.443a5.633,5.633,0,0,1-2.464-4.453V141.131a5.8,5.8,0,0,1,2.626-4.548L309.555,55.455a4.933,4.933,0,0,1,7.553,4.361V280.674a5.806,5.806,0,0,1-2.625,4.547L173.837,366.349a5.631,5.631,0,0,1-5.089.094",
    transform: "translate(62.346 20.546)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4693",
    "data-name": "Trac\\xE9 4693",
    d: "M172.493,365.492,313.14,284.364a5.8,5.8,0,0,0,2.626-4.547V58.959c0-1.675-1.176-2.354-2.626-1.517L172.492,138.571a5.8,5.8,0,0,0-2.626,4.548V363.976c0,1.675,1.176,2.354,2.626,1.517",
    transform: "translate(63.689 21.403)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4694",
    "data-name": "Trac\\xE9 4694",
    d: "M182.806,139.928,291.5,77.167c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009L182.8,146.2c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 28.814)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4695",
    "data-name": "Trac\\xE9 4695",
    d: "M182.806,151.312,291.5,88.551c1.279-.738,2.315-.14,2.315,1.335v.924A5.118,5.118,0,0,1,291.5,94.82L182.8,157.58c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 33.083)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4696",
    "data-name": "Trac\\xE9 4696",
    d: "M182.806,162.7,291.5,99.936c1.279-.738,2.315-.14,2.315,1.336v.923A5.118,5.118,0,0,1,291.5,106.2l-108.7,62.76c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 37.351)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4697",
    "data-name": "Trac\\xE9 4697",
    d: "M182.806,174.081,291.5,111.32c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009l-108.7,62.76c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 41.62)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4698",
    "data-name": "Trac\\xE9 4698",
    d: "M182.806,185.465,291.5,122.7c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009l-108.7,62.76c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 45.888)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4699",
    "data-name": "Trac\\xE9 4699",
    d: "M182.806,196.933,291.5,134.171c1.279-.737,2.315-.139,2.315,1.338v.921a5.114,5.114,0,0,1-2.315,4.009L182.8,203.2c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 50.188)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4700",
    "data-name": "Trac\\xE9 4700",
    d: "M182.806,208.317,291.5,145.556c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009l-108.7,62.76c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 54.456)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4701",
    "data-name": "Trac\\xE9 4701",
    d: "M182.806,219.7,291.5,156.941c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009L182.8,225.97c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 58.725)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4702",
    "data-name": "Trac\\xE9 4702",
    d: "M182.806,231.086,291.5,168.325c1.279-.738,2.315-.14,2.315,1.335v.924a5.113,5.113,0,0,1-2.315,4.008L182.8,237.354c-1.277.738-2.314.14-2.313-1.336V235.1a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 62.993)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4703",
    "data-name": "Trac\\xE9 4703",
    d: "M182.806,242.47,291.5,179.709c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009l-108.7,62.76c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 67.261)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4704",
    "data-name": "Trac\\xE9 4704",
    d: "M182.806,253.9,291.5,191.143c1.279-.737,2.315-.139,2.315,1.338v.923a5.118,5.118,0,0,1-2.315,4.009l-108.7,62.76c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 71.549)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4705",
    "data-name": "Trac\\xE9 4705",
    d: "M182.806,265.289,291.5,202.528c1.279-.738,2.315-.14,2.315,1.336v.923A5.118,5.118,0,0,1,291.5,208.8l-108.7,62.76c-1.277.738-2.314.14-2.313-1.336V269.3a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 75.817)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4706",
    "data-name": "Trac\\xE9 4706",
    d: "M182.806,276.674,291.5,213.913c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009l-108.7,62.76c-1.277.738-2.314.14-2.313-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(67.673 80.086)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4707",
    "data-name": "Trac\\xE9 4707",
    d: "M173.491,343.684a4.908,4.908,0,0,1-7.2-4.53V118.3a5.462,5.462,0,0,1,.762-2.595l4.932,2.846a5.293,5.293,0,0,0-.775,2.581V342c0,1.537,1,2.232,2.285,1.683",
    transform: "translate(62.348 43.383)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4708",
    "data-name": "Trac\\xE9 4708",
    d: "M183.109,374.735a5.629,5.629,0,0,1-2.464-4.455V149.422a5.8,5.8,0,0,1,2.626-4.547L323.916,63.747a4.933,4.933,0,0,1,7.553,4.361V288.966a5.806,5.806,0,0,1-2.625,4.547L188.2,374.641a5.631,5.631,0,0,1-5.089.093",
    transform: "translate(67.731 23.655)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4709",
    "data-name": "Trac\\xE9 4709",
    d: "M186.855,373.783,327.5,292.655a5.8,5.8,0,0,0,2.626-4.547V67.25c0-1.675-1.176-2.354-2.626-1.517L186.853,146.862a5.8,5.8,0,0,0-2.626,4.548V372.268c0,1.673,1.176,2.353,2.626,1.515",
    transform: "translate(69.074 24.512)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4710",
    "data-name": "Trac\\xE9 4710",
    d: "M197.167,148.219,305.86,85.457c1.279-.737,2.315-.139,2.315,1.338v.921a5.118,5.118,0,0,1-2.315,4.011l-108.694,62.76c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 31.923)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4711",
    "data-name": "Trac\\xE9 4711",
    d: "M197.167,159.6,305.86,96.843c1.279-.738,2.315-.14,2.315,1.336V99.1a5.118,5.118,0,0,1-2.315,4.009l-108.694,62.76c-1.279.738-2.315.14-2.314-1.336v-.923a5.121,5.121,0,0,1,2.315-4.011",
    transform: "translate(73.058 36.192)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4712",
    "data-name": "Trac\\xE9 4712",
    d: "M197.167,170.988,305.86,108.226c1.279-.737,2.315-.139,2.315,1.336v.924a5.118,5.118,0,0,1-2.315,4.009l-108.694,62.76c-1.279.738-2.315.14-2.314-1.336V175a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 40.46)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4713",
    "data-name": "Trac\\xE9 4713",
    d: "M197.167,182.372l108.693-62.76c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009L197.166,188.64c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 44.728)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4714",
    "data-name": "Trac\\xE9 4714",
    d: "M197.167,193.757,305.86,131c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009L197.166,200.025c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 48.997)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4715",
    "data-name": "Trac\\xE9 4715",
    d: "M197.167,205.224,305.86,142.462c1.279-.737,2.315-.139,2.315,1.338v.923a5.118,5.118,0,0,1-2.315,4.009l-108.694,62.76c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 53.296)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4716",
    "data-name": "Trac\\xE9 4716",
    d: "M197.167,216.609,305.86,153.847c1.279-.737,2.315-.139,2.315,1.338v.921a5.114,5.114,0,0,1-2.315,4.009L197.166,222.877c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 57.565)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4717",
    "data-name": "Trac\\xE9 4717",
    d: "M197.167,227.993l108.693-62.76c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009l-108.694,62.76c-1.279.738-2.315.14-2.314-1.336V232a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 61.833)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4718",
    "data-name": "Trac\\xE9 4718",
    d: "M197.167,239.377l108.693-62.76c1.279-.738,2.315-.14,2.315,1.335v.924a5.118,5.118,0,0,1-2.315,4.009l-108.694,62.76c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 66.102)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4719",
    "data-name": "Trac\\xE9 4719",
    d: "M197.167,250.762,305.86,188c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009L197.166,257.03c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 70.37)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4720",
    "data-name": "Trac\\xE9 4720",
    d: "M197.167,262.2,305.86,199.434c1.279-.737,2.315-.139,2.315,1.338v.923a5.118,5.118,0,0,1-2.315,4.009l-108.694,62.76c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 74.657)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4721",
    "data-name": "Trac\\xE9 4721",
    d: "M197.167,273.581,305.86,210.819c1.279-.737,2.315-.139,2.315,1.338v.921a5.114,5.114,0,0,1-2.315,4.009L197.166,279.849c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 78.926)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4722",
    "data-name": "Trac\\xE9 4722",
    d: "M197.167,284.965,305.86,222.2c1.279-.738,2.315-.14,2.315,1.336v.923a5.118,5.118,0,0,1-2.315,4.009l-108.694,62.76c-1.279.738-2.315.14-2.314-1.336v-.923a5.116,5.116,0,0,1,2.315-4.009",
    transform: "translate(73.058 83.194)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4723",
    "data-name": "Trac\\xE9 4723",
    d: "M187.853,351.976a4.908,4.908,0,0,1-7.2-4.53V126.592a5.457,5.457,0,0,1,.762-2.593l4.932,2.846a5.284,5.284,0,0,0-.775,2.579V350.292c0,1.537,1,2.232,2.285,1.684",
    transform: "translate(67.733 46.492)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4724",
    "data-name": "Trac\\xE9 4724",
    d: "M395.808,100.81,359.175,259.438,355.8,274.029a16.862,16.862,0,0,1-7,9.466L131.446,408.985a11.4,11.4,0,0,1-5.138,1.375,10.558,10.558,0,0,1-5.639-1.182l1.118-4.843c.039-.154.077-.308.116-.474l1.22-5.3,5.318-23.018L162.118,229.7a2.346,2.346,0,0,1,.2-.54c.091-.166.194-.333.3-.488.014-.025.038-.051.052-.077a3.247,3.247,0,0,1,.847-.8l185.614-107.16,40.627-23.454a2.445,2.445,0,0,1,2.234,0l2.993,1.72a1.884,1.884,0,0,1,.822,1.9",
    transform: "translate(45.243 36.338)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4649",
    "data-name": "Groupe 4649",
    transform: "translate(165.912 133.258)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4648",
    "data-name": "Groupe 4648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4647",
    "data-name": "Groupe 4647",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4725",
    "data-name": "Trac\\xE9 4725",
    d: "M395.808,100.81,359.175,259.438,355.8,274.029a16.862,16.862,0,0,1-7,9.466L131.446,408.985a11.4,11.4,0,0,1-5.138,1.375,10.558,10.558,0,0,1-5.639-1.182l1.118-4.843c.039-.154.077-.308.116-.474l1.22-5.3,5.318-23.018L162.118,229.7a2.346,2.346,0,0,1,.2-.54c.091-.166.194-.333.3-.488.014-.025.038-.051.052-.077a3.247,3.247,0,0,1,.847-.8l185.614-107.16,40.627-23.454a2.445,2.445,0,0,1,2.234,0l2.993,1.72a1.884,1.884,0,0,1,.822,1.9",
    transform: "translate(-120.669 -96.919)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4726",
    "data-name": "Trac\\xE9 4726",
    d: "M384.393,100.49c-.026-.45-.36-.591-.861-.3L157.28,230.821a2.893,2.893,0,0,0-.848.8l-5.215-3.018a3.248,3.248,0,0,1,.848-.8L378.305,97.188a2.453,2.453,0,0,1,2.234,0l2.993,1.721a1.914,1.914,0,0,1,.861,1.58",
    transform: "translate(56.697 36.339)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4652",
    "data-name": "Groupe 4652",
    transform: "translate(207.913 133.258)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4651",
    "data-name": "Groupe 4651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4650",
    "data-name": "Groupe 4650",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4727",
    "data-name": "Trac\\xE9 4727",
    d: "M384.393,100.49c-.026-.45-.36-.591-.861-.3L157.28,230.821a2.893,2.893,0,0,0-.848.8l-5.215-3.018a3.248,3.248,0,0,1,.848-.8L378.305,97.188a2.453,2.453,0,0,1,2.234,0l2.993,1.721a1.914,1.914,0,0,1,.861,1.58",
    transform: "translate(-151.216 -96.919)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4728",
    "data-name": "Trac\\xE9 4728",
    d: "M167.884,195.709a4.192,4.192,0,0,0-.385.63,2.9,2.9,0,0,0-.168.462l-32.2,139.464h-.012l-6.781,29.388-.848,3.674v.012l-1.181,5.112a10.571,10.571,0,0,1-5.639-1.181l1.118-4.843c.039-.154.077-.308.116-.476l1.22-5.3,5.317-23.017L162.118,193.8a2.314,2.314,0,0,1,.2-.539c.089-.168.192-.334.3-.488.012-.026.038-.052.051-.077Z",
    transform: "translate(45.243 72.247)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4655",
    "data-name": "Groupe 4655",
    transform: "translate(165.912 264.937)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4654",
    "data-name": "Groupe 4654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4653",
    "data-name": "Groupe 4653",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4729",
    "data-name": "Trac\\xE9 4729",
    d: "M167.884,195.709a4.192,4.192,0,0,0-.385.63,2.9,2.9,0,0,0-.168.462l-32.2,139.464h-.012l-6.781,29.388-.848,3.674v.012l-1.181,5.112a10.571,10.571,0,0,1-5.639-1.181l1.118-4.843c.039-.154.077-.308.116-.476l1.22-5.3,5.317-23.017L162.118,193.8a2.314,2.314,0,0,1,.2-.539c.089-.168.192-.334.3-.488.012-.026.038-.052.051-.077Z",
    transform: "translate(-120.669 -192.69)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4730",
    "data-name": "Trac\\xE9 4730",
    d: "M130.06,316.017a1.448,1.448,0,0,1,.685,1.577l-1.834,7.948v.012l-.921,3.985a1.458,1.458,0,0,1-1.492,1.125,9.83,9.83,0,0,1-4.408-1.178c-2.876-1.657-5.214-5.882-5.214-9.428v-9.147a1.445,1.445,0,0,1,2.168-1.251L121.368,311a1.449,1.449,0,0,1,.722,1.254V316.8a1.446,1.446,0,0,0,2.854.326l.389-1.682a1.444,1.444,0,0,1,2.131-.927Z",
    transform: "translate(43.821 116.03)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4658",
    "data-name": "Groupe 4658",
    transform: "translate(160.697 425.494)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4657",
    "data-name": "Groupe 4657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4656",
    "data-name": "Groupe 4656",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4731",
    "data-name": "Trac\\xE9 4731",
    d: "M130.06,316.017a1.448,1.448,0,0,1,.685,1.577l-1.834,7.948v.012l-.921,3.985a1.458,1.458,0,0,1-1.492,1.125,9.83,9.83,0,0,1-4.408-1.178c-2.876-1.657-5.214-5.882-5.214-9.428v-9.147a1.445,1.445,0,0,1,2.168-1.251L121.368,311a1.449,1.449,0,0,1,.722,1.254V316.8a1.446,1.446,0,0,0,2.854.326l.389-1.682a1.444,1.444,0,0,1,2.131-.927Z",
    transform: "translate(-116.876 -309.464)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4668",
    "data-name": "Groupe 4668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4667",
    "data-name": "Groupe 4667",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4732",
    "data-name": "Trac\\xE9 4732",
    d: "M197.475,383.031a5.629,5.629,0,0,1-2.464-4.455V157.718a5.8,5.8,0,0,1,2.626-4.547L338.271,72.037a4.933,4.933,0,0,1,7.553,4.36V297.255A5.8,5.8,0,0,1,343.2,301.8L202.564,382.937a5.63,5.63,0,0,1-5.089.094",
    transform: "translate(73.117 26.763)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4733",
    "data-name": "Trac\\xE9 4733",
    d: "M201.222,382.08l140.636-81.134a5.806,5.806,0,0,0,2.625-4.548V75.54c0-1.675-1.176-2.354-2.626-1.517L201.22,155.159a5.8,5.8,0,0,0-2.626,4.548V380.565c0,1.673,1.176,2.353,2.626,1.515",
    transform: "translate(74.461 27.62)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4734",
    "data-name": "Trac\\xE9 4734",
    d: "M202.219,360.27a4.907,4.907,0,0,1-7.2-4.53V134.886a5.457,5.457,0,0,1,.762-2.593l4.932,2.846a5.283,5.283,0,0,0-.775,2.579V358.586c0,1.537,1,2.232,2.285,1.684",
    transform: "translate(73.119 49.602)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4735",
    "data-name": "Trac\\xE9 4735",
    d: "M215.306,139.935l98.766-56.98v22.768l-98.765,57.021Z",
    transform: "translate(80.726 31.103)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4736",
    "data-name": "Trac\\xE9 4736",
    d: "M209.439,156.51l31.936-18.438c.727-.419,1.316-.122,1.316.665a2.822,2.822,0,0,1-1.316,2.185l-31.936,18.439c-.727.419-1.316.121-1.316-.665a2.821,2.821,0,0,1,1.316-2.186",
    transform: "translate(78.033 51.697)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4737",
    "data-name": "Trac\\xE9 4737",
    d: "M209.439,160.657l31.936-18.438c.727-.419,1.316-.122,1.316.666a2.822,2.822,0,0,1-1.316,2.185l-31.936,18.439c-.727.419-1.316.121-1.316-.667a2.82,2.82,0,0,1,1.316-2.185",
    transform: "translate(78.033 53.252)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4738",
    "data-name": "Trac\\xE9 4738",
    d: "M209.439,164.8l31.936-18.438c.727-.419,1.316-.122,1.316.665a2.822,2.822,0,0,1-1.316,2.185l-31.936,18.439c-.727.419-1.316.121-1.316-.667a2.82,2.82,0,0,1,1.316-2.185",
    transform: "translate(78.033 54.807)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4739",
    "data-name": "Trac\\xE9 4739",
    d: "M209.439,168.952l31.936-18.438c.727-.419,1.316-.122,1.316.665a2.822,2.822,0,0,1-1.316,2.185L209.439,171.8c-.727.419-1.316.121-1.316-.665a2.82,2.82,0,0,1,1.316-2.186",
    transform: "translate(78.033 56.362)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4740",
    "data-name": "Trac\\xE9 4740",
    d: "M271.795,143.318,303.73,124.88c.727-.419,1.316-.122,1.316.665a2.826,2.826,0,0,1-1.316,2.186l-31.936,18.438c-.727.419-1.316.121-1.316-.665a2.821,2.821,0,0,1,1.316-2.186",
    transform: "translate(101.413 46.751)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4741",
    "data-name": "Trac\\xE9 4741",
    d: "M271.795,147.465l31.936-18.438c.727-.419,1.316-.122,1.316.665a2.822,2.822,0,0,1-1.316,2.185l-31.936,18.439c-.727.419-1.316.121-1.316-.665a2.821,2.821,0,0,1,1.316-2.186",
    transform: "translate(101.413 48.306)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4742",
    "data-name": "Trac\\xE9 4742",
    d: "M271.795,151.613l31.936-18.438c.727-.419,1.316-.122,1.316.665a2.822,2.822,0,0,1-1.316,2.185l-31.936,18.439c-.727.419-1.316.121-1.316-.667a2.82,2.82,0,0,1,1.316-2.185",
    transform: "translate(101.413 49.861)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4743",
    "data-name": "Trac\\xE9 4743",
    d: "M271.795,155.76l31.936-18.438c.727-.421,1.316-.122,1.316.665a2.822,2.822,0,0,1-1.316,2.185l-31.936,18.439c-.727.419-1.316.121-1.316-.667a2.821,2.821,0,0,1,1.316-2.185",
    transform: "translate(101.413 51.416)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4744",
    "data-name": "Trac\\xE9 4744",
    d: "M209.44,299.068l120.824-69.757c.727-.419,1.316-.121,1.316.665a2.822,2.822,0,0,1-1.317,2.186L209.44,301.92c-.727.419-1.316.121-1.316-.665a2.821,2.821,0,0,1,1.316-2.186",
    transform: "translate(78.034 85.906)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4745",
    "data-name": "Trac\\xE9 4745",
    d: "M209.44,303.215l120.824-69.757c.727-.419,1.316-.121,1.316.665a2.825,2.825,0,0,1-1.317,2.186L209.44,306.067c-.727.419-1.316.121-1.316-.667a2.82,2.82,0,0,1,1.316-2.185",
    transform: "translate(78.034 87.461)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4746",
    "data-name": "Trac\\xE9 4746",
    d: "M265.948,125.077l39.506-22.809c.726-.419,1.316-.121,1.316.665a2.826,2.826,0,0,1-1.317,2.186l-39.5,22.809c-.727.419-1.316.121-1.316-.665a2.821,2.821,0,0,1,1.316-2.186",
    transform: "translate(99.221 38.273)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4747",
    "data-name": "Trac\\xE9 4747",
    d: "M265.948,129.224l39.506-22.809c.726-.419,1.316-.121,1.316.665a2.826,2.826,0,0,1-1.317,2.186l-39.5,22.809c-.727.419-1.316.121-1.316-.667a2.82,2.82,0,0,1,1.316-2.185",
    transform: "translate(99.221 39.828)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4748",
    "data-name": "Trac\\xE9 4748",
    d: "M265.948,133.37l39.506-22.809c.726-.418,1.316-.12,1.316.667a2.828,2.828,0,0,1-1.317,2.186l-39.5,22.808c-.727.421-1.316.122-1.316-.665a2.825,2.825,0,0,1,1.316-2.186",
    transform: "translate(99.221 41.383)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4749",
    "data-name": "Trac\\xE9 4749",
    d: "M265.948,137.519l39.506-22.809c.726-.419,1.316-.121,1.316.665a2.826,2.826,0,0,1-1.317,2.186l-39.5,22.809c-.727.419-1.316.121-1.316-.667a2.821,2.821,0,0,1,1.316-2.185",
    transform: "translate(99.221 42.938)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4750",
    "data-name": "Trac\\xE9 4750",
    d: "M209.487,194.113a.253.253,0,0,1-.333-.025.578.578,0,0,1-.139-.43V176.247a1.4,1.4,0,0,1,.139-.593.9.9,0,0,1,.333-.407l2.293-1.324a.254.254,0,0,1,.333.023.575.575,0,0,1,.142.43v17.411a1.372,1.372,0,0,1-.142.593.877.877,0,0,1-.333.408Z",
    transform: "translate(78.368 65.192)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4751",
    "data-name": "Trac\\xE9 4751",
    d: "M221.117,188.5a.424.424,0,0,1-.483.036.78.78,0,0,1-.235-.241l-4.008-6.9V190.5a1.371,1.371,0,0,1-.14.593.887.887,0,0,1-.333.408l-2.293,1.325a.256.256,0,0,1-.333-.025.578.578,0,0,1-.14-.432V174.963a1.379,1.379,0,0,1,.14-.593.887.887,0,0,1,.333-.407l1.82-1.052a.423.423,0,0,1,.481-.034.744.744,0,0,1,.236.242l4.009,6.9v-9.109a1.36,1.36,0,0,1,.14-.593.882.882,0,0,1,.331-.408l2.293-1.324a.256.256,0,0,1,.333.023.583.583,0,0,1,.14.432v17.412a1.364,1.364,0,0,1-.14.59.87.87,0,0,1-.333.408Z",
    transform: "translate(79.919 63.191)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4752",
    "data-name": "Trac\\xE9 4752",
    d: "M226.336,185.685q-.683.394-.927-.543l-3.572-14.782c-.023-.113-.037-.184-.044-.219a.6.6,0,0,1-.008-.1,1.116,1.116,0,0,1,.113-.483.726.726,0,0,1,.272-.333l2.205-1.273q.351-.2.5-.059a.614.614,0,0,1,.183.34l2.434,10.452,2.434-13.263a2.094,2.094,0,0,1,.183-.551,1.2,1.2,0,0,1,.5-.517l2.205-1.273a.207.207,0,0,1,.271.019.471.471,0,0,1,.114.352,1.065,1.065,0,0,1-.008.111c-.007.041-.022.129-.044.27l-3.571,18.905a2.26,2.26,0,0,1-.928,1.613Z",
    transform: "translate(83.156 61.129)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4753",
    "data-name": "Trac\\xE9 4753",
    d: "M230.681,170.736a15.394,15.394,0,0,1,.428-3.091,13.83,13.83,0,0,1,1.07-2.934,12.4,12.4,0,0,1,1.679-2.534,8.808,8.808,0,0,1,2.285-1.9,4.659,4.659,0,0,1,2.277-.736,2.542,2.542,0,0,1,1.688.588,3.7,3.7,0,0,1,1.067,1.7,9.128,9.128,0,0,1,.429,2.6q.035,1.14.036,2.406t-.036,2.392a15.207,15.207,0,0,1-.429,3.091,13.954,13.954,0,0,1-1.067,2.948,11.711,11.711,0,0,1-1.688,2.537,8.955,8.955,0,0,1-2.277,1.881,4.752,4.752,0,0,1-2.285.752,2.451,2.451,0,0,1-1.679-.591,3.818,3.818,0,0,1-1.07-1.716,9.2,9.2,0,0,1-.428-2.6q-.035-1.083-.036-2.351t.036-2.446m7.685.227c.014-.331.023-.7.036-1.1s.018-.809.018-1.222-.007-.81-.018-1.189-.022-.719-.036-1.016a4.665,4.665,0,0,0-.184-1.136,1.719,1.719,0,0,0-.421-.74.956.956,0,0,0-.672-.271,1.862,1.862,0,0,0-.946.3,3.552,3.552,0,0,0-.945.788,4.808,4.808,0,0,0-.675,1.05,6.121,6.121,0,0,0-.419,1.225A7.973,7.973,0,0,0,233.92,169q-.035.479-.045,1.064t-.008,1.2q0,.621.008,1.207c.007.393.022.744.045,1.055a2.994,2.994,0,0,0,.6,1.888q.536.582,1.62-.045a3.8,3.8,0,0,0,1.61-1.819,7.468,7.468,0,0,0,.613-2.59",
    transform: "translate(86.478 59.819)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4754",
    "data-name": "Trac\\xE9 4754",
    d: "M240.577,176.164a.253.253,0,0,1-.333-.025.578.578,0,0,1-.139-.43V158.3a1.4,1.4,0,0,1,.139-.593.9.9,0,0,1,.333-.407l2.293-1.325a.256.256,0,0,1,.333.025.575.575,0,0,1,.142.43v17.411a1.376,1.376,0,0,1-.142.593.885.885,0,0,1-.333.408Z",
    transform: "translate(90.025 58.462)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4755",
    "data-name": "Trac\\xE9 4755",
    d: "M247.186,161.334c-.012.241-.021.569-.027.986s-.008.844-.008,1.284,0,.87.008,1.29.015.741.027.968a6.081,6.081,0,0,0,.157,1.094,1.7,1.7,0,0,0,.386.774.934.934,0,0,0,.665.3,1.885,1.885,0,0,0,1-.319,3.882,3.882,0,0,0,.982-.782,5.005,5.005,0,0,0,.63-.89,4.752,4.752,0,0,0,.377-.9q.13-.452.2-.817a3.387,3.387,0,0,1,.194-.718.911.911,0,0,1,.4-.407l2.295-1.324a.207.207,0,0,1,.271.018.476.476,0,0,1,.113.353,10.729,10.729,0,0,1-.437,2.839,12.984,12.984,0,0,1-1.156,2.769,13.25,13.25,0,0,1-1.723,2.41,8.889,8.889,0,0,1-2.145,1.764,4.54,4.54,0,0,1-2.249.719,2.569,2.569,0,0,1-1.69-.6,3.753,3.753,0,0,1-1.077-1.71,9.119,9.119,0,0,1-.429-2.568q-.035-1.085-.034-2.353t.034-2.445a14.229,14.229,0,0,1,.421-3.059,14.441,14.441,0,0,1,1.077-2.953,12.148,12.148,0,0,1,1.69-2.552,8.749,8.749,0,0,1,2.258-1.882,4.8,4.8,0,0,1,2.145-.714,2.889,2.889,0,0,1,1.723.421,3.069,3.069,0,0,1,1.156,1.434,6.066,6.066,0,0,1,.437,2.336,1.125,1.125,0,0,1-.113.483.728.728,0,0,1-.271.331l-2.295,1.324c-.2.114-.331.133-.4.058a1.218,1.218,0,0,1-.194-.495,3.72,3.72,0,0,0-.2-.584,1.112,1.112,0,0,0-.377-.47,1.072,1.072,0,0,0-.63-.162,2.171,2.171,0,0,0-.982.351,3.592,3.592,0,0,0-1,.832,4.655,4.655,0,0,0-.665,1.071,5.5,5.5,0,0,0-.386,1.219,9.627,9.627,0,0,0-.157,1.277",
    transform: "translate(91.452 56.955)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4756",
    "data-name": "Trac\\xE9 4756",
    d: "M261.95,160.435a.255.255,0,0,1,.333.023.579.579,0,0,1,.14.432v2.857a1.365,1.365,0,0,1-.14.591.893.893,0,0,1-.333.408l-8.3,4.792a.253.253,0,0,1-.331-.025.574.574,0,0,1-.139-.432V151.673a1.373,1.373,0,0,1,.139-.593.891.891,0,0,1,.331-.408l8.158-4.709a.256.256,0,0,1,.334.023.576.576,0,0,1,.14.432v2.857a1.381,1.381,0,0,1-.14.593.882.882,0,0,1-.334.407l-5.39,3.113V156.3l5.006-2.89a.253.253,0,0,1,.331.023.577.577,0,0,1,.142.43v2.857a1.383,1.383,0,0,1-.142.594.877.877,0,0,1-.331.407l-5.006,2.89v3.019Z",
    transform: "translate(94.927 54.708)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4757",
    "data-name": "Trac\\xE9 4757",
    d: "M208.123,214.965l123.456-71.277v2.85L208.123,217.817Z",
    transform: "translate(78.033 53.874)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4663",
    "data-name": "Groupe 4663",
    transform: "translate(286.156 197.562)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4662",
    "data-name": "Groupe 4662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4661",
    "data-name": "Groupe 4661",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4758",
    "data-name": "Trac\\xE9 4758",
    d: "M208.123,214.965l123.456-71.277v2.85L208.123,217.817Z",
    transform: "translate(-208.123 -143.688)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4759",
    "data-name": "Trac\\xE9 4759",
    d: "M208.123,268.879,331.579,197.6v2.85L208.123,271.731Z",
    transform: "translate(78.033 74.089)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4666",
    "data-name": "Groupe 4666",
    transform: "translate(286.156 271.691)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4665",
    "data-name": "Groupe 4665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4664",
    "data-name": "Groupe 4664",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4760",
    "data-name": "Trac\\xE9 4760",
    d: "M208.123,268.879,331.579,197.6v2.85L208.123,271.731Z",
    transform: "translate(-208.123 -197.602)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4761",
    "data-name": "Trac\\xE9 4761",
    d: "M208.123,208.747l44.444-25.66v5.7l-44.444,25.659Z",
    transform: "translate(78.033 68.646)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4762",
    "data-name": "Trac\\xE9 4762",
    d: "M247.631,182.049l19.752-11.4v5.7l-19.752,11.4Z",
    transform: "translate(92.846 63.981)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4763",
    "data-name": "Trac\\xE9 4763",
    d: "M265.589,171.681l19.752-11.405v5.7l-19.752,11.4Z",
    transform: "translate(99.58 60.094)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4764",
    "data-name": "Trac\\xE9 4764",
    d: "M283.547,161.314,303.3,149.908v5.7l-19.752,11.4Z",
    transform: "translate(106.313 56.206)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4765",
    "data-name": "Trac\\xE9 4765",
    d: "M208.123,233.628l123.456-71.277v11.4L208.123,245.031Z",
    transform: "translate(78.033 60.871)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4766",
    "data-name": "Trac\\xE9 4766",
    d: "M208.123,250.216,331.579,178.94v11.4L208.123,261.62Z",
    transform: "translate(78.033 67.091)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4767",
    "data-name": "Trac\\xE9 4767",
    d: "M211.965,214.573a.911.911,0,0,1-.456-1.7l34.566-19.959a.912.912,0,1,1,.911,1.58L212.42,214.45a.916.916,0,0,1-.455.122",
    transform: "translate(79.132 72.285)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4768",
    "data-name": "Trac\\xE9 4768",
    d: "M251.389,186.709a.608.608,0,0,1-.305-1.134l14.815-8.552a.607.607,0,1,1,.608,1.052l-14.815,8.553a.6.6,0,0,1-.3.081",
    transform: "translate(94.027 66.342)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4769",
    "data-name": "Trac\\xE9 4769",
    d: "M251.389,189.673a.608.608,0,0,1-.305-1.134l14.815-8.554a.608.608,0,0,1,.608,1.053l-14.815,8.553a.6.6,0,0,1-.3.081",
    transform: "translate(94.027 67.453)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4770",
    "data-name": "Trac\\xE9 4770",
    d: "M269.347,177.9a.608.608,0,0,1-.3-1.134l14.814-8.553a.608.608,0,1,1,.608,1.053l-14.813,8.554a.611.611,0,0,1-.3.081",
    transform: "translate(100.76 63.038)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4771",
    "data-name": "Trac\\xE9 4771",
    d: "M287.3,167.53a.608.608,0,0,1-.3-1.134l14.815-8.553a.608.608,0,1,1,.608,1.053l-14.815,8.553a.61.61,0,0,1-.3.081",
    transform: "translate(107.493 59.151)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4772",
    "data-name": "Trac\\xE9 4772",
    d: "M211.965,221.313a.911.911,0,0,1-.456-1.7l24.69-14.257a.912.912,0,0,1,.912,1.58l-24.69,14.255a.916.916,0,0,1-.455.122",
    transform: "translate(79.132 76.95)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4773",
    "data-name": "Trac\\xE9 4773",
    d: "M251.389,195a.608.608,0,0,1-.305-1.134l14.815-8.552a.608.608,0,0,1,.608,1.053l-14.815,8.552a.605.605,0,0,1-.3.081",
    transform: "translate(94.027 69.452)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4774",
    "data-name": "Trac\\xE9 4774",
    d: "M251.389,197.968a.608.608,0,0,1-.305-1.134l14.815-8.553a.608.608,0,0,1,.608,1.053l-14.815,8.552a.593.593,0,0,1-.3.083",
    transform: "translate(94.027 70.563)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4775",
    "data-name": "Trac\\xE9 4775",
    d: "M269.347,186.193a.608.608,0,0,1-.3-1.134l14.814-8.554a.608.608,0,1,1,.608,1.053l-14.813,8.553a.611.611,0,0,1-.3.081",
    transform: "translate(100.76 66.148)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4776",
    "data-name": "Trac\\xE9 4776",
    d: "M287.3,175.824a.608.608,0,0,1-.3-1.134l14.815-8.554a.608.608,0,1,1,.608,1.053l-14.815,8.553a.61.61,0,0,1-.3.081",
    transform: "translate(107.493 62.26)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4777",
    "data-name": "Trac\\xE9 4777",
    d: "M211.965,231.939a.911.911,0,0,1-.456-1.7l39.5-22.809a.911.911,0,1,1,.912,1.578l-39.5,22.809a.9.9,0,0,1-.455.122",
    transform: "translate(79.132 77.727)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4778",
    "data-name": "Trac\\xE9 4778",
    d: "M251.389,203.3a.608.608,0,0,1-.305-1.134L265.9,193.61a.608.608,0,0,1,.608,1.053l-14.815,8.552a.593.593,0,0,1-.3.082",
    transform: "translate(94.027 72.562)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4779",
    "data-name": "Trac\\xE9 4779",
    d: "M251.389,206.262a.608.608,0,0,1-.305-1.134l14.815-8.553a.607.607,0,1,1,.608,1.052l-14.815,8.554a.593.593,0,0,1-.3.082",
    transform: "translate(94.027 73.673)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4780",
    "data-name": "Trac\\xE9 4780",
    d: "M269.347,194.487a.608.608,0,0,1-.3-1.134l14.814-8.554a.608.608,0,1,1,.608,1.053l-14.813,8.553a.611.611,0,0,1-.3.081",
    transform: "translate(100.76 69.258)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4781",
    "data-name": "Trac\\xE9 4781",
    d: "M287.3,184.119a.608.608,0,0,1-.3-1.134l14.815-8.553a.608.608,0,1,1,.608,1.053l-14.815,8.553a.609.609,0,0,1-.3.081",
    transform: "translate(107.493 65.37)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4782",
    "data-name": "Trac\\xE9 4782",
    d: "M211.965,237.123a.911.911,0,0,1-.456-1.7l19.752-11.405a.912.912,0,0,1,.912,1.58L212.42,237a.914.914,0,0,1-.455.121",
    transform: "translate(79.132 83.947)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4783",
    "data-name": "Trac\\xE9 4783",
    d: "M251.389,211.592a.607.607,0,0,1-.305-1.133l14.815-8.552a.607.607,0,1,1,.608,1.05l-14.815,8.552a.58.58,0,0,1-.3.082",
    transform: "translate(94.027 75.671)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4784",
    "data-name": "Trac\\xE9 4784",
    d: "M251.389,214.557a.608.608,0,0,1-.305-1.134L265.9,204.87a.607.607,0,1,1,.608,1.052l-14.815,8.553a.593.593,0,0,1-.3.083",
    transform: "translate(94.027 76.783)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4785",
    "data-name": "Trac\\xE9 4785",
    d: "M269.347,202.782a.608.608,0,0,1-.3-1.134l14.814-8.553a.607.607,0,1,1,.608,1.052L269.651,202.7a.6.6,0,0,1-.3.083",
    transform: "translate(100.76 72.368)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4786",
    "data-name": "Trac\\xE9 4786",
    d: "M287.3,192.413a.608.608,0,0,1-.3-1.134l14.815-8.553a.608.608,0,1,1,.608,1.053l-14.815,8.554a.61.61,0,0,1-.3.081",
    transform: "translate(107.493 68.48)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4787",
    "data-name": "Trac\\xE9 4787",
    d: "M211.965,247.751a.911.911,0,0,1-.456-1.7l34.566-19.959a.911.911,0,1,1,.911,1.578L212.42,247.629a.915.915,0,0,1-.455.122",
    transform: "translate(79.132 84.724)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4788",
    "data-name": "Trac\\xE9 4788",
    d: "M251.389,219.887a.608.608,0,0,1-.305-1.134L265.9,210.2a.607.607,0,1,1,.608,1.052L251.692,219.8a.593.593,0,0,1-.3.083",
    transform: "translate(94.027 78.781)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4789",
    "data-name": "Trac\\xE9 4789",
    d: "M251.389,222.851a.608.608,0,0,1-.305-1.134l14.815-8.554a.607.607,0,1,1,.608,1.052l-14.815,8.553a.593.593,0,0,1-.3.083",
    transform: "translate(94.027 79.892)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4790",
    "data-name": "Trac\\xE9 4790",
    d: "M269.347,211.076a.608.608,0,0,1-.3-1.134l14.814-8.553a.607.607,0,1,1,.608,1.052l-14.813,8.553a.6.6,0,0,1-.3.082",
    transform: "translate(100.76 75.477)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4791",
    "data-name": "Trac\\xE9 4791",
    d: "M287.3,200.708a.608.608,0,0,1-.3-1.134l14.815-8.554a.608.608,0,0,1,.608,1.053l-14.815,8.552a.6.6,0,0,1-.3.082",
    transform: "translate(107.493 71.59)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4792",
    "data-name": "Trac\\xE9 4792",
    d: "M269.347,223.518a.608.608,0,0,1-.3-1.134l14.815-8.553a.607.607,0,1,1,.608,1.052l-14.815,8.553a.6.6,0,0,1-.3.083",
    transform: "translate(100.76 80.142)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4793",
    "data-name": "Trac\\xE9 4793",
    d: "M287.3,213.149a.608.608,0,0,1-.3-1.134l14.814-8.552a.607.607,0,1,1,.608,1.052l-14.814,8.552a.6.6,0,0,1-.3.083",
    transform: "translate(107.494 76.255)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4794",
    "data-name": "Trac\\xE9 4794",
    d: "M269.347,227.665a.608.608,0,0,1-.3-1.134l14.815-8.553a.607.607,0,1,1,.608,1.052l-14.815,8.554a.6.6,0,0,1-.3.082",
    transform: "translate(100.76 81.697)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4795",
    "data-name": "Trac\\xE9 4795",
    d: "M287.3,217.3a.608.608,0,0,1-.3-1.134l14.814-8.552a.608.608,0,0,1,.608,1.053l-14.814,8.554a.623.623,0,0,1-.3.08",
    transform: "translate(107.494 77.81)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4796",
    "data-name": "Trac\\xE9 4796",
    d: "M319.459,212.117l-79.011,45.618v17.105l79.011-45.616Z",
    transform: "translate(90.153 79.531)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4797",
    "data-name": "Trac\\xE9 4797",
    d: "M252.515,242.017a.124.124,0,0,1,.161.012.276.276,0,0,1,.069.208v1.378a.667.667,0,0,1-.069.286.434.434,0,0,1-.161.2l-1.486.858v6.668a.667.667,0,0,1-.066.285.423.423,0,0,1-.161.2l-1.107.638a.121.121,0,0,1-.16-.011.277.277,0,0,1-.067-.208v-6.67l-1.488.859a.122.122,0,0,1-.16-.011.277.277,0,0,1-.067-.208v-1.379a.664.664,0,0,1,.067-.286.44.44,0,0,1,.16-.2Z",
    transform: "translate(92.893 90.733)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4798",
    "data-name": "Trac\\xE9 4798",
    d: "M251.725,245.661a7.366,7.366,0,0,1,.206-1.49,6.778,6.778,0,0,1,.516-1.415,6.041,6.041,0,0,1,.811-1.224,4.23,4.23,0,0,1,1.1-.914,2.271,2.271,0,0,1,1.1-.356,1.232,1.232,0,0,1,.814.286,1.785,1.785,0,0,1,.516.819,4.416,4.416,0,0,1,.206,1.253c.011.366.017.753.017,1.16s-.005.792-.017,1.152a7.349,7.349,0,0,1-.206,1.492,6.777,6.777,0,0,1-.516,1.422,5.656,5.656,0,0,1-.814,1.225,4.346,4.346,0,0,1-1.1.9,2.3,2.3,0,0,1-1.1.366,1.2,1.2,0,0,1-.811-.287,1.86,1.86,0,0,1-.516-.828,4.384,4.384,0,0,1-.206-1.253c-.011-.348-.016-.726-.016-1.132s.005-.8.016-1.181m3.707.109c.005-.158.012-.336.016-.529s.01-.39.01-.59,0-.391-.01-.572-.011-.348-.016-.492a2.273,2.273,0,0,0-.088-.547.829.829,0,0,0-.2-.357.476.476,0,0,0-.323-.131.9.9,0,0,0-.458.147,1.7,1.7,0,0,0-.455.379,2.294,2.294,0,0,0-.326.506,3.062,3.062,0,0,0-.2.591,3.748,3.748,0,0,0-.087.65c-.012.153-.019.325-.022.513s0,.381,0,.58,0,.395,0,.582.01.359.022.509a1.445,1.445,0,0,0,.29.912c.171.186.432.179.781-.022a1.854,1.854,0,0,0,.778-.879,3.659,3.659,0,0,0,.294-1.25",
    transform: "translate(94.375 90.083)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4799",
    "data-name": "Trac\\xE9 4799",
    d: "M260.654,237.32a.124.124,0,0,1,.161.012.277.277,0,0,1,.067.206v1.379a.684.684,0,0,1-.067.286.432.432,0,0,1-.161.2l-1.488.857v6.67a.673.673,0,0,1-.066.285.43.43,0,0,1-.161.2l-1.107.638a.121.121,0,0,1-.159-.011.277.277,0,0,1-.067-.208v-6.67l-1.486.858a.124.124,0,0,1-.161-.01.283.283,0,0,1-.067-.209v-1.378a.675.675,0,0,1,.067-.287.443.443,0,0,1,.161-.2Z",
    transform: "translate(95.943 88.972)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4800",
    "data-name": "Trac\\xE9 4800",
    d: "M262.9,235.85c.113-.066.2-.066.257-.005a.487.487,0,0,1,.122.215l1.841,7.128a.6.6,0,0,1,.033.175.54.54,0,0,1-.055.234.34.34,0,0,1-.131.16l-1.064.615c-.111.065-.192.074-.241.029a.3.3,0,0,1-.088-.164l-.237-.943-2.245,1.3-.237,1.215a1.035,1.035,0,0,1-.088.267.573.573,0,0,1-.241.249l-1.064.615a.1.1,0,0,1-.131-.01.216.216,0,0,1-.056-.169,1.14,1.14,0,0,1,.033-.215l1.842-9.251a1.641,1.641,0,0,1,.122-.357.633.633,0,0,1,.257-.293Zm-1.368,6.471,1.368-.791-.685-2.725Z",
    transform: "translate(97.214 88.41)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4801",
    "data-name": "Trac\\xE9 4801",
    d: "M268.189,239.45a.121.121,0,0,1,.161.012.284.284,0,0,1,.066.208v1.376a.693.693,0,0,1-.066.286.431.431,0,0,1-.161.2l-3.909,2.255a.119.119,0,0,1-.161-.011.273.273,0,0,1-.067-.208v-8.4a.652.652,0,0,1,.067-.285.417.417,0,0,1,.161-.2l1.105-.639a.122.122,0,0,1,.159.012.278.278,0,0,1,.069.208v6.668Z",
    transform: "translate(99.003 87.745)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4802",
    "data-name": "Trac\\xE9 4802",
    d: "M280.767,225.61a1.389,1.389,0,0,1,.726-.049,1.12,1.12,0,0,1,.524.276,1.291,1.291,0,0,1,.32.5,2.014,2.014,0,0,1,.127.6.538.538,0,0,1-.063.29.45.45,0,0,1-.165.193l-.59.341c-.1.055-.168.069-.216.041a.383.383,0,0,1-.13-.154.678.678,0,0,0-.385-.342,1,1,0,0,0-.763.2,2.33,2.33,0,0,0-.765.719,2.078,2.078,0,0,0-.232.465,1.5,1.5,0,0,0-.082.492.8.8,0,0,0,.089.433.377.377,0,0,0,.3.153,1.964,1.964,0,0,0,.532-.054q.326-.072.789-.183a2.854,2.854,0,0,1,.857-.1.967.967,0,0,1,.575.215,1.061,1.061,0,0,1,.32.549,3.511,3.511,0,0,1,.1.894,4.288,4.288,0,0,1-.125,1.022,4.9,4.9,0,0,1-.367,1.005,5.1,5.1,0,0,1-.587.924,4.889,4.889,0,0,1-.785.78v.883a.67.67,0,0,1-.067.285.412.412,0,0,1-.161.2l-.683.4a.12.12,0,0,1-.161-.012.273.273,0,0,1-.067-.208v-.883a1.85,1.85,0,0,1-.714.106,1.161,1.161,0,0,1-.583-.19,1.19,1.19,0,0,1-.4-.491,2.084,2.084,0,0,1-.168-.8.554.554,0,0,1,.063-.29.458.458,0,0,1,.164-.193l.591-.342a.273.273,0,0,1,.22-.05.292.292,0,0,1,.127.161,1.235,1.235,0,0,0,.146.256.427.427,0,0,0,.227.168.753.753,0,0,0,.359.007,1.79,1.79,0,0,0,.535-.224,3.723,3.723,0,0,0,.49-.341,2.441,2.441,0,0,0,.7-.938,1.441,1.441,0,0,0,.11-.565.538.538,0,0,0-.118-.4.466.466,0,0,0-.359-.1,2.813,2.813,0,0,0-.593.1c-.239.058-.513.117-.822.175a2.359,2.359,0,0,1-.737.054.852.852,0,0,1-.524-.223,1.167,1.167,0,0,1-.309-.557,3.642,3.642,0,0,1-.1-.949,4.019,4.019,0,0,1,.129-1.009,5.358,5.358,0,0,1,.348-.976,4.885,4.885,0,0,1,.538-.88,4.662,4.662,0,0,1,.683-.727v-.884a.663.663,0,0,1,.067-.286.424.424,0,0,1,.161-.2l.683-.395a.122.122,0,0,1,.161.012.281.281,0,0,1,.067.208Z",
    transform: "translate(104.143 84.157)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4803",
    "data-name": "Trac\\xE9 4803",
    d: "M285.035,223.144a1.4,1.4,0,0,1,.726-.048,1.084,1.084,0,0,1,.524.276,1.265,1.265,0,0,1,.32.5,2.013,2.013,0,0,1,.128.6.558.558,0,0,1-.065.29.449.449,0,0,1-.165.192l-.59.34c-.1.056-.168.069-.216.041a.367.367,0,0,1-.129-.153.679.679,0,0,0-.385-.344,1.012,1.012,0,0,0-.764.2,2.215,2.215,0,0,0-.418.314,2.252,2.252,0,0,0-.345.406,2.168,2.168,0,0,0-.234.465,1.5,1.5,0,0,0-.084.492.8.8,0,0,0,.092.434.375.375,0,0,0,.3.151,1.963,1.963,0,0,0,.532-.054c.216-.048.48-.107.789-.183a2.841,2.841,0,0,1,.855-.1.971.971,0,0,1,.575.213,1.041,1.041,0,0,1,.32.55,3.422,3.422,0,0,1,.1.892,4.3,4.3,0,0,1-.127,1.023,4.865,4.865,0,0,1-.367,1,5.012,5.012,0,0,1-.586.924,4.68,4.68,0,0,1-.786.778v.884a.667.667,0,0,1-.066.286.433.433,0,0,1-.161.2l-.683.4a.122.122,0,0,1-.161-.012.275.275,0,0,1-.069-.209v-.883a1.849,1.849,0,0,1-.714.107,1.178,1.178,0,0,1-.583-.19,1.2,1.2,0,0,1-.4-.491,2.047,2.047,0,0,1-.168-.806.526.526,0,0,1,.062-.29.459.459,0,0,1,.165-.193l.591-.342a.263.263,0,0,1,.219-.048.28.28,0,0,1,.128.16,1.431,1.431,0,0,0,.143.257.438.438,0,0,0,.228.166.734.734,0,0,0,.359.008,1.8,1.8,0,0,0,.536-.224,3.7,3.7,0,0,0,.489-.342,2.518,2.518,0,0,0,.414-.435,2.38,2.38,0,0,0,.287-.5,1.46,1.46,0,0,0,.109-.564.554.554,0,0,0-.117-.4.481.481,0,0,0-.36-.1,2.868,2.868,0,0,0-.594.1c-.237.056-.511.116-.819.173a2.38,2.38,0,0,1-.738.055.858.858,0,0,1-.524-.224,1.149,1.149,0,0,1-.308-.555,3.582,3.582,0,0,1-.1-.949,4.089,4.089,0,0,1,.126-1.011,5.539,5.539,0,0,1,.349-.975,4.928,4.928,0,0,1,.538-.881,4.854,4.854,0,0,1,.683-.727v-.883a.676.676,0,0,1,.069-.287.418.418,0,0,1,.161-.2l.683-.395a.124.124,0,0,1,.161.011.286.286,0,0,1,.066.209Z",
    transform: "translate(105.743 83.233)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4804",
    "data-name": "Trac\\xE9 4804",
    d: "M289.3,220.682a1.394,1.394,0,0,1,.727-.048,1.073,1.073,0,0,1,.523.275,1.3,1.3,0,0,1,.322.5,2,2,0,0,1,.127.6.557.557,0,0,1-.065.29.447.447,0,0,1-.164.192l-.59.34c-.1.056-.168.07-.216.04a.368.368,0,0,1-.131-.153.674.674,0,0,0-.385-.342,1.006,1.006,0,0,0-.763.2,2.389,2.389,0,0,0-.419.313,2.2,2.2,0,0,0-.345.407,2.1,2.1,0,0,0-.234.465,1.537,1.537,0,0,0-.084.492.8.8,0,0,0,.092.433.38.38,0,0,0,.3.153,1.915,1.915,0,0,0,.532-.055q.326-.07.789-.183a2.887,2.887,0,0,1,.855-.1.971.971,0,0,1,.576.214,1.059,1.059,0,0,1,.32.55,3.483,3.483,0,0,1,.1.892,4.283,4.283,0,0,1-.125,1.022,4.772,4.772,0,0,1-.368,1,4.911,4.911,0,0,1-.586.925,4.8,4.8,0,0,1-.786.78v.883a.673.673,0,0,1-.066.286.434.434,0,0,1-.161.2l-.683.395a.12.12,0,0,1-.161-.012.274.274,0,0,1-.067-.208v-.883a1.824,1.824,0,0,1-.714.106,1.174,1.174,0,0,1-.583-.19,1.2,1.2,0,0,1-.4-.489,2.055,2.055,0,0,1-.168-.807.545.545,0,0,1,.063-.29.458.458,0,0,1,.164-.192l.591-.341a.261.261,0,0,1,.22-.048.278.278,0,0,1,.127.161,1.449,1.449,0,0,0,.143.254.436.436,0,0,0,.23.168.728.728,0,0,0,.357.008,1.827,1.827,0,0,0,.536-.225,3.605,3.605,0,0,0,.49-.341,2.378,2.378,0,0,0,.414-.436,2.289,2.289,0,0,0,.287-.5,1.468,1.468,0,0,0,.11-.564.548.548,0,0,0-.118-.4.482.482,0,0,0-.359-.106,3.076,3.076,0,0,0-.6.1c-.236.058-.51.117-.819.173a2.421,2.421,0,0,1-.738.056.874.874,0,0,1-.524-.224,1.153,1.153,0,0,1-.307-.557,3.569,3.569,0,0,1-.1-.947,4.077,4.077,0,0,1,.126-1.01,5.386,5.386,0,0,1,.351-.975,4.833,4.833,0,0,1,.538-.883,4.77,4.77,0,0,1,.683-.726v-.884a.664.664,0,0,1,.067-.286.424.424,0,0,1,.161-.2l.683-.393a.124.124,0,0,1,.161.01.289.289,0,0,1,.066.209Z",
    transform: "translate(107.343 82.31)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4805",
    "data-name": "Trac\\xE9 4805",
    d: "M293.571,218.218a1.388,1.388,0,0,1,.726-.048,1.07,1.07,0,0,1,.524.275,1.312,1.312,0,0,1,.32.5,2.005,2.005,0,0,1,.126.6.556.556,0,0,1-.063.29.449.449,0,0,1-.165.193l-.59.34c-.1.056-.168.069-.216.04a.368.368,0,0,1-.131-.153.669.669,0,0,0-.385-.342,1.007,1.007,0,0,0-.763.2,2.4,2.4,0,0,0-.419.314,2.319,2.319,0,0,0-.345.407,2.035,2.035,0,0,0-.232.465,1.5,1.5,0,0,0-.084.492.8.8,0,0,0,.092.433.38.38,0,0,0,.3.153,1.911,1.911,0,0,0,.532-.055c.217-.047.481-.107.789-.183a2.89,2.89,0,0,1,.856-.1.97.97,0,0,1,.575.213,1.081,1.081,0,0,1,.322.551,3.483,3.483,0,0,1,.1.892,4.289,4.289,0,0,1-.126,1.022,4.838,4.838,0,0,1-.367,1,4.92,4.92,0,0,1-.587.925,4.778,4.778,0,0,1-.785.778v.884a.657.657,0,0,1-.067.286.435.435,0,0,1-.161.2l-.683.395a.12.12,0,0,1-.161-.012.278.278,0,0,1-.067-.208v-.883a1.821,1.821,0,0,1-.714.106,1.174,1.174,0,0,1-.583-.19,1.216,1.216,0,0,1-.4-.489,2.081,2.081,0,0,1-.168-.807.543.543,0,0,1,.063-.29.468.468,0,0,1,.165-.192l.591-.341a.257.257,0,0,1,.219-.048.273.273,0,0,1,.127.159,1.413,1.413,0,0,0,.144.256.427.427,0,0,0,.228.168.733.733,0,0,0,.359.008,1.807,1.807,0,0,0,.535-.225,3.689,3.689,0,0,0,.491-.341,2.474,2.474,0,0,0,.414-.436,2.224,2.224,0,0,0,.286-.5,1.44,1.44,0,0,0,.11-.564.548.548,0,0,0-.118-.4.481.481,0,0,0-.359-.106,3.067,3.067,0,0,0-.594.1c-.238.058-.511.117-.821.173a2.413,2.413,0,0,1-.737.056.866.866,0,0,1-.524-.224,1.143,1.143,0,0,1-.308-.557,3.566,3.566,0,0,1-.1-.947,4.082,4.082,0,0,1,.128-1.011,5.4,5.4,0,0,1,.349-.975,4.919,4.919,0,0,1,.538-.883,4.841,4.841,0,0,1,.683-.726v-.884a.682.682,0,0,1,.067-.286.423.423,0,0,1,.161-.2l.683-.393a.124.124,0,0,1,.161.01.284.284,0,0,1,.067.209Z",
    transform: "translate(108.944 81.386)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4806",
    "data-name": "Trac\\xE9 4806",
    d: "M211.881,267.323a.608.608,0,0,1-.3-1.134l29.63-17.106a.607.607,0,0,1,.608,1.052l-29.63,17.106a.6.6,0,0,1-.3.082",
    transform: "translate(79.214 93.359)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4807",
    "data-name": "Trac\\xE9 4807",
    d: "M211.881,271.47a.608.608,0,0,1-.3-1.134l29.63-17.106a.607.607,0,0,1,.608,1.052l-29.63,17.106a.6.6,0,0,1-.3.082",
    transform: "translate(79.214 94.914)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4808",
    "data-name": "Trac\\xE9 4808",
    d: "M211.881,275.617a.608.608,0,0,1-.3-1.134l29.63-17.106a.607.607,0,0,1,.608,1.052l-29.63,17.106a.6.6,0,0,1-.3.082",
    transform: "translate(79.214 96.469)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4940",
    "data-name": "Groupe 4940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4939",
    "data-name": "Groupe 4939",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4809",
    "data-name": "Trac\\xE9 4809",
    d: "M84.89,346.663a23.807,23.807,0,0,0-8.808-8.145c-14.4-8.314-37.746-8.314-52.146,0a23.78,23.78,0,0,0-8.806,8.145H13.137V354.2h.026c.265,5.239,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.923-4,10.533-9.19,10.8-14.427v-7.533Z",
    transform: "translate(4.926 124.585)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4671",
    "data-name": "Groupe 4671",
    transform: "translate(18.062 456.867)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4670",
    "data-name": "Groupe 4670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4669",
    "data-name": "Groupe 4669",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4810",
    "data-name": "Trac\\xE9 4810",
    d: "M84.89,346.663a23.807,23.807,0,0,0-8.808-8.145c-14.4-8.314-37.746-8.314-52.146,0a23.78,23.78,0,0,0-8.806,8.145H13.137V354.2h.026c.265,5.239,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.923-4,10.533-9.19,10.8-14.427v-7.533Z",
    transform: "translate(-13.136 -332.282)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4674",
    "data-name": "Groupe 4674",
    transform: "translate(18.062 456.867)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4673",
    "data-name": "Groupe 4673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4672",
    "data-name": "Groupe 4672",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4811",
    "data-name": "Trac\\xE9 4811",
    d: "M50.01,332.282c-9.438,0-18.874,2.078-26.074,6.235a23.773,23.773,0,0,0-8.808,8.145H13.136V354.2h.026c.265,5.237,3.85,10.429,10.774,14.427,7.2,4.158,16.637,6.235,26.074,6.235Z",
    transform: "translate(-13.137 -332.282)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4677",
    "data-name": "Groupe 4677",
    transform: "translate(18.062 460.323)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4676",
    "data-name": "Groupe 4676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4675",
    "data-name": "Groupe 4675",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4812",
    "data-name": "Trac\\xE9 4812",
    d: "M29.87,334.8a40.378,40.378,0,0,0-5.934,2.779,23.8,23.8,0,0,0-8.808,8.145H13.136v7.535h.026c.265,5.237,3.85,10.429,10.774,14.427a40.371,40.371,0,0,0,5.934,2.779Z",
    transform: "translate(-13.137 -334.795)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4680",
    "data-name": "Groupe 4680",
    transform: "translate(75.072 460.323)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4679",
    "data-name": "Groupe 4679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4678",
    "data-name": "Groupe 4678",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4813",
    "data-name": "Trac\\xE9 4813",
    d: "M54.6,334.8a40.379,40.379,0,0,1,5.934,2.779,23.8,23.8,0,0,1,8.808,8.145h1.992v7.533c-.265,5.239-3.876,10.43-10.8,14.429A40.372,40.372,0,0,1,54.6,370.46Z",
    transform: "translate(-54.6 -334.795)",
    fill: "#27debf"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4814",
    "data-name": "Trac\\xE9 4814",
    d: "M76.082,333.5c-14.4-8.313-37.746-8.313-52.146,0s-14.4,21.793,0,30.106,37.746,8.314,52.146,0,14.4-21.791,0-30.106",
    transform: "translate(4.926 122.703)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4683",
    "data-name": "Groupe 4683",
    transform: "translate(18.062 449.962)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4682",
    "data-name": "Groupe 4682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4681",
    "data-name": "Groupe 4681",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4815",
    "data-name": "Trac\\xE9 4815",
    d: "M76.082,333.5c-14.4-8.313-37.746-8.313-52.146,0s-14.4,21.793,0,30.106,37.746,8.314,52.146,0,14.4-21.791,0-30.106",
    transform: "translate(-13.136 -327.26)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4816",
    "data-name": "Trac\\xE9 4816",
    d: "M63.6,336.79a38.083,38.083,0,0,0-16.982-3.622,38.056,38.056,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.546s2.658,7.067,7.485,9.542A37.98,37.98,0,0,0,46.622,359.5,38.007,38.007,0,0,0,63.6,355.878c4.821-2.475,7.478-5.863,7.478-9.542s-2.658-7.073-7.478-9.546",
    transform: "translate(8.309 124.918)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4686",
    "data-name": "Groupe 4686",
    transform: "translate(30.472 458.084)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4685",
    "data-name": "Groupe 4685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4684",
    "data-name": "Groupe 4684",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4817",
    "data-name": "Trac\\xE9 4817",
    d: "M63.6,336.79a38.083,38.083,0,0,0-16.982-3.622,38.056,38.056,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.546s2.658,7.067,7.485,9.542A37.98,37.98,0,0,0,46.622,359.5,38.007,38.007,0,0,0,63.6,355.878c4.821-2.475,7.478-5.863,7.478-9.542s-2.658-7.073-7.478-9.546",
    transform: "translate(-22.162 -333.167)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4818",
    "data-name": "Trac\\xE9 4818",
    d: "M74.842,334.45c-6.723-3.883-15.7-6.025-25.274-6.025S31.027,330.567,24.3,334.45c-6.451,3.723-10,8.57-10,13.664s3.546,9.941,10,13.663c6.723,3.876,15.694,6.018,25.265,6.018s18.551-2.142,25.274-6.018c6.442-3.722,10-8.577,10-13.663s-3.554-9.941-10-13.664m-8.292,23.2a38.007,38.007,0,0,1-16.982,3.628,37.98,37.98,0,0,1-16.975-3.628c-4.827-2.474-7.485-5.861-7.485-9.541s2.658-7.073,7.485-9.548a38.074,38.074,0,0,1,16.975-3.622,38.1,38.1,0,0,1,16.982,3.622c4.821,2.475,7.478,5.868,7.478,9.548s-2.658,7.067-7.478,9.541",
    transform: "translate(5.364 123.139)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4689",
    "data-name": "Groupe 4689",
    transform: "translate(31.743 459.348)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4688",
    "data-name": "Groupe 4688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4687",
    "data-name": "Groupe 4687",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4819",
    "data-name": "Trac\\xE9 4819",
    d: "M62.677,354.4c9.055-4.647,9.055-12.183,0-16.831s-23.742-4.647-32.8,0-9.057,12.183,0,16.831,23.738,4.647,32.8,0",
    transform: "translate(-23.087 -334.086)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4820",
    "data-name": "Trac\\xE9 4820",
    d: "M62.677,354.4c9.055-4.647,9.055-12.183,0-16.831s-23.742-4.647-32.8,0-9.057,12.183,0,16.831,23.738,4.647,32.8,0",
    transform: "translate(8.656 125.262)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4692",
    "data-name": "Groupe 4692",
    transform: "translate(31.743 459.348)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4691",
    "data-name": "Groupe 4691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4690",
    "data-name": "Groupe 4690",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4821",
    "data-name": "Trac\\xE9 4821",
    d: "M62.677,354.4c9.055-4.647,9.055-12.183,0-16.831s-23.742-4.647-32.8,0-9.057,12.183,0,16.831,23.738,4.647,32.8,0",
    transform: "translate(-23.087 -334.086)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4822",
    "data-name": "Trac\\xE9 4822",
    d: "M62.619,339.866c-9.057-4.647-23.74-4.649-32.8,0-3.745,1.922-5.937,4.338-6.585,6.839.648,2.5,2.839,4.917,6.585,6.839,9.057,4.647,23.74,4.647,32.8,0,3.745-1.922,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.839",
    transform: "translate(8.713 126.122)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4695",
    "data-name": "Groupe 4695",
    transform: "translate(31.951 462.502)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4694",
    "data-name": "Groupe 4694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4693",
    "data-name": "Groupe 4693",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4823",
    "data-name": "Trac\\xE9 4823",
    d: "M62.619,339.866c-9.057-4.647-23.74-4.649-32.8,0-3.745,1.922-5.937,4.338-6.585,6.839.648,2.5,2.839,4.917,6.585,6.839,9.057,4.647,23.74,4.647,32.8,0,3.745-1.922,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.839",
    transform: "translate(-23.238 -336.38)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4824",
    "data-name": "Trac\\xE9 4824",
    d: "M42.453,336.753v3.4l-1.16,1.226-2.148,2.248v-3.539Z",
    transform: "translate(14.677 126.262)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4698",
    "data-name": "Groupe 4698",
    transform: "translate(53.822 463.016)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4697",
    "data-name": "Groupe 4697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4696",
    "data-name": "Groupe 4696",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4825",
    "data-name": "Trac\\xE9 4825",
    d: "M42.453,336.753v3.4l-1.16,1.226-2.148,2.248v-3.539Z",
    transform: "translate(-39.145 -336.754)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4826",
    "data-name": "Trac\\xE9 4826",
    d: "M40.777,339.27v2.007a18.993,18.993,0,0,1-3.3.938,3.544,3.544,0,0,1-1.413-.054,3.339,3.339,0,0,1-.674-.276c-.818-.49-.95-1.215.608-2.113a5.446,5.446,0,0,1,4.781-.5",
    transform: "translate(13.045 127.078)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4701",
    "data-name": "Groupe 4701",
    transform: "translate(47.838 466.007)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4700",
    "data-name": "Groupe 4700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4699",
    "data-name": "Groupe 4699",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4827",
    "data-name": "Trac\\xE9 4827",
    d: "M40.777,339.27v2.007a18.993,18.993,0,0,1-3.3.938,3.544,3.544,0,0,1-1.413-.054,3.339,3.339,0,0,1-.674-.276c-.818-.49-.95-1.215.608-2.113a5.446,5.446,0,0,1,4.781-.5",
    transform: "translate(-34.793 -338.929)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4828",
    "data-name": "Trac\\xE9 4828",
    d: "M58.131,349.435v2.936l-3.719,2.145-2.751-1.591a14.011,14.011,0,0,1-10.652.481v-2.938l1.691-1.676-1.691.466a10.873,10.873,0,0,1-8.3-.95c-1.668-.96-2.441-2.014-2.438-3.1v-2.859l.3-1.248-1.015-.591v-2.938l2.751,1.591c-1.342,1.041-2.056,2.113-2.038,3.154v.033c.03,1.057.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.484.346,3.054-1,5.277-2.167,7.038-1.152,1.092.632.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.244.305l-3.516,3.486a12.706,12.706,0,0,0,1.943.571,14.492,14.492,0,0,0,8.709-1.048l2.751,1.591Z",
    transform: "translate(11.084 126.57)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4704",
    "data-name": "Groupe 4704",
    transform: "translate(41.358 467.674)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4703",
    "data-name": "Groupe 4703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4702",
    "data-name": "Groupe 4702",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4829",
    "data-name": "Trac\\xE9 4829",
    d: "M30.08,341.359v.033c.03,1.056.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.485.345,3.052-1,5.276-2.167,7.037-1.151,1.092.632.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.243.305l-3.516,3.485a12.442,12.442,0,0,0,1.943.569,14.476,14.476,0,0,0,8.708-1.046l2.753,1.589,3.718-2.145v2.934l-3.718,2.146-2.753-1.591a14.015,14.015,0,0,1-10.65.481v-2.938l1.69-1.676-1.69.466a10.876,10.876,0,0,1-8.3-.95c-1.668-.961-2.441-2.014-2.438-3.1v-2.857l.3-1.25",
    transform: "translate(-30.08 -340.142)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4707",
    "data-name": "Groupe 4707",
    transform: "translate(40.645 464.145)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4706",
    "data-name": "Groupe 4706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4705",
    "data-name": "Groupe 4705",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4830",
    "data-name": "Trac\\xE9 4830",
    d: "M29.562,337.575v2.938l1.013.59-.006.01a6,6,0,0,1,1.743-1.947Z",
    transform: "translate(-29.561 -337.575)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4831",
    "data-name": "Trac\\xE9 4831",
    d: "M50.475,345.486a3.428,3.428,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.826c.012.806.026,2.416.026,2.5",
    transform: "translate(18.123 128.6)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4710",
    "data-name": "Groupe 4710",
    transform: "translate(66.46 471.59)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4709",
    "data-name": "Groupe 4709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4708",
    "data-name": "Groupe 4708",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4832",
    "data-name": "Trac\\xE9 4832",
    d: "M50.475,345.486a3.428,3.428,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.826c.012.806.026,2.416.026,2.5",
    transform: "translate(-48.337 -342.99)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4833",
    "data-name": "Trac\\xE9 4833",
    d: "M57.509,349.669l-2.128-1.235a3.626,3.626,0,0,0,2.128-3.261c0-.1-.01-.194-.018-.286-.092-1.013-.839-2-2.379-2.885v-.01a9.768,9.768,0,0,0-4.947-1.29c-.139,0-.286.01-.425.01H49.7l-.443.027c-.129.01-.258.018-.386.037-.056.008-.111.008-.157.018-.1.01-.2.019-.3.037a19.865,19.865,0,0,0-2.4.5c-.378.1-.755.212-1.125.331-.533.166-1.059.341-1.556.507-.2.073-.4.137-.59.2a18.315,18.315,0,0,1-3.3.941,3.446,3.446,0,0,1-1.419-.055,2.976,2.976,0,0,1-.664-.276c-.829-.48-.958-1.207.6-2.11a5.438,5.438,0,0,1,4.782-.5l3.308-3.336a14.167,14.167,0,0,0-9.979.553L33.312,336l-3.751,2.166,2.755,1.585c-1.345,1.041-2.064,2.119-2.046,3.161v.028c.037,1.059.811,2.082,2.442,3.022,3.622,2.091,7.206,1.4,10.487.341,3.05-1,5.27-2.166,7.031-1.152,1.1.637.764,1.4-.462,2.111a6.057,6.057,0,0,1-5.243.3l-3.52,3.492a13.676,13.676,0,0,0,1.944.572,12.984,12.984,0,0,0,3.393.247,15.715,15.715,0,0,0,5.314-1.3l2.755,1.594,3.714-2.146Z",
    transform: "translate(11.084 125.981)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4834",
    "data-name": "Trac\\xE9 4834",
    d: "M45.634,346.605v2.936l2.754,1.589v-2.936Z",
    transform: "translate(17.11 129.956)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4713",
    "data-name": "Groupe 4713",
    transform: "translate(62.744 476.561)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4712",
    "data-name": "Groupe 4712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4711",
    "data-name": "Groupe 4711",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4835",
    "data-name": "Trac\\xE9 4835",
    d: "M45.634,346.605v2.936l2.754,1.589v-2.936Z",
    transform: "translate(-45.634 -346.605)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4836",
    "data-name": "Trac\\xE9 4836",
    d: "M29.562,338.168,33.312,336l2.755,1.585-2.732-1.143Z",
    transform: "translate(11.084 125.981)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4837",
    "data-name": "Trac\\xE9 4837",
    d: "M35.667,340.587a5.439,5.439,0,0,1,4.782-.5l3.308-3.336-3.308,2.992a5.011,5.011,0,0,0-4.782.841",
    transform: "translate(13.373 126.262)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4838",
    "data-name": "Trac\\xE9 4838",
    d: "M37.885,347.906a13.5,13.5,0,0,0,1.944.571,12.918,12.918,0,0,0,3.393.249,11.956,11.956,0,0,1-4.782-.956l2.964-3.356Z",
    transform: "translate(14.205 129.134)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4839",
    "data-name": "Trac\\xE9 4839",
    d: "M45.634,346.756,48.388,348,52.1,346.2l-3.712,2.142Z",
    transform: "translate(17.11 129.805)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4840",
    "data-name": "Trac\\xE9 4840",
    d: "M24.585,334.945c9.762-5.93,24.983-6.52,24.983-6.52-9.571,0-18.541,2.142-25.265,6.025-6.451,3.723-10,8.57-10,13.664,0,0,.349-7.137,10.279-13.169",
    transform: "translate(5.364 123.139)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4841",
    "data-name": "Trac\\xE9 4841",
    d: "M37.884,364.611c10.36.461,20.994-1.6,28.918-6.172,8.24-4.757,11.765-11.207,10.575-17.411,0,0,1.539,10.111-11.2,17.031s-28.295,6.552-28.295,6.552",
    transform: "translate(14.204 127.865)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4842",
    "data-name": "Trac\\xE9 4842",
    d: "M83.051,338.915a23.783,23.783,0,0,0-8.808-8.145c-14.4-8.314-37.746-8.314-52.145,0a23.772,23.772,0,0,0-8.808,8.145H11.3v7.533h.026c.265,5.237,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(4.236 121.68)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4716",
    "data-name": "Groupe 4716",
    transform: "translate(15.534 446.214)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4715",
    "data-name": "Groupe 4715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4714",
    "data-name": "Groupe 4714",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4843",
    "data-name": "Trac\\xE9 4843",
    d: "M83.051,338.915a23.783,23.783,0,0,0-8.808-8.145c-14.4-8.314-37.746-8.314-52.145,0a23.772,23.772,0,0,0-8.808,8.145H11.3v7.533h.026c.265,5.237,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(-11.298 -324.534)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4719",
    "data-name": "Groupe 4719",
    transform: "translate(15.534 446.214)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4718",
    "data-name": "Groupe 4718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4717",
    "data-name": "Groupe 4717",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4844",
    "data-name": "Trac\\xE9 4844",
    d: "M48.172,324.534c-9.438,0-18.875,2.079-26.074,6.235a23.774,23.774,0,0,0-8.808,8.145H11.3v7.533h.026c.265,5.237,3.85,10.43,10.774,14.427,7.2,4.158,16.637,6.235,26.074,6.235Z",
    transform: "translate(-11.298 -324.534)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4722",
    "data-name": "Groupe 4722",
    transform: "translate(15.534 449.671)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4721",
    "data-name": "Groupe 4721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4720",
    "data-name": "Groupe 4720",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4845",
    "data-name": "Trac\\xE9 4845",
    d: "M28.032,327.048a40.384,40.384,0,0,0-5.934,2.779,23.794,23.794,0,0,0-8.808,8.145H11.3v7.535h.026c.265,5.237,3.85,10.429,10.774,14.427a40.523,40.523,0,0,0,5.934,2.779Z",
    transform: "translate(-11.298 -327.048)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4725",
    "data-name": "Groupe 4725",
    transform: "translate(72.544 449.671)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4724",
    "data-name": "Groupe 4724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4723",
    "data-name": "Groupe 4723",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4846",
    "data-name": "Trac\\xE9 4846",
    d: "M52.762,327.048a40.385,40.385,0,0,1,5.934,2.779,23.784,23.784,0,0,1,8.808,8.145H69.5v7.535h0c-.265,5.239-3.876,10.43-10.8,14.429a40.523,40.523,0,0,1-5.934,2.779Z",
    transform: "translate(-52.761 -327.048)",
    fill: "#27debf"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4847",
    "data-name": "Trac\\xE9 4847",
    d: "M74.243,325.748c-14.4-8.314-37.746-8.314-52.146,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.793,0-30.106",
    transform: "translate(4.236 119.798)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4728",
    "data-name": "Groupe 4728",
    transform: "translate(15.534 439.311)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4727",
    "data-name": "Groupe 4727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4726",
    "data-name": "Groupe 4726",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4848",
    "data-name": "Trac\\xE9 4848",
    d: "M74.243,325.748c-14.4-8.314-37.746-8.314-52.146,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.793,0-30.106",
    transform: "translate(-11.298 -319.513)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4849",
    "data-name": "Trac\\xE9 4849",
    d: "M61.766,329.042a38.083,38.083,0,0,0-16.982-3.622,38.056,38.056,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.546s2.658,7.067,7.485,9.541a37.961,37.961,0,0,0,16.975,3.628,37.988,37.988,0,0,0,16.982-3.628c4.821-2.474,7.478-5.861,7.478-9.541s-2.658-7.073-7.478-9.546",
    transform: "translate(7.62 122.012)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4731",
    "data-name": "Groupe 4731",
    transform: "translate(27.944 447.432)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4730",
    "data-name": "Groupe 4730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4729",
    "data-name": "Groupe 4729",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4850",
    "data-name": "Trac\\xE9 4850",
    d: "M61.766,329.042a38.083,38.083,0,0,0-16.982-3.622,38.056,38.056,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.546s2.658,7.067,7.485,9.541a37.961,37.961,0,0,0,16.975,3.628,37.988,37.988,0,0,0,16.982-3.628c4.821-2.474,7.478-5.861,7.478-9.541s-2.658-7.073-7.478-9.546",
    transform: "translate(-20.323 -325.42)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4851",
    "data-name": "Trac\\xE9 4851",
    d: "M73,326.7c-6.723-3.883-15.7-6.025-25.274-6.025S29.189,322.82,22.465,326.7c-6.451,3.723-10,8.57-10,13.664s3.546,9.941,10,13.664c6.723,3.875,15.694,6.017,25.265,6.017S66.28,357.906,73,354.031c6.442-3.723,10-8.577,10-13.664s-3.554-9.941-10-13.664m-8.292,23.2a38.007,38.007,0,0,1-16.982,3.628,37.98,37.98,0,0,1-16.975-3.628c-4.827-2.474-7.485-5.861-7.485-9.541s2.658-7.073,7.485-9.546A38.055,38.055,0,0,1,47.73,327.2a38.082,38.082,0,0,1,16.982,3.623c4.821,2.474,7.478,5.867,7.478,9.546s-2.658,7.067-7.478,9.541",
    transform: "translate(4.675 120.234)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4734",
    "data-name": "Groupe 4734",
    transform: "translate(29.215 448.696)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4733",
    "data-name": "Groupe 4733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4732",
    "data-name": "Groupe 4732",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4852",
    "data-name": "Trac\\xE9 4852",
    d: "M60.838,346.655c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.055,12.183,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-21.248 -326.339)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4853",
    "data-name": "Trac\\xE9 4853",
    d: "M60.838,346.655c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.055,12.183,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(7.967 122.357)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4737",
    "data-name": "Groupe 4737",
    transform: "translate(29.215 448.696)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4736",
    "data-name": "Groupe 4736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4735",
    "data-name": "Groupe 4735",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4854",
    "data-name": "Trac\\xE9 4854",
    d: "M60.838,346.655c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.055,12.183,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-21.248 -326.339)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4855",
    "data-name": "Trac\\xE9 4855",
    d: "M60.781,332.117c-9.057-4.646-23.74-4.646-32.8,0-3.745,1.924-5.937,4.339-6.585,6.84.648,2.5,2.839,4.915,6.585,6.839,9.057,4.646,23.74,4.646,32.8,0,3.745-1.924,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.84",
    transform: "translate(8.024 123.217)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4740",
    "data-name": "Groupe 4740",
    transform: "translate(29.423 451.849)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4739",
    "data-name": "Groupe 4739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4738",
    "data-name": "Groupe 4738",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4856",
    "data-name": "Trac\\xE9 4856",
    d: "M60.781,332.117c-9.057-4.646-23.74-4.646-32.8,0-3.745,1.924-5.937,4.339-6.585,6.84.648,2.5,2.839,4.915,6.585,6.839,9.057,4.646,23.74,4.646,32.8,0,3.745-1.924,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.84",
    transform: "translate(-21.4 -328.632)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4857",
    "data-name": "Trac\\xE9 4857",
    d: "M40.615,329.006v3.4l-1.16,1.225-2.148,2.248v-3.538Z",
    transform: "translate(13.988 123.357)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4743",
    "data-name": "Groupe 4743",
    transform: "translate(51.294 452.363)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4742",
    "data-name": "Groupe 4742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4741",
    "data-name": "Groupe 4741",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4858",
    "data-name": "Trac\\xE9 4858",
    d: "M40.615,329.006v3.4l-1.16,1.225-2.148,2.248v-3.538Z",
    transform: "translate(-37.306 -329.006)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4859",
    "data-name": "Trac\\xE9 4859",
    d: "M38.939,331.523v2.008a18.985,18.985,0,0,1-3.3.938,3.546,3.546,0,0,1-1.413-.053,3.346,3.346,0,0,1-.674-.276c-.818-.49-.95-1.216.609-2.113a5.442,5.442,0,0,1,4.779-.5",
    transform: "translate(12.356 124.173)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4746",
    "data-name": "Groupe 4746",
    transform: "translate(45.31 455.355)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4745",
    "data-name": "Groupe 4745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4744",
    "data-name": "Groupe 4744",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4860",
    "data-name": "Trac\\xE9 4860",
    d: "M38.939,331.523v2.008a18.985,18.985,0,0,1-3.3.938,3.546,3.546,0,0,1-1.413-.053,3.346,3.346,0,0,1-.674-.276c-.818-.49-.95-1.216.609-2.113a5.442,5.442,0,0,1,4.779-.5",
    transform: "translate(-32.954 -331.182)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4861",
    "data-name": "Trac\\xE9 4861",
    d: "M56.293,341.688v2.936l-3.719,2.145-2.751-1.589a14.018,14.018,0,0,1-10.652.48v-2.938l1.691-1.676-1.691.466a10.879,10.879,0,0,1-8.3-.949c-1.668-.961-2.441-2.016-2.438-3.1v-2.859l.3-1.248-1.015-.591v-2.938l2.751,1.591c-1.343,1.042-2.056,2.113-2.038,3.154v.033c.03,1.057.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.484.347,3.054-1,5.277-2.167,7.038-1.152,1.092.632.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.244.305l-3.516,3.485a12.648,12.648,0,0,0,1.943.571,14.493,14.493,0,0,0,8.709-1.048l2.751,1.591Z",
    transform: "translate(10.394 123.665)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4749",
    "data-name": "Groupe 4749",
    transform: "translate(38.83 457.023)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4748",
    "data-name": "Groupe 4748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4747",
    "data-name": "Groupe 4747",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4862",
    "data-name": "Trac\\xE9 4862",
    d: "M28.242,333.611v.033c.03,1.056.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.485.345,3.052-1,5.276-2.167,7.037-1.151,1.092.632.76,1.4-.466,2.109a6.094,6.094,0,0,1-5.243.3l-3.516,3.487a12.455,12.455,0,0,0,1.943.569,14.484,14.484,0,0,0,8.709-1.046l2.751,1.59,3.718-2.145v2.934l-3.718,2.146-2.751-1.591a14.019,14.019,0,0,1-10.652.481v-2.938l1.69-1.677-1.69.468a10.877,10.877,0,0,1-8.3-.95c-1.668-.961-2.441-2.014-2.438-3.1v-2.857l.3-1.25",
    transform: "translate(-28.241 -332.395)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4752",
    "data-name": "Groupe 4752",
    transform: "translate(38.117 453.493)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4751",
    "data-name": "Groupe 4751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4750",
    "data-name": "Groupe 4750",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4863",
    "data-name": "Trac\\xE9 4863",
    d: "M27.723,329.828v2.938l1.015.59-.006.01a6,6,0,0,1,1.742-1.947Z",
    transform: "translate(-27.723 -329.828)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4864",
    "data-name": "Trac\\xE9 4864",
    d: "M48.637,337.739a3.423,3.423,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.826c.012.806.026,2.416.026,2.5",
    transform: "translate(17.434 125.695)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4755",
    "data-name": "Groupe 4755",
    transform: "translate(63.932 460.939)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4754",
    "data-name": "Groupe 4754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4753",
    "data-name": "Groupe 4753",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4865",
    "data-name": "Trac\\xE9 4865",
    d: "M48.637,337.739a3.423,3.423,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.826c.012.806.026,2.416.026,2.5",
    transform: "translate(-46.498 -335.243)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4866",
    "data-name": "Trac\\xE9 4866",
    d: "M55.671,341.921l-2.128-1.235a3.624,3.624,0,0,0,2.128-3.261c0-.1-.01-.194-.018-.286-.092-1.013-.839-2-2.379-2.885v-.01a9.768,9.768,0,0,0-4.948-1.29c-.137,0-.285.01-.423.01h-.045c-.147.011-.3.018-.443.029-.129.008-.258.018-.386.036-.056.01-.111.01-.157.018-.1.01-.2.021-.3.039a19.589,19.589,0,0,0-2.4.5c-.378.1-.756.21-1.125.33-.533.168-1.059.341-1.556.509-.2.071-.4.136-.59.2a18.1,18.1,0,0,1-3.3.94,3.444,3.444,0,0,1-1.419-.054,3.045,3.045,0,0,1-.664-.278c-.829-.48-.958-1.207.6-2.111a5.438,5.438,0,0,1,4.782-.5l3.308-3.334a14.159,14.159,0,0,0-9.979.551l-2.755-1.585-3.751,2.165,2.755,1.585c-1.345,1.041-2.064,2.119-2.046,3.162v.026c.037,1.059.811,2.082,2.442,3.023,3.622,2.09,7.206,1.4,10.487.34,3.05-1,5.27-2.166,7.03-1.152,1.1.637.766,1.4-.461,2.111a6.051,6.051,0,0,1-5.243.3l-3.52,3.492a13.693,13.693,0,0,0,1.944.572,12.921,12.921,0,0,0,3.393.247,15.713,15.713,0,0,0,5.314-1.3l2.755,1.595,3.714-2.148Z",
    transform: "translate(10.394 123.075)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4867",
    "data-name": "Trac\\xE9 4867",
    d: "M43.8,338.858v2.935l2.754,1.589v-2.935Z",
    transform: "translate(16.421 127.051)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4758",
    "data-name": "Groupe 4758",
    transform: "translate(60.216 465.909)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4757",
    "data-name": "Groupe 4757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4756",
    "data-name": "Groupe 4756",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4868",
    "data-name": "Trac\\xE9 4868",
    d: "M43.8,338.858v2.935l2.754,1.589v-2.935Z",
    transform: "translate(-43.795 -338.858)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4869",
    "data-name": "Trac\\xE9 4869",
    d: "M27.723,330.421l3.751-2.166,2.755,1.585L31.5,328.7Z",
    transform: "translate(10.394 123.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4870",
    "data-name": "Trac\\xE9 4870",
    d: "M33.828,332.839a5.438,5.438,0,0,1,4.782-.5l3.308-3.336L38.61,332a5.016,5.016,0,0,0-4.782.841",
    transform: "translate(12.683 123.357)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4871",
    "data-name": "Trac\\xE9 4871",
    d: "M36.047,340.159a13.5,13.5,0,0,0,1.944.571,12.924,12.924,0,0,0,3.393.249,11.955,11.955,0,0,1-4.782-.956l2.964-3.356Z",
    transform: "translate(13.515 126.229)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4872",
    "data-name": "Trac\\xE9 4872",
    d: "M43.8,339.009l2.754,1.242,3.712-1.794L46.549,340.6Z",
    transform: "translate(16.421 126.9)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4873",
    "data-name": "Trac\\xE9 4873",
    d: "M22.746,327.2c9.762-5.93,24.984-6.52,24.984-6.52-9.572,0-18.542,2.142-25.266,6.025-6.451,3.723-10,8.569-10,13.664,0,0,.349-7.137,10.279-13.169",
    transform: "translate(4.674 120.234)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4874",
    "data-name": "Trac\\xE9 4874",
    d: "M36.046,356.864c10.36.461,20.994-1.6,28.918-6.172,8.24-4.757,11.765-11.207,10.575-17.411,0,0,1.539,10.111-11.2,17.031s-28.295,6.552-28.295,6.552",
    transform: "translate(13.515 124.96)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4875",
    "data-name": "Trac\\xE9 4875",
    d: "M86.887,331.416a23.8,23.8,0,0,0-8.808-8.145c-14.4-8.313-37.746-8.313-52.145,0a23.783,23.783,0,0,0-8.808,8.145H15.134v7.533h.026c.265,5.238,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(5.674 118.869)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4761",
    "data-name": "Groupe 4761",
    transform: "translate(20.808 435.906)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4760",
    "data-name": "Groupe 4760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4759",
    "data-name": "Groupe 4759",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4876",
    "data-name": "Trac\\xE9 4876",
    d: "M86.887,331.416a23.8,23.8,0,0,0-8.808-8.145c-14.4-8.313-37.746-8.313-52.145,0a23.783,23.783,0,0,0-8.808,8.145H15.134v7.533h.026c.265,5.238,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(-15.134 -317.037)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4764",
    "data-name": "Groupe 4764",
    transform: "translate(20.808 435.906)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4763",
    "data-name": "Groupe 4763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4762",
    "data-name": "Groupe 4762",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4877",
    "data-name": "Trac\\xE9 4877",
    d: "M52.008,317.037c-9.438,0-18.874,2.078-26.074,6.235a23.774,23.774,0,0,0-8.808,8.145H15.134v7.533h.026c.265,5.237,3.85,10.429,10.774,14.427,7.2,4.158,16.637,6.235,26.074,6.235Z",
    transform: "translate(-15.134 -317.037)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4767",
    "data-name": "Groupe 4767",
    transform: "translate(20.808 439.362)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4766",
    "data-name": "Groupe 4766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4765",
    "data-name": "Groupe 4765",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4878",
    "data-name": "Trac\\xE9 4878",
    d: "M31.868,319.55a40.371,40.371,0,0,0-5.934,2.779,23.785,23.785,0,0,0-8.808,8.145H15.134v7.535h.026c.265,5.237,3.85,10.429,10.774,14.427a40.365,40.365,0,0,0,5.934,2.779Z",
    transform: "translate(-15.134 -319.55)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4770",
    "data-name": "Groupe 4770",
    transform: "translate(77.819 439.362)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4769",
    "data-name": "Groupe 4769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4768",
    "data-name": "Groupe 4768",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4879",
    "data-name": "Trac\\xE9 4879",
    d: "M56.6,319.55a40.372,40.372,0,0,1,5.934,2.779,23.785,23.785,0,0,1,8.808,8.145h1.992v7.535h0c-.265,5.239-3.876,10.43-10.8,14.429a40.365,40.365,0,0,1-5.934,2.779Z",
    transform: "translate(-56.598 -319.55)",
    fill: "#27debf"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4880",
    "data-name": "Trac\\xE9 4880",
    d: "M78.079,318.25c-14.4-8.313-37.746-8.313-52.145,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.791,0-30.106",
    transform: "translate(5.674 116.987)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4773",
    "data-name": "Groupe 4773",
    transform: "translate(20.808 429.001)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4772",
    "data-name": "Groupe 4772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4771",
    "data-name": "Groupe 4771",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4881",
    "data-name": "Trac\\xE9 4881",
    d: "M78.079,318.25c-14.4-8.313-37.746-8.313-52.145,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.791,0-30.106",
    transform: "translate(-15.134 -312.015)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4882",
    "data-name": "Trac\\xE9 4882",
    d: "M65.6,321.544a38.081,38.081,0,0,0-16.982-3.622,38.054,38.054,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.548s2.658,7.066,7.485,9.541A37.98,37.98,0,0,0,48.62,344.26,38.006,38.006,0,0,0,65.6,340.632c4.821-2.475,7.478-5.861,7.478-9.541s-2.658-7.074-7.478-9.548",
    transform: "translate(9.059 119.201)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4776",
    "data-name": "Groupe 4776",
    transform: "translate(33.218 437.123)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4775",
    "data-name": "Groupe 4775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4774",
    "data-name": "Groupe 4774",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4883",
    "data-name": "Trac\\xE9 4883",
    d: "M65.6,321.544a38.081,38.081,0,0,0-16.982-3.622,38.054,38.054,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.548s2.658,7.066,7.485,9.541A37.98,37.98,0,0,0,48.62,344.26,38.006,38.006,0,0,0,65.6,340.632c4.821-2.475,7.478-5.861,7.478-9.541s-2.658-7.074-7.478-9.548",
    transform: "translate(-24.16 -317.922)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4884",
    "data-name": "Trac\\xE9 4884",
    d: "M76.84,319.205c-6.725-3.883-15.7-6.025-25.274-6.025s-18.541,2.142-25.264,6.025c-6.451,3.723-10,8.57-10,13.664s3.546,9.941,10,13.664c6.723,3.875,15.694,6.017,25.264,6.017s18.549-2.142,25.274-6.017c6.442-3.723,10-8.577,10-13.664s-3.554-9.941-10-13.664m-8.292,23.2a38.007,38.007,0,0,1-16.982,3.628,37.98,37.98,0,0,1-16.975-3.628c-4.827-2.474-7.485-5.861-7.485-9.541s2.658-7.073,7.485-9.547A38.072,38.072,0,0,1,51.566,319.7a38.1,38.1,0,0,1,16.982,3.622c4.821,2.475,7.478,5.868,7.478,9.547s-2.658,7.067-7.478,9.541",
    transform: "translate(6.113 117.423)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4779",
    "data-name": "Groupe 4779",
    transform: "translate(34.49 438.387)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4778",
    "data-name": "Groupe 4778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4777",
    "data-name": "Groupe 4777",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4885",
    "data-name": "Trac\\xE9 4885",
    d: "M64.674,339.157c9.057-4.646,9.057-12.182,0-16.831s-23.741-4.646-32.8,0-9.055,12.185,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-25.084 -318.841)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4886",
    "data-name": "Trac\\xE9 4886",
    d: "M64.674,339.157c9.057-4.646,9.057-12.182,0-16.831s-23.741-4.646-32.8,0-9.055,12.185,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(9.405 119.546)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4782",
    "data-name": "Groupe 4782",
    transform: "translate(34.49 438.387)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4781",
    "data-name": "Groupe 4781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4780",
    "data-name": "Groupe 4780",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4887",
    "data-name": "Trac\\xE9 4887",
    d: "M64.674,339.157c9.057-4.646,9.057-12.182,0-16.831s-23.741-4.646-32.8,0-9.055,12.185,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-25.084 -318.841)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4888",
    "data-name": "Trac\\xE9 4888",
    d: "M64.617,324.619c-9.057-4.646-23.741-4.646-32.8,0-3.745,1.924-5.937,4.339-6.585,6.84.648,2.5,2.839,4.915,6.585,6.839,9.057,4.646,23.74,4.646,32.8,0,3.745-1.924,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.84",
    transform: "translate(9.462 120.406)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4785",
    "data-name": "Groupe 4785",
    transform: "translate(34.698 441.539)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4784",
    "data-name": "Groupe 4784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4783",
    "data-name": "Groupe 4783",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4889",
    "data-name": "Trac\\xE9 4889",
    d: "M64.617,324.619c-9.057-4.646-23.741-4.646-32.8,0-3.745,1.924-5.937,4.339-6.585,6.84.648,2.5,2.839,4.915,6.585,6.839,9.057,4.646,23.74,4.646,32.8,0,3.745-1.924,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.84",
    transform: "translate(-25.236 -321.134)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4890",
    "data-name": "Trac\\xE9 4890",
    d: "M44.451,321.508v3.4l-1.162,1.225-2.146,2.249v-3.539Z",
    transform: "translate(15.426 120.546)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4788",
    "data-name": "Groupe 4788",
    transform: "translate(56.569 442.054)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4787",
    "data-name": "Groupe 4787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4786",
    "data-name": "Groupe 4786",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4891",
    "data-name": "Trac\\xE9 4891",
    d: "M44.451,321.508v3.4l-1.162,1.225-2.146,2.249v-3.539Z",
    transform: "translate(-41.143 -321.508)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4892",
    "data-name": "Trac\\xE9 4892",
    d: "M42.775,324.025v2.007a18.987,18.987,0,0,1-3.3.938,3.552,3.552,0,0,1-1.413-.054,3.336,3.336,0,0,1-.674-.276c-.818-.49-.95-1.215.608-2.113a5.445,5.445,0,0,1,4.781-.5",
    transform: "translate(13.794 121.362)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4791",
    "data-name": "Groupe 4791",
    transform: "translate(50.585 445.046)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4790",
    "data-name": "Groupe 4790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4789",
    "data-name": "Groupe 4789",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4893",
    "data-name": "Trac\\xE9 4893",
    d: "M42.775,324.025v2.007a18.987,18.987,0,0,1-3.3.938,3.552,3.552,0,0,1-1.413-.054,3.336,3.336,0,0,1-.674-.276c-.818-.49-.95-1.215.608-2.113a5.445,5.445,0,0,1,4.781-.5",
    transform: "translate(-36.79 -323.684)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4894",
    "data-name": "Trac\\xE9 4894",
    d: "M60.129,334.19v2.935l-3.718,2.145-2.753-1.591a14.012,14.012,0,0,1-10.652.481v-2.938l1.691-1.676-1.691.466a10.874,10.874,0,0,1-8.3-.95c-1.668-.96-2.442-2.014-2.438-3.1v-2.859l.3-1.248-1.015-.591V322.33l2.751,1.591c-1.342,1.041-2.056,2.113-2.038,3.154v.033c.029,1.057.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.484.346,3.054-1,5.277-2.167,7.038-1.152,1.092.633.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.244.305l-3.516,3.485a12.655,12.655,0,0,0,1.943.571,14.491,14.491,0,0,0,8.709-1.048l2.753,1.591Z",
    transform: "translate(11.833 120.854)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4794",
    "data-name": "Groupe 4794",
    transform: "translate(44.105 446.713)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4793",
    "data-name": "Groupe 4793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4792",
    "data-name": "Groupe 4792",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4895",
    "data-name": "Trac\\xE9 4895",
    d: "M32.078,326.113v.033c.03,1.057.811,2.08,2.438,3.022,3.617,2.087,7.2,1.4,10.485.344,3.052-1,5.276-2.166,7.037-1.15,1.092.631.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.243.3l-3.516,3.487a12.615,12.615,0,0,0,1.943.569,14.466,14.466,0,0,0,8.707-1.049l2.753,1.591,3.718-2.145v2.934l-3.718,2.148-2.753-1.591a14.009,14.009,0,0,1-10.65.48v-2.937l1.69-1.677-1.69.466a10.869,10.869,0,0,1-8.3-.949c-1.668-.961-2.441-2.014-2.438-3.1v-2.857l.3-1.25",
    transform: "translate(-32.078 -324.897)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4797",
    "data-name": "Groupe 4797",
    transform: "translate(43.392 443.184)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4796",
    "data-name": "Groupe 4796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4795",
    "data-name": "Groupe 4795",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4896",
    "data-name": "Trac\\xE9 4896",
    d: "M31.559,322.33v2.938l1.015.59-.006.01a6.013,6.013,0,0,1,1.742-1.947Z",
    transform: "translate(-31.559 -322.33)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4897",
    "data-name": "Trac\\xE9 4897",
    d: "M52.473,330.24a3.424,3.424,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.826c.012.806.026,2.417.026,2.5",
    transform: "translate(18.872 122.884)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4800",
    "data-name": "Groupe 4800",
    transform: "translate(69.206 450.629)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4799",
    "data-name": "Groupe 4799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4798",
    "data-name": "Groupe 4798",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4898",
    "data-name": "Trac\\xE9 4898",
    d: "M52.473,330.24a3.424,3.424,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.826c.012.806.026,2.417.026,2.5",
    transform: "translate(-50.334 -327.745)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4899",
    "data-name": "Trac\\xE9 4899",
    d: "M59.507,334.424l-2.128-1.235a3.626,3.626,0,0,0,2.128-3.261,2.674,2.674,0,0,0-.019-.286c-.092-1.013-.837-2-2.377-2.885v-.01a9.771,9.771,0,0,0-4.947-1.29c-.139,0-.286.01-.425.01h-.045l-.443.028c-.129.01-.258.018-.386.037-.056.008-.111.008-.157.018-.1.01-.2.019-.3.037a19.611,19.611,0,0,0-2.4.5c-.378.1-.756.212-1.125.331-.533.166-1.059.341-1.556.507-.2.073-.4.137-.59.2a18.333,18.333,0,0,1-3.3.94,3.42,3.42,0,0,1-1.419-.056,2.909,2.909,0,0,1-.664-.275c-.829-.48-.958-1.209.6-2.111a5.439,5.439,0,0,1,4.782-.5l3.308-3.336a14.167,14.167,0,0,0-9.979.553l-2.755-1.585-3.751,2.165,2.755,1.585c-1.345,1.041-2.064,2.119-2.046,3.161v.027c.037,1.059.811,2.082,2.442,3.022,3.622,2.091,7.206,1.4,10.487.341,3.05-1,5.27-2.165,7.03-1.152,1.1.637.766,1.4-.461,2.11a6.057,6.057,0,0,1-5.243.3L43,335.815a13.684,13.684,0,0,0,1.944.572,12.984,12.984,0,0,0,3.393.248,15.745,15.745,0,0,0,5.314-1.3l2.755,1.594,3.714-2.146Z",
    transform: "translate(11.833 120.264)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4900",
    "data-name": "Trac\\xE9 4900",
    d: "M47.631,331.36V334.3l2.754,1.589V332.95Z",
    transform: "translate(17.859 124.24)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4803",
    "data-name": "Groupe 4803",
    transform: "translate(65.49 455.6)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4802",
    "data-name": "Groupe 4802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4801",
    "data-name": "Groupe 4801",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4901",
    "data-name": "Trac\\xE9 4901",
    d: "M47.631,331.36V334.3l2.754,1.589V332.95Z",
    transform: "translate(-47.631 -331.36)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4902",
    "data-name": "Trac\\xE9 4902",
    d: "M31.559,322.923l3.751-2.165,2.755,1.585L35.333,321.2Z",
    transform: "translate(11.833 120.264)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4903",
    "data-name": "Trac\\xE9 4903",
    d: "M37.665,325.341a5.439,5.439,0,0,1,4.781-.5l3.309-3.336L42.446,324.5a5.013,5.013,0,0,0-4.781.842",
    transform: "translate(14.122 120.546)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4904",
    "data-name": "Trac\\xE9 4904",
    d: "M39.883,332.661a13.51,13.51,0,0,0,1.944.571,12.924,12.924,0,0,0,3.393.249,11.944,11.944,0,0,1-4.782-.957l2.964-3.355Z",
    transform: "translate(14.954 123.418)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4905",
    "data-name": "Trac\\xE9 4905",
    d: "M47.631,331.511l2.754,1.242,3.712-1.794L50.385,333.1Z",
    transform: "translate(17.859 124.089)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4906",
    "data-name": "Trac\\xE9 4906",
    d: "M26.583,319.7c9.762-5.93,24.984-6.52,24.984-6.52-9.572,0-18.542,2.142-25.266,6.025-6.451,3.723-10,8.57-10,13.664,0,0,.349-7.137,10.279-13.169",
    transform: "translate(6.113 117.423)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4907",
    "data-name": "Trac\\xE9 4907",
    d: "M39.882,349.366c10.36.461,20.994-1.6,28.918-6.172,8.24-4.757,11.765-11.207,10.575-17.411,0,0,1.539,10.111-11.2,17.031s-28.295,6.552-28.295,6.552",
    transform: "translate(14.953 122.149)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4908",
    "data-name": "Trac\\xE9 4908",
    d: "M84.268,323.832a23.8,23.8,0,0,0-8.808-8.145c-14.4-8.314-37.745-8.314-52.145,0a23.784,23.784,0,0,0-8.808,8.145H12.515v7.533h.026c.265,5.239,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(4.692 116.025)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4806",
    "data-name": "Groupe 4806",
    transform: "translate(17.208 425.476)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4805",
    "data-name": "Groupe 4805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4804",
    "data-name": "Groupe 4804",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4909",
    "data-name": "Trac\\xE9 4909",
    d: "M84.268,323.832a23.8,23.8,0,0,0-8.808-8.145c-14.4-8.314-37.745-8.314-52.145,0a23.784,23.784,0,0,0-8.808,8.145H12.515v7.533h.026c.265,5.239,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(-12.515 -309.451)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4809",
    "data-name": "Groupe 4809",
    transform: "translate(17.207 425.476)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4808",
    "data-name": "Groupe 4808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4807",
    "data-name": "Groupe 4807",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4910",
    "data-name": "Trac\\xE9 4910",
    d: "M49.389,309.451c-9.438,0-18.874,2.078-26.074,6.235a23.8,23.8,0,0,0-8.808,8.145H12.515v7.533h.026c.265,5.238,3.85,10.43,10.774,14.427,7.2,4.158,16.637,6.235,26.074,6.235Z",
    transform: "translate(-12.515 -309.451)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4812",
    "data-name": "Groupe 4812",
    transform: "translate(17.207 428.933)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4811",
    "data-name": "Groupe 4811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4810",
    "data-name": "Groupe 4810",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4911",
    "data-name": "Trac\\xE9 4911",
    d: "M29.249,311.965a40.378,40.378,0,0,0-5.934,2.779,23.8,23.8,0,0,0-8.808,8.145H12.515v7.533h.026c.265,5.238,3.85,10.43,10.774,14.429a40.51,40.51,0,0,0,5.934,2.779Z",
    transform: "translate(-12.515 -311.965)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4815",
    "data-name": "Groupe 4815",
    transform: "translate(74.218 428.933)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4814",
    "data-name": "Groupe 4814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4813",
    "data-name": "Groupe 4813",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4912",
    "data-name": "Trac\\xE9 4912",
    d: "M53.979,311.965a40.378,40.378,0,0,1,5.934,2.779,23.8,23.8,0,0,1,8.808,8.145h1.992v7.533c-.265,5.238-3.876,10.43-10.8,14.429a40.51,40.51,0,0,1-5.934,2.779Z",
    transform: "translate(-53.979 -311.965)",
    fill: "#27debf"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4913",
    "data-name": "Trac\\xE9 4913",
    d: "M75.46,310.665c-14.4-8.313-37.745-8.313-52.145,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.791,0-30.106",
    transform: "translate(4.692 114.143)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4818",
    "data-name": "Groupe 4818",
    transform: "translate(17.208 418.572)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4817",
    "data-name": "Groupe 4817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4816",
    "data-name": "Groupe 4816",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4914",
    "data-name": "Trac\\xE9 4914",
    d: "M75.46,310.665c-14.4-8.313-37.745-8.313-52.145,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.791,0-30.106",
    transform: "translate(-12.515 -304.43)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4915",
    "data-name": "Trac\\xE9 4915",
    d: "M62.983,313.959A38.082,38.082,0,0,0,46,310.337a38.055,38.055,0,0,0-16.975,3.622c-4.827,2.473-7.485,5.868-7.485,9.546s2.658,7.067,7.485,9.541A37.961,37.961,0,0,0,46,336.674a37.988,37.988,0,0,0,16.982-3.628c4.822-2.474,7.48-5.861,7.48-9.541s-2.658-7.073-7.48-9.546",
    transform: "translate(8.077 116.357)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4821",
    "data-name": "Groupe 4821",
    transform: "translate(29.618 426.694)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4820",
    "data-name": "Groupe 4820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4819",
    "data-name": "Groupe 4819",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4916",
    "data-name": "Trac\\xE9 4916",
    d: "M62.983,313.959A38.082,38.082,0,0,0,46,310.337a38.055,38.055,0,0,0-16.975,3.622c-4.827,2.473-7.485,5.868-7.485,9.546s2.658,7.067,7.485,9.541A37.961,37.961,0,0,0,46,336.674a37.988,37.988,0,0,0,16.982-3.628c4.822-2.474,7.48-5.861,7.48-9.541s-2.658-7.073-7.48-9.546",
    transform: "translate(-21.541 -310.337)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4917",
    "data-name": "Trac\\xE9 4917",
    d: "M74.221,311.621c-6.723-3.884-15.7-6.026-25.274-6.026s-18.541,2.142-25.265,6.026c-6.451,3.722-10,8.569-10,13.663s3.546,9.941,10,13.664c6.723,3.875,15.694,6.017,25.265,6.017s18.551-2.142,25.274-6.017c6.443-3.723,10-8.577,10-13.664s-3.554-9.941-10-13.663m-8.292,23.2a38.007,38.007,0,0,1-16.982,3.628,37.981,37.981,0,0,1-16.975-3.628c-4.827-2.474-7.485-5.861-7.485-9.541s2.658-7.073,7.485-9.546a38.056,38.056,0,0,1,16.975-3.623,38.082,38.082,0,0,1,16.982,3.623c4.822,2.474,7.48,5.867,7.48,9.546s-2.658,7.067-7.48,9.541",
    transform: "translate(5.131 114.579)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4824",
    "data-name": "Groupe 4824",
    transform: "translate(30.889 427.958)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4823",
    "data-name": "Groupe 4823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4822",
    "data-name": "Groupe 4822",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4918",
    "data-name": "Trac\\xE9 4918",
    d: "M62.055,331.572c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.055,12.183,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-22.466 -311.256)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4919",
    "data-name": "Trac\\xE9 4919",
    d: "M62.055,331.572c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.055,12.183,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(8.423 116.702)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4827",
    "data-name": "Groupe 4827",
    transform: "translate(30.889 427.958)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4826",
    "data-name": "Groupe 4826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4825",
    "data-name": "Groupe 4825",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4920",
    "data-name": "Trac\\xE9 4920",
    d: "M62.055,331.572c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.055,12.183,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-22.466 -311.256)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4921",
    "data-name": "Trac\\xE9 4921",
    d: "M62,317.035c-9.057-4.647-23.74-4.647-32.8,0-3.745,1.922-5.937,4.338-6.585,6.839.648,2.5,2.839,4.917,6.585,6.839,9.057,4.647,23.74,4.647,32.8,0,3.745-1.922,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.839",
    transform: "translate(8.48 117.562)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4830",
    "data-name": "Groupe 4830",
    transform: "translate(31.097 431.111)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4829",
    "data-name": "Groupe 4829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4828",
    "data-name": "Groupe 4828",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4922",
    "data-name": "Trac\\xE9 4922",
    d: "M62,317.035c-9.057-4.647-23.74-4.647-32.8,0-3.745,1.922-5.937,4.338-6.585,6.839.648,2.5,2.839,4.917,6.585,6.839,9.057,4.647,23.74,4.647,32.8,0,3.745-1.922,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.839",
    transform: "translate(-22.617 -313.549)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4923",
    "data-name": "Trac\\xE9 4923",
    d: "M41.832,313.923v3.4l-1.162,1.225L38.524,320.8v-3.539Z",
    transform: "translate(14.444 117.702)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4833",
    "data-name": "Groupe 4833",
    transform: "translate(52.968 431.625)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4832",
    "data-name": "Groupe 4832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4831",
    "data-name": "Groupe 4831",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4924",
    "data-name": "Trac\\xE9 4924",
    d: "M41.832,313.923v3.4l-1.162,1.225L38.524,320.8v-3.539Z",
    transform: "translate(-38.524 -313.923)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4925",
    "data-name": "Trac\\xE9 4925",
    d: "M40.156,316.44v2.008a19.008,19.008,0,0,1-3.3.938,3.548,3.548,0,0,1-1.413-.054,3.339,3.339,0,0,1-.674-.276c-.818-.489-.95-1.215.608-2.113a5.441,5.441,0,0,1,4.781-.5",
    transform: "translate(12.812 118.518)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4836",
    "data-name": "Groupe 4836",
    transform: "translate(46.984 434.617)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4835",
    "data-name": "Groupe 4835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4834",
    "data-name": "Groupe 4834",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4926",
    "data-name": "Trac\\xE9 4926",
    d: "M40.156,316.44v2.008a19.008,19.008,0,0,1-3.3.938,3.548,3.548,0,0,1-1.413-.054,3.339,3.339,0,0,1-.674-.276c-.818-.489-.95-1.215.608-2.113a5.441,5.441,0,0,1,4.781-.5",
    transform: "translate(-34.172 -316.099)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4927",
    "data-name": "Trac\\xE9 4927",
    d: "M57.51,326.605v2.936l-3.719,2.145-2.751-1.591a14.012,14.012,0,0,1-10.652.481v-2.938l1.691-1.676-1.691.466a10.879,10.879,0,0,1-8.3-.949c-1.668-.961-2.441-2.016-2.438-3.1v-2.857l.3-1.25-1.015-.59v-2.938l2.751,1.591c-1.342,1.041-2.056,2.113-2.038,3.154v.033c.03,1.057.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.484.346,3.054-1,5.277-2.167,7.038-1.152,1.092.633.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.244.305l-3.516,3.485a12.5,12.5,0,0,0,1.943.569,14.481,14.481,0,0,0,8.709-1.046l2.751,1.591Z",
    transform: "translate(10.851 118.01)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4839",
    "data-name": "Groupe 4839",
    transform: "translate(40.504 436.285)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4838",
    "data-name": "Groupe 4838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4837",
    "data-name": "Groupe 4837",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4928",
    "data-name": "Trac\\xE9 4928",
    d: "M29.459,318.528v.033c.03,1.056.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.485.345,3.052-1,5.276-2.167,7.037-1.151,1.092.632.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.243.305l-3.516,3.485a12.454,12.454,0,0,0,1.943.569,14.483,14.483,0,0,0,8.709-1.046l2.751,1.589,3.718-2.145v2.935L53.6,330.724l-2.751-1.591a14.013,14.013,0,0,1-10.652.481v-2.938L41.884,325l-1.69.466a10.876,10.876,0,0,1-8.3-.95c-1.668-.961-2.441-2.014-2.438-3.1v-2.857l.3-1.25",
    transform: "translate(-29.459 -317.312)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4842",
    "data-name": "Groupe 4842",
    transform: "translate(39.791 432.755)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4841",
    "data-name": "Groupe 4841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4840",
    "data-name": "Groupe 4840",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4929",
    "data-name": "Trac\\xE9 4929",
    d: "M28.94,314.745v2.938l1.015.59-.006.01a6,6,0,0,1,1.742-1.947Z",
    transform: "translate(-28.94 -314.745)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4930",
    "data-name": "Trac\\xE9 4930",
    d: "M49.854,322.656a3.429,3.429,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.825c.012.806.026,2.416.026,2.5",
    transform: "translate(17.89 120.04)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4845",
    "data-name": "Groupe 4845",
    transform: "translate(65.606 440.2)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4844",
    "data-name": "Groupe 4844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4843",
    "data-name": "Groupe 4843",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4931",
    "data-name": "Trac\\xE9 4931",
    d: "M49.854,322.656a3.429,3.429,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.825c.012.806.026,2.416.026,2.5",
    transform: "translate(-47.715 -320.16)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4932",
    "data-name": "Trac\\xE9 4932",
    d: "M56.888,326.839,54.76,325.6a3.626,3.626,0,0,0,2.128-3.261c0-.1-.01-.194-.018-.286-.094-1.013-.839-2-2.379-2.885v-.01a9.767,9.767,0,0,0-4.947-1.29c-.139,0-.286.01-.425.01h-.045l-.443.028c-.129.01-.258.018-.386.037-.056.008-.111.008-.157.018a2.764,2.764,0,0,0-.3.037,19.566,19.566,0,0,0-2.4.5c-.378.1-.756.212-1.125.331-.533.166-1.059.341-1.556.507-.2.073-.4.137-.59.2a18.326,18.326,0,0,1-3.3.941,3.445,3.445,0,0,1-1.419-.055,2.975,2.975,0,0,1-.664-.276c-.829-.48-.958-1.207.6-2.111a5.439,5.439,0,0,1,4.782-.5l3.308-3.336a14.167,14.167,0,0,0-9.979.553l-2.755-1.585-3.751,2.165,2.755,1.585c-1.345,1.041-2.064,2.119-2.046,3.161v.028c.037,1.059.811,2.082,2.442,3.022,3.622,2.091,7.206,1.4,10.487.341,3.05-1,5.27-2.165,7.03-1.152,1.1.636.766,1.4-.461,2.11a6.056,6.056,0,0,1-5.243.3l-3.52,3.492a13.693,13.693,0,0,0,1.944.572,12.979,12.979,0,0,0,3.393.247,15.712,15.712,0,0,0,5.314-1.3l2.755,1.594,3.714-2.148Z",
    transform: "translate(10.851 117.421)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4933",
    "data-name": "Trac\\xE9 4933",
    d: "M45.013,323.775v2.936l2.754,1.589v-2.936Z",
    transform: "translate(16.877 121.396)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4848",
    "data-name": "Groupe 4848",
    transform: "translate(61.89 445.171)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4847",
    "data-name": "Groupe 4847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4846",
    "data-name": "Groupe 4846",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4934",
    "data-name": "Trac\\xE9 4934",
    d: "M45.013,323.775v2.936l2.754,1.589v-2.936Z",
    transform: "translate(-45.013 -323.775)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4935",
    "data-name": "Trac\\xE9 4935",
    d: "M28.94,315.338l3.751-2.166,2.755,1.585-2.732-1.142Z",
    transform: "translate(10.851 117.421)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4936",
    "data-name": "Trac\\xE9 4936",
    d: "M35.046,317.756a5.438,5.438,0,0,1,4.782-.5l3.308-3.336-3.308,2.992a5.011,5.011,0,0,0-4.782.842",
    transform: "translate(13.14 117.702)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4937",
    "data-name": "Trac\\xE9 4937",
    d: "M37.264,325.075a13.505,13.505,0,0,0,1.944.572,12.987,12.987,0,0,0,3.393.247,11.954,11.954,0,0,1-4.782-.956l2.964-3.356Z",
    transform: "translate(13.972 120.574)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4938",
    "data-name": "Trac\\xE9 4938",
    d: "M45.013,323.926l2.754,1.242,3.712-1.794-3.712,2.142Z",
    transform: "translate(16.877 121.245)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4939",
    "data-name": "Trac\\xE9 4939",
    d: "M23.964,312.115c9.762-5.93,24.984-6.52,24.984-6.52-9.572,0-18.542,2.142-25.266,6.026-6.451,3.722-10,8.569-10,13.663,0,0,.349-7.137,10.279-13.169",
    transform: "translate(5.131 114.579)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4940",
    "data-name": "Trac\\xE9 4940",
    d: "M37.263,341.781c10.36.461,20.994-1.6,28.918-6.172,8.24-4.757,11.765-11.207,10.575-17.411,0,0,1.539,10.111-11.2,17.031s-28.295,6.552-28.295,6.552",
    transform: "translate(13.971 119.305)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4941",
    "data-name": "Trac\\xE9 4941",
    d: "M126.11,369.985a23.794,23.794,0,0,0-8.808-8.145c-14.4-8.314-37.746-8.314-52.145,0a23.772,23.772,0,0,0-8.808,8.145H54.357v7.533h.026c.265,5.238,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(20.381 133.329)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4851",
    "data-name": "Groupe 4851",
    transform: "translate(74.738 488.934)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4850",
    "data-name": "Groupe 4850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4849",
    "data-name": "Groupe 4849",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4942",
    "data-name": "Trac\\xE9 4942",
    d: "M126.11,369.985a23.794,23.794,0,0,0-8.808-8.145c-14.4-8.314-37.746-8.314-52.145,0a23.772,23.772,0,0,0-8.808,8.145H54.357v7.533h.026c.265,5.238,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(-54.357 -355.604)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4854",
    "data-name": "Groupe 4854",
    transform: "translate(74.738 488.934)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4853",
    "data-name": "Groupe 4853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4852",
    "data-name": "Groupe 4852",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4943",
    "data-name": "Trac\\xE9 4943",
    d: "M91.231,355.6c-9.436,0-18.874,2.079-26.074,6.235a23.771,23.771,0,0,0-8.808,8.145H54.357v7.533h.026c.265,5.237,3.85,10.43,10.774,14.427,7.2,4.158,16.638,6.235,26.074,6.235Z",
    transform: "translate(-54.357 -355.604)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4857",
    "data-name": "Groupe 4857",
    transform: "translate(74.738 492.39)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4856",
    "data-name": "Groupe 4856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4855",
    "data-name": "Groupe 4855",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4944",
    "data-name": "Trac\\xE9 4944",
    d: "M71.091,358.117a40.39,40.39,0,0,0-5.934,2.779,23.776,23.776,0,0,0-8.808,8.146H54.357v7.533h.026C54.648,381.813,58.233,387,65.157,391a40.516,40.516,0,0,0,5.934,2.779Z",
    transform: "translate(-54.357 -358.118)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4860",
    "data-name": "Groupe 4860",
    transform: "translate(131.748 492.39)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4859",
    "data-name": "Groupe 4859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4858",
    "data-name": "Groupe 4858",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4945",
    "data-name": "Trac\\xE9 4945",
    d: "M95.821,358.117a40.391,40.391,0,0,1,5.934,2.779,23.788,23.788,0,0,1,8.808,8.146h1.992v7.533h0c-.265,5.238-3.876,10.43-10.8,14.429a40.516,40.516,0,0,1-5.934,2.779Z",
    transform: "translate(-95.821 -358.118)",
    fill: "#27debf"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4946",
    "data-name": "Trac\\xE9 4946",
    d: "M117.3,356.817c-14.4-8.314-37.746-8.314-52.145,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.793,0-30.106",
    transform: "translate(20.381 131.447)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4863",
    "data-name": "Groupe 4863",
    transform: "translate(74.738 482.029)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4862",
    "data-name": "Groupe 4862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4861",
    "data-name": "Groupe 4861",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4947",
    "data-name": "Trac\\xE9 4947",
    d: "M117.3,356.817c-14.4-8.314-37.746-8.314-52.145,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.793,0-30.106",
    transform: "translate(-54.357 -350.582)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4948",
    "data-name": "Trac\\xE9 4948",
    d: "M104.825,360.112a38.082,38.082,0,0,0-16.982-3.622,38.055,38.055,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.548s2.658,7.066,7.485,9.541a37.98,37.98,0,0,0,16.975,3.627,38.006,38.006,0,0,0,16.982-3.627c4.822-2.475,7.48-5.861,7.48-9.541s-2.658-7.074-7.48-9.548",
    transform: "translate(23.765 133.662)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4866",
    "data-name": "Groupe 4866",
    transform: "translate(87.148 490.15)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4865",
    "data-name": "Groupe 4865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4864",
    "data-name": "Groupe 4864",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4949",
    "data-name": "Trac\\xE9 4949",
    d: "M104.825,360.112a38.082,38.082,0,0,0-16.982-3.622,38.055,38.055,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.548s2.658,7.066,7.485,9.541a37.98,37.98,0,0,0,16.975,3.627,38.006,38.006,0,0,0,16.982-3.627c4.822-2.475,7.48-5.861,7.48-9.541s-2.658-7.074-7.48-9.548",
    transform: "translate(-63.383 -356.489)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4950",
    "data-name": "Trac\\xE9 4950",
    d: "M116.063,357.772c-6.723-3.883-15.7-6.025-25.274-6.025s-18.541,2.142-25.264,6.025c-6.451,3.723-10,8.57-10,13.664s3.546,9.941,10,13.664c6.723,3.875,15.694,6.017,25.264,6.017s18.551-2.142,25.274-6.017c6.442-3.723,10-8.577,10-13.664s-3.554-9.941-10-13.664m-8.292,23.2a38.007,38.007,0,0,1-16.982,3.628,37.98,37.98,0,0,1-16.975-3.628c-4.827-2.473-7.485-5.861-7.485-9.541s2.658-7.073,7.485-9.548a38.074,38.074,0,0,1,16.975-3.622,38.1,38.1,0,0,1,16.982,3.622c4.822,2.475,7.48,5.868,7.48,9.548s-2.658,7.067-7.48,9.541",
    transform: "translate(20.819 131.884)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4869",
    "data-name": "Groupe 4869",
    transform: "translate(88.419 491.415)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4868",
    "data-name": "Groupe 4868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4867",
    "data-name": "Groupe 4867",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4951",
    "data-name": "Trac\\xE9 4951",
    d: "M103.9,377.725c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.057,12.182,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-64.308 -357.409)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4952",
    "data-name": "Trac\\xE9 4952",
    d: "M103.9,377.725c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.057,12.182,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(24.111 134.006)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4872",
    "data-name": "Groupe 4872",
    transform: "translate(88.419 491.415)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4871",
    "data-name": "Groupe 4871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4870",
    "data-name": "Groupe 4870",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4953",
    "data-name": "Trac\\xE9 4953",
    d: "M103.9,377.725c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.057,12.182,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-64.308 -357.409)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4954",
    "data-name": "Trac\\xE9 4954",
    d: "M103.84,363.188c-9.057-4.647-23.74-4.647-32.8,0-3.745,1.922-5.937,4.338-6.585,6.839.648,2.5,2.839,4.917,6.585,6.839,9.057,4.647,23.74,4.647,32.8,0,3.745-1.922,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.839",
    transform: "translate(24.168 134.866)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4875",
    "data-name": "Groupe 4875",
    transform: "translate(88.627 494.568)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4874",
    "data-name": "Groupe 4874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4873",
    "data-name": "Groupe 4873",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4955",
    "data-name": "Trac\\xE9 4955",
    d: "M103.84,363.188c-9.057-4.647-23.74-4.647-32.8,0-3.745,1.922-5.937,4.338-6.585,6.839.648,2.5,2.839,4.917,6.585,6.839,9.057,4.647,23.74,4.647,32.8,0,3.745-1.922,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.839",
    transform: "translate(-64.459 -359.702)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4956",
    "data-name": "Trac\\xE9 4956",
    d: "M83.674,360.076v3.4l-1.16,1.225-2.148,2.248v-3.538Z",
    transform: "translate(30.132 135.006)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4878",
    "data-name": "Groupe 4878",
    transform: "translate(110.498 495.082)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4877",
    "data-name": "Groupe 4877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4876",
    "data-name": "Groupe 4876",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4957",
    "data-name": "Trac\\xE9 4957",
    d: "M83.674,360.076v3.4l-1.16,1.225-2.148,2.248v-3.538Z",
    transform: "translate(-80.366 -360.076)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4958",
    "data-name": "Trac\\xE9 4958",
    d: "M82,362.592V364.6a19,19,0,0,1-3.3.938,3.544,3.544,0,0,1-1.413-.054,3.342,3.342,0,0,1-.674-.276c-.818-.489-.95-1.215.608-2.113a5.445,5.445,0,0,1,4.781-.5",
    transform: "translate(28.5 135.822)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4881",
    "data-name": "Groupe 4881",
    transform: "translate(104.514 498.074)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4880",
    "data-name": "Groupe 4880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4879",
    "data-name": "Groupe 4879",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4959",
    "data-name": "Trac\\xE9 4959",
    d: "M82,362.592V364.6a19,19,0,0,1-3.3.938,3.544,3.544,0,0,1-1.413-.054,3.342,3.342,0,0,1-.674-.276c-.818-.489-.95-1.215.608-2.113a5.445,5.445,0,0,1,4.781-.5",
    transform: "translate(-76.014 -362.252)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4960",
    "data-name": "Trac\\xE9 4960",
    d: "M99.352,372.758v2.935l-3.718,2.145-2.753-1.591a14.011,14.011,0,0,1-10.652.481v-2.938l1.691-1.676-1.691.466a10.879,10.879,0,0,1-8.3-.949c-1.668-.961-2.441-2.016-2.438-3.1v-2.858l.3-1.248-1.015-.591V360.9l2.751,1.591c-1.343,1.041-2.056,2.113-2.038,3.154v.033c.03,1.057.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.484.346,3.054-1,5.277-2.167,7.038-1.152,1.092.632.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.244.305l-3.516,3.485a12.646,12.646,0,0,0,1.943.571,14.493,14.493,0,0,0,8.709-1.048l2.753,1.591Z",
    transform: "translate(26.539 135.315)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4884",
    "data-name": "Groupe 4884",
    transform: "translate(98.035 499.741)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4883",
    "data-name": "Groupe 4883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4882",
    "data-name": "Groupe 4882",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4961",
    "data-name": "Trac\\xE9 4961",
    d: "M71.3,364.681v.033c.03,1.056.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.484.345,3.054-1,5.277-2.167,7.038-1.151,1.092.632.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.243.305l-3.517,3.485a12.714,12.714,0,0,0,1.943.569,14.472,14.472,0,0,0,8.709-1.048l2.753,1.591,3.718-2.145v2.934l-3.718,2.146-2.753-1.591a14.018,14.018,0,0,1-10.652.481v-2.938l1.691-1.677-1.691.467a10.873,10.873,0,0,1-8.3-.95c-1.668-.961-2.441-2.014-2.438-3.1v-2.857l.3-1.25",
    transform: "translate(-71.301 -363.464)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4887",
    "data-name": "Groupe 4887",
    transform: "translate(97.321 496.213)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4886",
    "data-name": "Groupe 4886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4885",
    "data-name": "Groupe 4885",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4962",
    "data-name": "Trac\\xE9 4962",
    d: "M70.782,360.9v2.938l1.015.59-.006.01a6,6,0,0,1,1.742-1.947Z",
    transform: "translate(-70.782 -360.898)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4963",
    "data-name": "Trac\\xE9 4963",
    d: "M91.7,368.808a3.447,3.447,0,0,1-.276,1.4l-1.863-1.07a3.659,3.659,0,0,0,2.113-2.826c.014.806.026,2.416.026,2.5",
    transform: "translate(33.578 137.344)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4890",
    "data-name": "Groupe 4890",
    transform: "translate(123.136 503.656)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4889",
    "data-name": "Groupe 4889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4888",
    "data-name": "Groupe 4888",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4964",
    "data-name": "Trac\\xE9 4964",
    d: "M91.7,368.808a3.447,3.447,0,0,1-.276,1.4l-1.863-1.07a3.659,3.659,0,0,0,2.113-2.826c.014.806.026,2.416.026,2.5",
    transform: "translate(-89.558 -366.312)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4965",
    "data-name": "Trac\\xE9 4965",
    d: "M98.73,372.991,96.6,371.756a3.626,3.626,0,0,0,2.128-3.261c0-.1-.01-.194-.018-.286-.092-1.013-.839-2-2.377-2.885v-.01a9.778,9.778,0,0,0-4.95-1.29c-.137,0-.285.01-.423.01h-.045l-.443.027c-.129.01-.258.018-.386.037-.055.01-.111.01-.157.018-.1.01-.2.019-.3.037a20.112,20.112,0,0,0-2.4.5c-.378.1-.755.212-1.125.331-.533.166-1.059.341-1.556.507-.2.073-.4.137-.59.2a18.332,18.332,0,0,1-3.3.941,3.446,3.446,0,0,1-1.419-.055,2.97,2.97,0,0,1-.664-.276c-.829-.48-.958-1.207.6-2.11a5.438,5.438,0,0,1,4.782-.5l3.308-3.336a14.167,14.167,0,0,0-9.979.553l-2.755-1.585-3.751,2.166,2.755,1.585c-1.345,1.041-2.064,2.119-2.046,3.161v.027c.037,1.059.811,2.082,2.442,3.022,3.622,2.091,7.206,1.4,10.487.341,3.05-1,5.272-2.165,7.031-1.152,1.1.637.764,1.4-.461,2.111a6.06,6.06,0,0,1-5.244.3l-3.52,3.492a13.717,13.717,0,0,0,1.944.572,12.979,12.979,0,0,0,3.393.247,15.729,15.729,0,0,0,5.316-1.3l2.754,1.594,3.714-2.146Z",
    transform: "translate(26.539 134.725)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4966",
    "data-name": "Trac\\xE9 4966",
    d: "M86.855,369.928v2.935l2.754,1.591v-2.937Z",
    transform: "translate(32.565 138.7)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4893",
    "data-name": "Groupe 4893",
    transform: "translate(119.42 508.628)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4892",
    "data-name": "Groupe 4892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4891",
    "data-name": "Groupe 4891",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4967",
    "data-name": "Trac\\xE9 4967",
    d: "M86.855,369.928v2.935l2.754,1.591v-2.937Z",
    transform: "translate(-86.855 -369.928)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4968",
    "data-name": "Trac\\xE9 4968",
    d: "M70.782,361.491l3.751-2.166,2.755,1.585-2.731-1.143Z",
    transform: "translate(26.539 134.725)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4969",
    "data-name": "Trac\\xE9 4969",
    d: "M76.888,363.909a5.438,5.438,0,0,1,4.782-.5l3.308-3.336-3.308,2.992a5.015,5.015,0,0,0-4.782.841",
    transform: "translate(28.828 135.006)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4970",
    "data-name": "Trac\\xE9 4970",
    d: "M79.106,371.228a13.51,13.51,0,0,0,1.944.571,12.937,12.937,0,0,0,3.393.249,11.947,11.947,0,0,1-4.782-.957l2.964-3.355Z",
    transform: "translate(29.66 137.878)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4971",
    "data-name": "Trac\\xE9 4971",
    d: "M86.855,370.078l2.754,1.242,3.712-1.794-3.712,2.142Z",
    transform: "translate(32.565 138.549)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4972",
    "data-name": "Trac\\xE9 4972",
    d: "M65.806,358.267c9.762-5.93,24.984-6.52,24.984-6.52-9.572,0-18.542,2.142-25.266,6.025-6.451,3.723-10,8.57-10,13.664,0,0,.349-7.137,10.279-13.169",
    transform: "translate(20.819 131.884)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4973",
    "data-name": "Trac\\xE9 4973",
    d: "M79.105,387.934c10.36.461,20.994-1.6,28.918-6.172,8.24-4.757,11.765-11.207,10.575-17.411,0,0,1.539,10.111-11.2,17.031s-28.295,6.552-28.295,6.552",
    transform: "translate(29.66 136.609)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4974",
    "data-name": "Trac\\xE9 4974",
    d: "M127.712,362.455a23.782,23.782,0,0,0-8.808-8.145c-14.4-8.314-37.746-8.314-52.145,0a23.771,23.771,0,0,0-8.808,8.145H55.959v7.533h.026c.265,5.238,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(20.981 130.506)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4896",
    "data-name": "Groupe 4896",
    transform: "translate(76.94 478.58)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4895",
    "data-name": "Groupe 4895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4894",
    "data-name": "Groupe 4894",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4975",
    "data-name": "Trac\\xE9 4975",
    d: "M127.712,362.455a23.782,23.782,0,0,0-8.808-8.145c-14.4-8.314-37.746-8.314-52.145,0a23.771,23.771,0,0,0-8.808,8.145H55.959v7.533h.026c.265,5.238,3.85,10.43,10.774,14.427,14.4,8.314,37.745,8.314,52.145,0,6.924-4,10.535-9.19,10.8-14.427v-7.533Z",
    transform: "translate(-55.959 -348.074)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4899",
    "data-name": "Groupe 4899",
    transform: "translate(76.94 478.58)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4898",
    "data-name": "Groupe 4898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4897",
    "data-name": "Groupe 4897",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4976",
    "data-name": "Trac\\xE9 4976",
    d: "M92.833,348.074c-9.438,0-18.874,2.078-26.074,6.235a23.773,23.773,0,0,0-8.808,8.145H55.959v7.533h.026c.265,5.237,3.85,10.429,10.774,14.427,7.2,4.157,16.637,6.235,26.074,6.235Z",
    transform: "translate(-55.959 -348.074)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4902",
    "data-name": "Groupe 4902",
    transform: "translate(76.94 482.037)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4901",
    "data-name": "Groupe 4901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4900",
    "data-name": "Groupe 4900",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4977",
    "data-name": "Trac\\xE9 4977",
    d: "M72.693,350.587a40.365,40.365,0,0,0-5.934,2.779,23.776,23.776,0,0,0-8.808,8.146H55.959v7.533h.026c.265,5.237,3.85,10.429,10.774,14.427a40.384,40.384,0,0,0,5.934,2.779Z",
    transform: "translate(-55.959 -350.588)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4905",
    "data-name": "Groupe 4905",
    transform: "translate(133.95 482.037)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4904",
    "data-name": "Groupe 4904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4903",
    "data-name": "Groupe 4903",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4978",
    "data-name": "Trac\\xE9 4978",
    d: "M97.423,350.587a40.365,40.365,0,0,1,5.934,2.779,23.787,23.787,0,0,1,8.808,8.146h1.992v7.533h0c-.265,5.239-3.876,10.43-10.8,14.429a40.384,40.384,0,0,1-5.934,2.779Z",
    transform: "translate(-97.423 -350.588)",
    fill: "#27debf"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4979",
    "data-name": "Trac\\xE9 4979",
    d: "M118.9,349.287c-14.4-8.313-37.746-8.313-52.145,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.791,0-30.106",
    transform: "translate(20.981 128.624)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4908",
    "data-name": "Groupe 4908",
    transform: "translate(76.94 471.675)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4907",
    "data-name": "Groupe 4907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4906",
    "data-name": "Groupe 4906",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4980",
    "data-name": "Trac\\xE9 4980",
    d: "M118.9,349.287c-14.4-8.313-37.746-8.313-52.145,0s-14.4,21.793,0,30.106,37.745,8.314,52.145,0,14.4-21.791,0-30.106",
    transform: "translate(-55.959 -343.052)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4981",
    "data-name": "Trac\\xE9 4981",
    d: "M106.427,352.582a38.084,38.084,0,0,0-16.982-3.622,38.058,38.058,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.546s2.658,7.067,7.485,9.542A37.98,37.98,0,0,0,89.445,375.3a38.007,38.007,0,0,0,16.982-3.627c4.821-2.475,7.478-5.863,7.478-9.542s-2.658-7.073-7.478-9.546",
    transform: "translate(24.365 130.839)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4911",
    "data-name": "Groupe 4911",
    transform: "translate(89.35 479.797)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4910",
    "data-name": "Groupe 4910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4909",
    "data-name": "Groupe 4909",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4982",
    "data-name": "Trac\\xE9 4982",
    d: "M106.427,352.582a38.084,38.084,0,0,0-16.982-3.622,38.058,38.058,0,0,0-16.975,3.622c-4.827,2.474-7.485,5.868-7.485,9.546s2.658,7.067,7.485,9.542A37.98,37.98,0,0,0,89.445,375.3a38.007,38.007,0,0,0,16.982-3.627c4.821-2.475,7.478-5.863,7.478-9.542s-2.658-7.073-7.478-9.546",
    transform: "translate(-64.985 -348.959)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4983",
    "data-name": "Trac\\xE9 4983",
    d: "M117.665,350.242c-6.725-3.883-15.7-6.025-25.274-6.025s-18.541,2.142-25.265,6.025c-6.451,3.724-10,8.57-10,13.664s3.546,9.941,10,13.664c6.723,3.875,15.694,6.017,25.265,6.017s18.549-2.142,25.274-6.017c6.442-3.723,10-8.577,10-13.664s-3.554-9.941-10-13.664m-8.292,23.2a38.006,38.006,0,0,1-16.982,3.628,37.98,37.98,0,0,1-16.975-3.628c-4.827-2.474-7.485-5.861-7.485-9.541s2.658-7.073,7.485-9.547a38.074,38.074,0,0,1,16.975-3.622,38.1,38.1,0,0,1,16.982,3.622c4.821,2.475,7.478,5.868,7.478,9.547s-2.658,7.067-7.478,9.541",
    transform: "translate(21.42 129.06)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4914",
    "data-name": "Groupe 4914",
    transform: "translate(90.622 481.062)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4913",
    "data-name": "Groupe 4913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4912",
    "data-name": "Groupe 4912",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4984",
    "data-name": "Trac\\xE9 4984",
    d: "M105.5,370.2c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.055,12.183,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-65.909 -349.879)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4985",
    "data-name": "Trac\\xE9 4985",
    d: "M105.5,370.2c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.055,12.183,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(24.712 131.183)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4917",
    "data-name": "Groupe 4917",
    transform: "translate(90.622 481.062)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4916",
    "data-name": "Groupe 4916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4915",
    "data-name": "Groupe 4915",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4986",
    "data-name": "Trac\\xE9 4986",
    d: "M105.5,370.2c9.057-4.647,9.057-12.183,0-16.831s-23.741-4.649-32.8,0-9.055,12.183,0,16.831,23.74,4.647,32.8,0",
    transform: "translate(-65.909 -349.879)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4987",
    "data-name": "Trac\\xE9 4987",
    d: "M105.442,355.657c-9.057-4.647-23.74-4.647-32.8,0C68.9,357.58,66.709,360,66.061,362.5c.648,2.5,2.839,4.917,6.585,6.839,9.057,4.647,23.74,4.647,32.8,0,3.745-1.922,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.839",
    transform: "translate(24.769 132.043)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4920",
    "data-name": "Groupe 4920",
    transform: "translate(90.83 484.215)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4919",
    "data-name": "Groupe 4919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4918",
    "data-name": "Groupe 4918",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4988",
    "data-name": "Trac\\xE9 4988",
    d: "M105.442,355.657c-9.057-4.647-23.74-4.647-32.8,0C68.9,357.58,66.709,360,66.061,362.5c.648,2.5,2.839,4.917,6.585,6.839,9.057,4.647,23.74,4.647,32.8,0,3.745-1.922,5.937-4.338,6.585-6.839-.648-2.5-2.839-4.917-6.585-6.839",
    transform: "translate(-66.061 -352.172)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4989",
    "data-name": "Trac\\xE9 4989",
    d: "M85.276,352.546v3.4l-1.16,1.225-2.148,2.249v-3.539Z",
    transform: "translate(30.733 132.183)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4923",
    "data-name": "Groupe 4923",
    transform: "translate(112.701 484.729)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4922",
    "data-name": "Groupe 4922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4921",
    "data-name": "Groupe 4921",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4990",
    "data-name": "Trac\\xE9 4990",
    d: "M85.276,352.546v3.4l-1.16,1.225-2.148,2.249v-3.539Z",
    transform: "translate(-81.968 -352.546)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4991",
    "data-name": "Trac\\xE9 4991",
    d: "M83.6,355.062v2.007a18.987,18.987,0,0,1-3.3.938,3.549,3.549,0,0,1-1.413-.054,3.335,3.335,0,0,1-.674-.276c-.818-.49-.95-1.215.608-2.113a5.441,5.441,0,0,1,4.781-.5",
    transform: "translate(29.101 132.999)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4926",
    "data-name": "Groupe 4926",
    transform: "translate(106.716 487.721)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4925",
    "data-name": "Groupe 4925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4924",
    "data-name": "Groupe 4924",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4992",
    "data-name": "Trac\\xE9 4992",
    d: "M83.6,355.062v2.007a18.987,18.987,0,0,1-3.3.938,3.549,3.549,0,0,1-1.413-.054,3.335,3.335,0,0,1-.674-.276c-.818-.49-.95-1.215.608-2.113a5.441,5.441,0,0,1,4.781-.5",
    transform: "translate(-77.615 -354.722)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4993",
    "data-name": "Trac\\xE9 4993",
    d: "M100.954,365.227v2.935l-3.719,2.145-2.751-1.591a14.012,14.012,0,0,1-10.652.481V366.26l1.691-1.676-1.691.466a10.88,10.88,0,0,1-8.3-.949c-1.668-.961-2.44-2.014-2.438-3.1v-2.858l.3-1.248-1.015-.591v-2.938l2.751,1.591c-1.343,1.042-2.056,2.113-2.038,3.154v.033c.029,1.057.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.484.346,3.054-1,5.277-2.167,7.038-1.152,1.092.632.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.244.305l-3.516,3.485a12.656,12.656,0,0,0,1.943.571,14.493,14.493,0,0,0,8.709-1.048l2.751,1.591Z",
    transform: "translate(27.14 132.491)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4929",
    "data-name": "Groupe 4929",
    transform: "translate(100.237 489.387)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4928",
    "data-name": "Groupe 4928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4927",
    "data-name": "Groupe 4927",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4994",
    "data-name": "Trac\\xE9 4994",
    d: "M72.9,357.151v.033c.03,1.056.811,2.08,2.438,3.021,3.617,2.089,7.2,1.4,10.484.345,3.054-1,5.277-2.167,7.038-1.151,1.092.632.76,1.4-.466,2.109a6.1,6.1,0,0,1-5.244.305L83.637,365.3a12.493,12.493,0,0,0,1.944.569,14.48,14.48,0,0,0,8.708-1.046l2.753,1.589,3.718-2.145V367.2l-3.718,2.145-2.753-1.591a14.012,14.012,0,0,1-10.652.481V365.3l1.691-1.676-1.691.466a10.873,10.873,0,0,1-8.3-.95c-1.668-.961-2.44-2.014-2.438-3.1v-2.857l.3-1.25",
    transform: "translate(-72.903 -355.934)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4932",
    "data-name": "Groupe 4932",
    transform: "translate(99.524 485.859)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4931",
    "data-name": "Groupe 4931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4930",
    "data-name": "Groupe 4930",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4995",
    "data-name": "Trac\\xE9 4995",
    d: "M72.384,353.368v2.938l1.015.59-.005.01a6,6,0,0,1,1.742-1.947Z",
    transform: "translate(-72.384 -353.368)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4996",
    "data-name": "Trac\\xE9 4996",
    d: "M93.3,361.278a3.428,3.428,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.826c.012.806.026,2.416.026,2.5",
    transform: "translate(34.179 134.521)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4935",
    "data-name": "Groupe 4935",
    transform: "translate(125.338 493.303)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4934",
    "data-name": "Groupe 4934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4933",
    "data-name": "Groupe 4933",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4997",
    "data-name": "Trac\\xE9 4997",
    d: "M93.3,361.278a3.428,3.428,0,0,1-.278,1.4l-1.862-1.07a3.659,3.659,0,0,0,2.113-2.826c.012.806.026,2.416.026,2.5",
    transform: "translate(-91.159 -358.782)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4998",
    "data-name": "Trac\\xE9 4998",
    d: "M100.332,365.461,98.2,364.226a3.626,3.626,0,0,0,2.128-3.261,2.672,2.672,0,0,0-.019-.286c-.091-1.013-.837-2-2.377-2.884v-.01a9.771,9.771,0,0,0-4.947-1.29c-.139,0-.286.01-.425.01h-.045l-.443.028c-.129.01-.258.018-.386.037-.056.01-.111.01-.157.018a2.747,2.747,0,0,0-.3.037,19.819,19.819,0,0,0-2.4.5c-.378.1-.756.212-1.125.331-.533.166-1.059.341-1.556.507-.2.073-.4.137-.59.2a18.284,18.284,0,0,1-3.3.94,3.446,3.446,0,0,1-1.419-.055,2.924,2.924,0,0,1-.663-.278c-.829-.479-.958-1.206.6-2.109a5.437,5.437,0,0,1,4.782-.5l3.308-3.336a14.167,14.167,0,0,0-9.979.553L76.135,351.8l-3.751,2.166,2.755,1.585c-1.345,1.041-2.064,2.119-2.046,3.161v.028c.037,1.059.811,2.082,2.442,3.022,3.622,2.091,7.206,1.4,10.487.341,3.05-1,5.27-2.165,7.03-1.152,1.1.637.766,1.4-.461,2.11a6.056,6.056,0,0,1-5.243.3l-3.52,3.492a13.694,13.694,0,0,0,1.944.572,12.979,12.979,0,0,0,3.393.247,15.715,15.715,0,0,0,5.314-1.3l2.755,1.594,3.714-2.148Z",
    transform: "translate(27.14 131.902)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4999",
    "data-name": "Trac\\xE9 4999",
    d: "M88.456,362.4v2.935l2.754,1.589v-2.935Z",
    transform: "translate(33.166 135.877)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4938",
    "data-name": "Groupe 4938",
    transform: "translate(121.622 498.274)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4937",
    "data-name": "Groupe 4937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4936",
    "data-name": "Groupe 4936",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5000",
    "data-name": "Trac\\xE9 5000",
    d: "M88.456,362.4v2.935l2.754,1.589v-2.935Z",
    transform: "translate(-88.456 -362.397)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5001",
    "data-name": "Trac\\xE9 5001",
    d: "M72.384,353.961l3.751-2.166,2.755,1.585-2.732-1.143Z",
    transform: "translate(27.14 131.902)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5002",
    "data-name": "Trac\\xE9 5002",
    d: "M78.489,356.379a5.438,5.438,0,0,1,4.782-.5l3.308-3.336-3.308,2.992a5.012,5.012,0,0,0-4.782.841",
    transform: "translate(29.429 132.183)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5003",
    "data-name": "Trac\\xE9 5003",
    d: "M80.708,363.7a13.676,13.676,0,0,0,1.944.572,12.976,12.976,0,0,0,3.393.247,11.959,11.959,0,0,1-4.782-.956l2.964-3.356Z",
    transform: "translate(30.261 135.055)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5004",
    "data-name": "Trac\\xE9 5004",
    d: "M88.456,362.548l2.754,1.242L94.923,362l-3.712,2.142Z",
    transform: "translate(33.166 135.726)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5005",
    "data-name": "Trac\\xE9 5005",
    d: "M67.407,350.737c9.762-5.93,24.984-6.52,24.984-6.52-9.572,0-18.542,2.142-25.266,6.025-6.451,3.724-10,8.57-10,13.664,0,0,.349-7.137,10.279-13.169",
    transform: "translate(21.419 129.06)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5006",
    "data-name": "Trac\\xE9 5006",
    d: "M80.707,380.4c10.36.461,20.994-1.6,28.918-6.172,8.24-4.757,11.765-11.207,10.575-17.411,0,0,1.539,10.111-11.2,17.031S80.707,380.4,80.707,380.4",
    transform: "translate(30.26 133.786)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4942",
    "data-name": "Groupe 4942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4941",
    "data-name": "Groupe 4941",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5007",
    "data-name": "Trac\\xE9 5007",
    d: "M192.539,489.706v-6.3a.356.356,0,0,0-.355-.355H181.017v-6.3a.356.356,0,0,0-.355-.355H169.5v-6.3a.353.353,0,0,0-.353-.353H157.977v-6.3a.356.356,0,0,0-.355-.355H146.457v-6.3a.354.354,0,0,0-.355-.353H134.936v-6.3a.355.355,0,0,0-.355-.355H123.418v-6.092l258.5-149.245V300.5a.356.356,0,0,0,.355.355h11.165v6.3a.355.355,0,0,0,.355.355h11.166v6.3a.355.355,0,0,0,.355.355h11.165v6.3a.356.356,0,0,0,.355.355H428v6.3a.356.356,0,0,0,.355.355h11.164v6.3a.356.356,0,0,0,.355.355h11.167v6.3a.355.355,0,0,0,.353.355h10.2L203.608,489.706Z",
    transform: "translate(46.274 110.405)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5008",
    "data-name": "Trac\\xE9 5008",
    d: "M381.657,295.244v5.423a.709.709,0,0,0,.71.709h10.811v5.942a.708.708,0,0,0,.708.71H404.7v5.942a.709.709,0,0,0,.708.71h10.811v5.941a.709.709,0,0,0,.71.709h10.811v5.942a.709.709,0,0,0,.709.708h10.811v5.943a.708.708,0,0,0,.708.709h10.813v5.942a.709.709,0,0,0,.71.708h8.874L203.611,489.52h-10.62v-5.942a.709.709,0,0,0-.709-.709H181.47v-5.943a.709.709,0,0,0-.709-.708H169.95v-5.943a.708.708,0,0,0-.708-.708H158.429v-5.943a.709.709,0,0,0-.709-.709H146.91v-5.942a.709.709,0,0,0-.709-.71H135.388v-5.941a.708.708,0,0,0-.708-.709H123.868v-5.533Zm.708-1.228L123.159,443.67v6.651H134.68v6.651H146.2v6.652h11.519v6.651h11.522v6.651h11.519v6.652h11.521v6.651H203.8L463.008,340.576H451.489v-6.652H439.967v-6.651H428.448v-6.652H416.927V313.97H405.406v-6.652H393.886v-6.651H382.367Z",
    transform: "translate(46.177 110.238)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5009",
    "data-name": "Trac\\xE9 5009",
    d: "M346.628,335.125a1.408,1.408,0,0,1-.708-.19L311.359,314.98a1.418,1.418,0,1,1,1.418-2.456l34.563,19.954a1.419,1.419,0,0,1-.711,2.647",
    transform: "translate(116.474 117.106)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5010",
    "data-name": "Trac\\xE9 5010",
    d: "M349.53,340.648a.536.536,0,0,1-.265-.07l-46.084-26.606a.532.532,0,0,1,.531-.923L349.8,339.656a.532.532,0,0,1-.265.993",
    transform: "translate(113.574 117.348)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5011",
    "data-name": "Trac\\xE9 5011",
    d: "M345.341,343.066a.545.545,0,0,1-.267-.07L298.991,316.39a.532.532,0,0,1-.2-.727.538.538,0,0,1,.727-.2l46.084,26.607a.532.532,0,0,1-.265.993",
    transform: "translate(112.003 118.255)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5012",
    "data-name": "Trac\\xE9 5012",
    d: "M327.01,342.159a.539.539,0,0,1-.265-.07l-40.32-23.28a.532.532,0,0,1,.531-.923l40.32,23.281a.532.532,0,0,1-.265.993",
    transform: "translate(107.292 119.162)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5013",
    "data-name": "Trac\\xE9 5013",
    d: "M331.726,344.881a.539.539,0,0,1-.265-.07l-11.521-6.652a.533.533,0,0,1-.2-.727.538.538,0,0,1,.727-.2l11.519,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(119.858 126.417)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5014",
    "data-name": "Trac\\xE9 5014",
    d: "M322.82,344.578a.539.539,0,0,1-.265-.07l-40.32-23.279a.533.533,0,0,1,.531-.924l40.32,23.282a.531.531,0,0,1-.265.991",
    transform: "translate(105.721 120.068)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5015",
    "data-name": "Trac\\xE9 5015",
    d: "M327.534,347.3a.539.539,0,0,1-.265-.07l-11.519-6.652a.532.532,0,0,1-.2-.727.538.538,0,0,1,.727-.2l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(118.287 127.324)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5016",
    "data-name": "Trac\\xE9 5016",
    d: "M318.63,347a.54.54,0,0,1-.265-.07l-40.32-23.28a.532.532,0,0,1,.531-.923l40.32,23.281a.532.532,0,0,1-.265.993",
    transform: "translate(104.15 120.976)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5017",
    "data-name": "Trac\\xE9 5017",
    d: "M323.344,349.718a.54.54,0,0,1-.265-.07L311.56,343a.533.533,0,0,1-.2-.727.539.539,0,0,1,.727-.2l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(116.716 128.231)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5018",
    "data-name": "Trac\\xE9 5018",
    d: "M314.44,349.417a.54.54,0,0,1-.265-.07l-40.322-23.281a.533.533,0,0,1,.532-.923l40.32,23.281a.532.532,0,0,1-.265.993",
    transform: "translate(102.578 121.883)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5019",
    "data-name": "Trac\\xE9 5019",
    d: "M319.154,352.139a.54.54,0,0,1-.265-.07l-11.519-6.652a.532.532,0,1,1,.532-.922l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(115.145 129.138)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5020",
    "data-name": "Trac\\xE9 5020",
    d: "M310.249,351.836a.54.54,0,0,1-.265-.07l-40.319-23.28a.532.532,0,0,1,.531-.923l40.319,23.281a.532.532,0,0,1-.265.993",
    transform: "translate(101.008 122.79)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5021",
    "data-name": "Trac\\xE9 5021",
    d: "M314.964,354.558a.54.54,0,0,1-.265-.07l-11.519-6.652a.533.533,0,1,1,.532-.923l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(113.574 130.045)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5022",
    "data-name": "Trac\\xE9 5022",
    d: "M306.06,354.255a.54.54,0,0,1-.266-.07l-40.32-23.279a.532.532,0,1,1,.531-.923l40.32,23.281a.529.529,0,0,1,.2.726.535.535,0,0,1-.461.265",
    transform: "translate(99.437 123.697)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5023",
    "data-name": "Trac\\xE9 5023",
    d: "M310.774,356.976a.54.54,0,0,1-.265-.07l-11.519-6.652a.532.532,0,0,1-.2-.727.539.539,0,0,1,.727-.2l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(112.003 130.952)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5024",
    "data-name": "Trac\\xE9 5024",
    d: "M301.87,356.676a.541.541,0,0,1-.265-.07l-40.32-23.282a.532.532,0,0,1,.531-.922l40.32,23.282a.532.532,0,0,1-.265.993",
    transform: "translate(97.866 124.604)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5025",
    "data-name": "Trac\\xE9 5025",
    d: "M306.584,359.4a.541.541,0,0,1-.265-.07L294.8,352.673a.533.533,0,0,1-.2-.727.538.538,0,0,1,.727-.2L306.85,358.4a.532.532,0,0,1-.265.993",
    transform: "translate(110.432 131.859)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5026",
    "data-name": "Trac\\xE9 5026",
    d: "M297.68,359.094a.539.539,0,0,1-.265-.07l-40.322-23.282a.532.532,0,1,1,.532-.922l40.32,23.282a.532.532,0,0,1-.265.993",
    transform: "translate(96.295 125.511)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5027",
    "data-name": "Trac\\xE9 5027",
    d: "M302.395,361.814a.547.547,0,0,1-.265-.07l-11.521-6.651a.532.532,0,0,1-.2-.727.54.54,0,0,1,.727-.2l11.519,6.651a.532.532,0,0,1-.265.993",
    transform: "translate(108.86 132.767)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5028",
    "data-name": "Trac\\xE9 5028",
    d: "M293.49,361.512a.54.54,0,0,1-.265-.07L252.9,338.162a.532.532,0,1,1,.531-.923l40.32,23.28a.532.532,0,0,1-.265.993",
    transform: "translate(94.724 126.418)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5029",
    "data-name": "Trac\\xE9 5029",
    d: "M298.206,364.234a.541.541,0,0,1-.265-.07l-11.521-6.652a.532.532,0,0,1,.532-.923l11.519,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(107.29 133.673)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5030",
    "data-name": "Trac\\xE9 5030",
    d: "M289.3,363.931a.553.553,0,0,1-.265-.069l-40.321-23.28a.533.533,0,0,1,.532-.924l40.32,23.282a.531.531,0,0,1,.2.727.537.537,0,0,1-.461.264",
    transform: "translate(93.153 127.325)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5031",
    "data-name": "Trac\\xE9 5031",
    d: "M294.014,366.653a.538.538,0,0,1-.265-.07l-11.519-6.652a.532.532,0,0,1-.2-.727.537.537,0,0,1,.727-.2l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(105.719 134.58)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5032",
    "data-name": "Trac\\xE9 5032",
    d: "M285.11,366.351a.539.539,0,0,1-.265-.07L244.525,343a.532.532,0,1,1,.531-.923l40.32,23.28a.532.532,0,0,1-.265.993",
    transform: "translate(91.582 128.232)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5033",
    "data-name": "Trac\\xE9 5033",
    d: "M289.824,369.071a.54.54,0,0,1-.265-.07l-11.519-6.652a.533.533,0,0,1-.2-.727.539.539,0,0,1,.727-.2l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(104.148 135.487)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5034",
    "data-name": "Trac\\xE9 5034",
    d: "M280.92,368.77a.541.541,0,0,1-.265-.07l-40.32-23.281a.532.532,0,0,1,.531-.923l40.32,23.28a.532.532,0,0,1-.265.993",
    transform: "translate(90.011 129.139)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5035",
    "data-name": "Trac\\xE9 5035",
    d: "M285.634,371.492a.539.539,0,0,1-.265-.07l-11.519-6.652a.532.532,0,1,1,.532-.922L285.9,370.5a.532.532,0,0,1-.265.993",
    transform: "translate(102.577 136.394)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5036",
    "data-name": "Trac\\xE9 5036",
    d: "M276.73,371.189a.541.541,0,0,1-.267-.07l-40.319-23.281a.532.532,0,0,1,.531-.922L277,370.2a.532.532,0,0,1-.265.993",
    transform: "translate(88.44 130.046)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5037",
    "data-name": "Trac\\xE9 5037",
    d: "M281.444,373.911a.539.539,0,0,1-.265-.07l-11.519-6.652a.533.533,0,0,1,.532-.923l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(101.006 137.301)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5038",
    "data-name": "Trac\\xE9 5038",
    d: "M272.54,373.608a.536.536,0,0,1-.265-.07l-40.321-23.281a.532.532,0,1,1,.532-.922l40.32,23.28a.532.532,0,0,1-.265.993",
    transform: "translate(86.869 130.953)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5039",
    "data-name": "Trac\\xE9 5039",
    d: "M277.254,376.329a.538.538,0,0,1-.265-.07l-11.519-6.652a.531.531,0,0,1-.2-.727.539.539,0,0,1,.727-.2l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(99.435 138.208)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5040",
    "data-name": "Trac\\xE9 5040",
    d: "M268.35,376.028a.539.539,0,0,1-.265-.07l-40.321-23.28a.533.533,0,0,1,.532-.923l40.32,23.281a.532.532,0,0,1-.265.993",
    transform: "translate(85.298 131.86)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5041",
    "data-name": "Trac\\xE9 5041",
    d: "M273.064,378.749a.539.539,0,0,1-.265-.07l-11.519-6.652a.533.533,0,1,1,.532-.923l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(97.864 139.115)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5042",
    "data-name": "Trac\\xE9 5042",
    d: "M264.16,378.447a.536.536,0,0,1-.265-.07L223.574,355.1a.533.533,0,0,1,.532-.923l40.32,23.282a.532.532,0,0,1-.265.993",
    transform: "translate(83.727 132.767)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5043",
    "data-name": "Trac\\xE9 5043",
    d: "M268.876,381.169a.541.541,0,0,1-.267-.07l-11.521-6.652a.533.533,0,1,1,.532-.923l11.519,6.652a.532.532,0,0,1-.264.993",
    transform: "translate(96.293 140.023)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5044",
    "data-name": "Trac\\xE9 5044",
    d: "M259.97,380.867a.54.54,0,0,1-.265-.07l-40.32-23.282a.532.532,0,0,1,.531-.923l40.32,23.282a.532.532,0,0,1-.265.993",
    transform: "translate(82.156 133.674)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5045",
    "data-name": "Trac\\xE9 5045",
    d: "M264.686,383.587a.538.538,0,0,1-.265-.07L252.9,376.865a.533.533,0,0,1-.2-.727.539.539,0,0,1,.727-.2l11.519,6.652a.532.532,0,0,1-.266.993",
    transform: "translate(94.722 140.93)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5046",
    "data-name": "Trac\\xE9 5046",
    d: "M255.78,383.284a.536.536,0,0,1-.265-.07l-40.321-23.28a.532.532,0,1,1,.532-.922l40.32,23.28a.532.532,0,0,1-.265.993",
    transform: "translate(80.585 134.581)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5047",
    "data-name": "Trac\\xE9 5047",
    d: "M260.494,386.006a.539.539,0,0,1-.265-.07l-11.519-6.652a.532.532,0,1,1,.532-.922l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(93.151 141.836)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5048",
    "data-name": "Trac\\xE9 5048",
    d: "M247.414,388.116a.541.541,0,0,1-.267-.07l-40.319-23.281a.532.532,0,0,1-.2-.727.538.538,0,0,1,.729-.2l40.319,23.28a.532.532,0,0,1-.264.993",
    transform: "translate(77.447 136.393)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5049",
    "data-name": "Trac\\xE9 5049",
    d: "M252.126,390.837a.539.539,0,0,1-.265-.07l-11.519-6.652a.532.532,0,0,1,.532-.922l11.518,6.652a.532.532,0,0,1-.265.993",
    transform: "translate(90.013 143.648)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5050",
    "data-name": "Trac\\xE9 5050",
    d: "M234.562,391.36a1.409,1.409,0,0,1-.708-.19l-23.04-13.3a1.418,1.418,0,1,1,1.418-2.457l23.041,13.3a1.419,1.419,0,0,1-.711,2.647",
    transform: "translate(78.776 140.685)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5051",
    "data-name": "Trac\\xE9 5051",
    d: "M243.73,410.177a.539.539,0,0,1-.265-.07l-57.574-33.242a.532.532,0,0,1-.2-.727.539.539,0,0,1,.727-.2L244,409.185a.532.532,0,0,1-.265.993",
    transform: "translate(69.598 140.93)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5052",
    "data-name": "Trac\\xE9 5052",
    d: "M239.449,412.543a.54.54,0,0,1-.265-.07l-57.574-33.24a.532.532,0,1,1,.532-.921l57.573,33.239a.532.532,0,0,1-.265.993",
    transform: "translate(67.993 141.817)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5053",
    "data-name": "Trac\\xE9 5053",
    d: "M235.169,414.909a.54.54,0,0,1-.265-.07L177.33,381.6a.532.532,0,0,1-.2-.727.538.538,0,0,1,.727-.2l57.573,33.24a.532.532,0,0,1-.265.993",
    transform: "translate(66.388 142.704)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5054",
    "data-name": "Trac\\xE9 5054",
    d: "M230.888,417.275a.539.539,0,0,1-.265-.07l-57.574-33.242a.532.532,0,1,1,.532-.921l57.573,33.241a.532.532,0,0,1-.265.993",
    transform: "translate(64.783 143.591)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5055",
    "data-name": "Trac\\xE9 5055",
    d: "M206.015,431.938a.54.54,0,0,1-.265-.07l-57.576-33.241a.533.533,0,0,1-.2-.727.538.538,0,0,1,.727-.2l57.574,33.241a.532.532,0,0,1-.265.993",
    transform: "translate(55.456 149.089)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5056",
    "data-name": "Trac\\xE9 5056",
    d: "M201.734,434.305a.54.54,0,0,1-.265-.07l-57.576-33.242a.532.532,0,1,1,.532-.921L202,433.313a.532.532,0,0,1-.265.993",
    transform: "translate(53.851 149.976)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5057",
    "data-name": "Trac\\xE9 5057",
    d: "M208.138,413.815a.54.54,0,0,1-.265-.07L173.311,393.79a.532.532,0,1,1,.532-.923l34.56,19.954a.532.532,0,0,1-.265.993",
    transform: "translate(64.881 147.275)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5058",
    "data-name": "Trac\\xE9 5058",
    d: "M203.949,416.176a.54.54,0,0,1-.265-.07l-34.563-19.955a.534.534,0,0,1-.2-.727.539.539,0,0,1,.727-.2l34.562,19.955a.532.532,0,0,1-.265.993",
    transform: "translate(63.31 148.161)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5059",
    "data-name": "Trac\\xE9 5059",
    d: "M199.759,418.537a.54.54,0,0,1-.265-.07l-34.562-19.955a.532.532,0,1,1,.532-.922l34.56,19.954a.532.532,0,0,1-.265.993",
    transform: "translate(61.739 149.046)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4983",
    "data-name": "Groupe 4983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4982",
    "data-name": "Groupe 4982",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5060",
    "data-name": "Trac\\xE9 5060",
    d: "M404.828,345.468c-.166,2.828-.476,5.376.682,8.46,1.664,4.427,5.031,6.4,7.019,8.12a33.572,33.572,0,0,1,5.828,6.784,29.008,29.008,0,0,0,6.088,7.3c1.888,1.57,7.113,1.609,9.61.5s3.322-2.073,3.087-6.094c-.231-3.925-12.457-5.145-12.457-5.145Z",
    transform: "translate(151.723 129.529)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5061",
    "data-name": "Trac\\xE9 5061",
    d: "M435.156,359.913c1.048.373,1.352,2.348,1.588,6.285.179,2.979,1.519,7.317-2.549,9.279-3.282,1.583-8.6.681-10.891-2.084-2.863-3.451-4.814-6.5-8.885-10.7-3.532-3.642-7.158-4.82-8.842-12.209-1.084-4.75-.347-6.741,2.835-8.173,4.376-1.97,11.433,4.037,14.911,4.935,2.995.774,10.785,12.295,11.833,12.667",
    transform: "translate(151.891 128.198)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4945",
    "data-name": "Groupe 4945",
    transform: "translate(557 470.113)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4944",
    "data-name": "Groupe 4944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4943",
    "data-name": "Groupe 4943",
    clipPath: "url(#clip-path-133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5062",
    "data-name": "Trac\\xE9 5062",
    d: "M435.156,359.913c1.048.373,1.352,2.348,1.588,6.285.179,2.979,1.519,7.317-2.549,9.279-3.282,1.583-8.6.681-10.891-2.084-2.863-3.451-4.814-6.5-8.885-10.7-3.532-3.642-7.158-4.82-8.842-12.209-1.084-4.75-.347-6.741,2.835-8.173,4.376-1.97,11.433,4.037,14.911,4.935,2.995.774,10.785,12.295,11.833,12.667",
    transform: "translate(-405.109 -341.916)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5063",
    "data-name": "Trac\\xE9 5063",
    d: "M421.117,345.844c-.186-.048-.386-.117-.591-.192a11.378,11.378,0,0,0-9.429,6.458c-.564,1.31,1.272,2.284,2.331,1.253,2.368-4.95,7.41-6.138,9.422-6.42a5.069,5.069,0,0,0-1.732-1.1",
    transform: "translate(154.097 129.598)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5064",
    "data-name": "Trac\\xE9 5064",
    d: "M422.88,347.384a11.3,11.3,0,0,0-8.753,6.391c-.562,1.31,1.273,2.285,2.332,1.253a11.634,11.634,0,0,1,7.843-6.1c-.485-.55-.964-1.072-1.422-1.539",
    transform: "translate(155.233 130.248)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5065",
    "data-name": "Trac\\xE9 5065",
    d: "M365.371,392.149c-.608,3.353.637,5.071,5,7.471s11.14,3.12,18.212.907,10.41-5.386,13.352-6.184,10.254-1.008,13.16-1.922,2.83-2.412,2.743-5.924Z",
    transform: "translate(136.938 144.913)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5066",
    "data-name": "Trac\\xE9 5066",
    d: "M414.559,374.224a81.6,81.6,0,0,1,2.293,7.843c.653,2.914,1.6,7.784.623,10s-4.946,3.722-11.138,3.8c-4.012.049-10.209,2.9-14.44,5.372-4.371,2.556-9.167,2.661-13.854,2.207-5.522-.538-11.3-3.619-12.232-5.881s-1.2-3.971,11.673-9.766c.117-.054,14.955-5.868,21.1-12.927Z",
    transform: "translate(137.011 140.311)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4948",
    "data-name": "Groupe 4948",
    transform: "translate(502.436 514.536)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4947",
    "data-name": "Groupe 4947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4946",
    "data-name": "Groupe 4946",
    clipPath: "url(#clip-path-134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5067",
    "data-name": "Trac\\xE9 5067",
    d: "M414.559,374.224a81.6,81.6,0,0,1,2.293,7.843c.653,2.914,1.6,7.784.623,10s-4.946,3.722-11.138,3.8c-4.012.049-10.209,2.9-14.44,5.372-4.371,2.556-9.167,2.661-13.854,2.207-5.522-.538-11.3-3.619-12.232-5.881s-1.2-3.971,11.673-9.766c.117-.054,14.955-5.868,21.1-12.927Z",
    transform: "translate(-365.424 -374.225)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5068",
    "data-name": "Trac\\xE9 5068",
    d: "M390.2,398.553s-1.336-11.127-10.465-14.134c-8.25-2.718-15.282,3.5-14.379,8.758.606,3.539,10.742,11.4,24.844,5.376",
    transform: "translate(136.956 143.886)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5069",
    "data-name": "Trac\\xE9 5069",
    d: "M377.429,383.125a10.556,10.556,0,0,1,6.241,2.623c2.658,2.146,2.762,3.607,2.762,3.607a1.374,1.374,0,0,0,2.341-1.178s-.72-5.611-8.145-6.615a3.016,3.016,0,0,0-3.2,1.563",
    transform: "translate(141.513 143.045)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5070",
    "data-name": "Trac\\xE9 5070",
    d: "M381.162,381.245a9.269,9.269,0,0,1,6.3,2.357c2.658,2.146,2.707,3.873,2.707,3.873a1.374,1.374,0,0,0,2.342-1.178s-.722-5.611-8.145-6.615a3.016,3.016,0,0,0-3.2,1.563",
    transform: "translate(142.912 142.34)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5071",
    "data-name": "Trac\\xE9 5071",
    d: "M384.859,379.086a9.271,9.271,0,0,1,6.442,1.921c2.8,1.959,2.966,3.679,2.966,3.679a1.374,1.374,0,0,0,2.255-1.335s-1.1-5.549-8.577-6.043a3.018,3.018,0,0,0-3.085,1.778",
    transform: "translate(144.298 141.46)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5072",
    "data-name": "Trac\\xE9 5072",
    d: "M430.428,350.369l.15,7.564s-4.951,3.965-12.216.575c-.22-.462-.982-7.877-.982-7.877Z",
    transform: "translate(156.492 131.367)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5073",
    "data-name": "Trac\\xE9 5073",
    d: "M405.44,370.421s.055,3.59.113,5.641-2.3,5.156-8.577,5.058c-4.408-.07-7.507-1.192-7.405-4.823l-.1-5.229Z",
    transform: "translate(146.026 138.885)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5074",
    "data-name": "Trac\\xE9 5074",
    d: "M451.583,337.986c-.729-15.945-4.151-22.88-4.151-22.88s.826-19.729,2.995-43.909c3.3-36.81.382-42.264-7.195-58.644,0,0-61.036-6.653-62.406,19.079-1.708,32.046-1.985,93.188-.91,104.475s1.827,15.656,5.031,38.482c2.535,18.054,8.338,55.961,8.338,55.961,8.295,4.27,15.975-.648,15.975-.648s3.855-59.892,3.063-72.925c-.968-15.914-1.953-19.948-1.953-19.948s6.2-51.7,7.147-60.026c0,0,1.3,14.836,2.382,26.122s1.188,20.392,4.038,43.727c2.236,18.3,7.554,57.8,7.554,57.8a15.182,15.182,0,0,0,13.463-1.262s7.218-52.507,6.629-65.409",
    transform: "translate(142.206 79.404)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5075",
    "data-name": "Trac\\xE9 5075",
    d: "M407.853,356.121s.169-8.838,12.08-10.3l.693.373a10.3,10.3,0,0,0-5.963-4.415c-3.991-.991-7.1.1-9.132,2.823s.225,9.843,2.322,11.523",
    transform: "translate(151.751 128.01)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5076",
    "data-name": "Trac\\xE9 5076",
    d: "M407.09,264.682l.775-10.565a86.424,86.424,0,0,0,18.862-9.471,25.373,25.373,0,0,1-15.19,11.525l-1.9,10.368-.162,24.265Z",
    transform: "translate(152.634 91.727)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5077",
    "data-name": "Trac\\xE9 5077",
    d: "M479.463,306.853l-18.8,54.857a1.765,1.765,0,0,1-3.342-.011l-18.558-55.293Z",
    transform: "translate(164.509 114.883)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5078",
    "data-name": "Trac\\xE9 5078",
    d: "M453.341,349.848a1.764,1.764,0,0,0,3.341.011l3.671-10.711a9.771,9.771,0,0,1-10.162-.564l-.819-.565Z",
    transform: "translate(168.487 126.736)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5079",
    "data-name": "Trac\\xE9 5079",
    d: "M439.474,128.49l-.012,5.368-.041,6.477-.663,232.774c4.3,4.918,10.674,7.415,17.139,8.065,9.842,1.023,19.935-2.2,23.54-7.616l.656-232.634.033-12.381c-.466,8.014-41.01,7.992-40.651-.054",
    transform: "translate(164.507 48.176)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4951",
    "data-name": "Groupe 4951",
    transform: "translate(603.265 176.666)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4950",
    "data-name": "Groupe 4950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4949",
    "data-name": "Groupe 4949",
    clipPath: "url(#clip-path-135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5080",
    "data-name": "Trac\\xE9 5080",
    d: "M439.474,128.49l-.012,5.368-.041,6.477-.663,232.774c4.3,4.918,10.674,7.415,17.139,8.065,9.842,1.023,19.935-2.2,23.54-7.616l.656-232.634.033-12.381c-.466,8.014-41.01,7.992-40.651-.054",
    transform: "translate(-438.758 -128.49)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5081",
    "data-name": "Trac\\xE9 5081",
    d: "M439.194,143.38l-.013,11.987c-.12,3.474,7.282,5.717,15.827,6.5,11.346,1.075,24.7-2,24.87-6.6l.026-8.834-.047-3.16c-.166,4.6-13.527,7.687-24.873,6.613-8.186-.764-15.351-2.892-15.76-6.132v-.036a.725.725,0,0,1-.03-.338",
    transform: "translate(164.665 53.719)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5082",
    "data-name": "Trac\\xE9 5082",
    d: "M439.207,148.826c-.293,8.068,40.379,7.966,40.671-.1l.051-12c-.293,8.068-40.958,8.168-40.665.1Z",
    transform: "translate(164.675 51.264)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5083",
    "data-name": "Trac\\xE9 5083",
    d: "M439.294,128.49l-.054,11.845c-.345,7.92,38.9,8.152,40.672.59a1.654,1.654,0,0,0,.071-.45l-.038-11.932c-.466,8.014-41.01,7.992-40.651-.054",
    transform: "translate(164.687 48.176)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5084",
    "data-name": "Trac\\xE9 5084",
    d: "M480.122,94.568v-.5c0-5.78-9.1-10.466-20.333-10.466s-20.333,4.686-20.333,10.466v5.449l-.177,45.806c-.157,3.44,7.157,5.7,15.63,6.528,11.349,1.111,24.765-1.885,25.021-6.475.018-.018.018-.018.016-.054l.177-50.424c0-.076,0-.292,0-.329",
    transform: "translate(164.702 31.345)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4954",
    "data-name": "Groupe 4954",
    transform: "translate(604.16 114.946)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4953",
    "data-name": "Groupe 4953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4952",
    "data-name": "Groupe 4952",
    clipPath: "url(#clip-path-136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5085",
    "data-name": "Trac\\xE9 5085",
    d: "M480.073,94.066c0,5.78-9.1,10.465-20.333,10.465s-20.331-4.684-20.331-10.465S448.511,83.6,459.74,83.6s20.333,4.684,20.333,10.465",
    transform: "translate(-439.409 -83.601)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4957",
    "data-name": "Groupe 4957",
    transform: "translate(625.169 125.913)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4956",
    "data-name": "Groupe 4956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4955",
    "data-name": "Groupe 4955",
    clipPath: "url(#clip-path-137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5086",
    "data-name": "Trac\\xE9 5086",
    d: "M474.12,154.765l.224-63.188c-.275,4.951-8.7,9.63-17.909,9.963L455.778,395.2l-1.089,47.056,18.8-54.857h-.028Z",
    transform: "translate(-454.689 -91.577)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5087",
    "data-name": "Trac\\xE9 5087",
    d: "M420.32,157.721c7.726-1.123,15.626,2.278,22.263,11.606s29.945,31.666,32.476,38.887c1.846,5.269,2.584,19.868-8.3,15.23-10.546-4.493-46.811-40.761-46.811-40.761Z",
    transform: "translate(157.453 59.058)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5088",
    "data-name": "Trac\\xE9 5088",
    d: "M420.232,157.26c4.3-1.042,10.707.429,13.965,2.636s9.67,9.565,17.027,17.869a166.272,166.272,0,0,1,10.931,13.425s-.3,13.011-14.129,19.395l-28.859-24.306Z",
    transform: "translate(157.162 58.835)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5089",
    "data-name": "Trac\\xE9 5089",
    d: "M455.027,198.049,474.02,181l.051-18.082s3.744,1.251,5.232,7.078,3.347,12.611,2.6,17.585-16.439,32.64-22.5,34.548c-7.289,2.3-4.377-24.079-4.377-24.079",
    transform: "translate(170.392 61.084)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5090",
    "data-name": "Trac\\xE9 5090",
    d: "M397.938,154.25l2.625,23.27L422.2,172.6,419.4,141.538Z",
    transform: "translate(149.202 53.068)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5091",
    "data-name": "Trac\\xE9 5091",
    d: "M451.677,169.365c-1.185-6.513-9.748-13.355-17.763-12.053q-2.795.454-5.441.92c-.962,3.914-11.69,6.363-21.937,3.95-3.089.811-13.258,2.715-15.831,3.569-7.366,2.446-10.405,9.695-11.552,33.716,0,0,.59,54.4.3,65.233,18.185,7.675,37.273,7.88,47.873,5.813,22.066-4.3,24.921-13.352,24.921-13.352l-3.286-24.885s5.394-48.181,2.713-62.912",
    transform: "translate(142.159 58.922)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5092",
    "data-name": "Trac\\xE9 5092",
    d: "M400.184,157.4h0a28.879,28.879,0,0,0,13.678.543c7.14-1.588,8.562-2.684,8.562-2.684l-.15-1.661s1.156-.07,2.711,2.077c1.7,2.34,2.277,3.129,2.277,3.129s-.421,5.206-8.816,7.752a25.94,25.94,0,0,1-20.9-2.282l-3.292.694s2.846-6.563,3.707-7.892a2.186,2.186,0,0,1,2.058-1.141Z",
    transform: "translate(147.821 57.59)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5093",
    "data-name": "Trac\\xE9 5093",
    d: "M388.017,130.065s-5.486,8.325-4.862,9.143,4.662,1.555,4.662,1.555Z",
    transform: "translate(143.641 48.766)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5094",
    "data-name": "Trac\\xE9 5094",
    d: "M390.328,137.522a6.538,6.538,0,1,1,6.536-6.539,6.545,6.545,0,0,1-6.536,6.539m0-11.622a5.084,5.084,0,1,0,5.083,5.083,5.088,5.088,0,0,0-5.083-5.083",
    transform: "translate(143.898 46.66)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5095",
    "data-name": "Trac\\xE9 5095",
    d: "M402.032,113.61c-11.1,2.342-14.308,7.224-15.354,24.862-1.093,18.427.788,24.222,3.209,26.7,1.635,1.672,10.716,1.976,15.3.712,5.735-1.581,18.692-6.173,24.763-15.443,7.139-10.906,9.016-25.688,1.371-31.75-10.756-8.534-24.77-6.037-29.288-5.085",
    transform: "translate(144.861 42.19)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5096",
    "data-name": "Trac\\xE9 5096",
    d: "M401.288,152.639l-.516-3.395a21.963,21.963,0,0,1-11.383,2.579c2.119,1.046,7.646,1.345,11.9.815",
    transform: "translate(145.997 55.957)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5097",
    "data-name": "Trac\\xE9 5097",
    d: "M384.236,128.207l19.74,2.555-.795,1.386-18.945-2.457Z",
    transform: "translate(144.065 48.07)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5098",
    "data-name": "Trac\\xE9 5098",
    d: "M386.335,125.046a5.6,5.6,0,0,0,2.508-.158,3.954,3.954,0,0,0,1.354,4.627,5.587,5.587,0,0,0,4.979.663,4.8,4.8,0,0,0-.545,3.432,5.567,5.567,0,0,0,5.75,4.15c.118,2.578.15,5.1,2.905,6.278,0,0,1.754-6.813,7.5-5.956,5.779.862,6.56,8.229,2.918,12.7-3.616,4.442-6.986,2.786-7.037,2.761a11.921,11.921,0,0,0,.91,3.253,13.277,13.277,0,0,0,4.855,5.35,26.124,26.124,0,0,0,13.84,3.747c1.8-5.207,4.757-9.149,7.9-13.715,2.461-3.579,5.6-7.649,6.842-11.812a23.348,23.348,0,0,0,.139-13.887c-1.361-4.125-2.973-7.262-7.464-8.369-1.02-5.522-6.53-8.435-11.54-10.971a18.613,18.613,0,0,0-16.26-.135c-1.849-1.963-3.307-4.309-5.882-5.445-2.1-.928-4.892-.7-6.293,1.126-1.118,1.455-1.086,3.457-1.005,5.289a12.337,12.337,0,0,0-6.322.546,6.565,6.565,0,0,0-4.088,4.6,4.529,4.529,0,0,0,2.835,5.126,3.983,3.983,0,0,0-1.428,4.489,3.358,3.358,0,0,0,2.636,2.3",
    transform: "translate(143.307 37.88)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5099",
    "data-name": "Trac\\xE9 5099",
    d: "M398.479,137.238l.2-7.709a3.856,3.856,0,0,0-.2,7.709",
    transform: "translate(147.998 48.565)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5100",
    "data-name": "Trac\\xE9 5100",
    d: "M354.91,192.068l46.1,24.763.756,1.189v.958a1.385,1.385,0,0,1-.756,1.191l-34.364,19.785a2.7,2.7,0,0,1-2.526,0L318.841,213.8v-.958Z",
    transform: "translate(119.546 72.014)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5101",
    "data-name": "Trac\\xE9 5101",
    d: "M365.383,239.565a2.565,2.565,0,0,0,1.263-.313l34.364-19.785a1.314,1.314,0,0,0,0-2.38l-44.481-25.7-37.689,21.706,45.279,26.158a2.557,2.557,0,0,0,1.262.313",
    transform: "translate(119.546 71.758)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5102",
    "data-name": "Trac\\xE9 5102",
    d: "M356.1,189.342l44.081,25.468.357.5v3.736a.6.6,0,0,1-.357.5l-34.364,19.787a1.914,1.914,0,0,1-1.728,0L320,213.86v-3.734Z",
    transform: "translate(119.981 70.992)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5103",
    "data-name": "Trac\\xE9 5103",
    d: "M320,210.127l.435.252,5.663,3.268,1.053.61,36.931,21.336a1.911,1.911,0,0,0,1.727,0l34.368-19.788a.527.527,0,0,0,0-1l-.463-.268-43.619-25.2-35.664,20.533-.1.065Z",
    transform: "translate(119.981 70.992)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5104",
    "data-name": "Trac\\xE9 5104",
    d: "M352.691,228.719v3.734a1.743,1.743,0,0,0,.862-.208l34.366-19.788a.6.6,0,0,0,.356-.5v-3.733a.615.615,0,0,1-.356.5l-34.366,19.787a1.729,1.729,0,0,1-.862.208",
    transform: "translate(132.237 78.072)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5105",
    "data-name": "Trac\\xE9 5105",
    d: "M320,209.764l6.264,3.615.982.568,36.836,21.284a1.911,1.911,0,0,0,1.727,0l29.3-16.859c.392-.215.755-.426,1.093-.63a10.681,10.681,0,0,0,3.516-3.065c.029-.044.056-.084.084-.128a.7.7,0,0,0,.109-.26.777.777,0,0,0-.608-.877,16.012,16.012,0,0,1-3.275-1.365.432.432,0,0,1-.044-.023L356.1,188.979Z",
    transform: "translate(119.981 70.856)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5106",
    "data-name": "Trac\\xE9 5106",
    d: "M330.514,209.378l24.441-14.111a1.2,1.2,0,0,1,1.088,0l.063.037a.331.331,0,0,1,0,.628l-24.441,14.11a1.2,1.2,0,0,1-1.089,0l-.062-.036a.332.332,0,0,1,0-.628",
    transform: "translate(123.838 73.165)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5107",
    "data-name": "Trac\\xE9 5107",
    d: "M332.259,210.366,356.7,196.255a1.2,1.2,0,0,1,1.088,0l.063.037a.331.331,0,0,1,0,.628l-24.441,14.11a1.2,1.2,0,0,1-1.089,0l-.062-.036a.331.331,0,0,1,0-.628",
    transform: "translate(124.492 73.535)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5108",
    "data-name": "Trac\\xE9 5108",
    d: "M334,211.355l24.441-14.111a1.2,1.2,0,0,1,1.088,0l.063.037a.331.331,0,0,1,0,.628l-24.441,14.11a1.2,1.2,0,0,1-1.089,0l-.062-.036a.332.332,0,0,1,0-.628",
    transform: "translate(125.146 73.906)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5109",
    "data-name": "Trac\\xE9 5109",
    d: "M346.406,218.563l24.44-14.111a1.2,1.2,0,0,1,1.088,0l.063.037a.331.331,0,0,1,0,.628l-24.441,14.111a1.2,1.2,0,0,1-1.089,0l-.061-.036a.331.331,0,0,1,0-.628",
    transform: "translate(129.796 76.608)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_544",
    "data-name": 544,
    transform: "translate(488.514 283.771) rotate(-45)",
    fill: "#e0e0e0",
    fontSize: 1,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "544")), /*#__PURE__*/React.createElement("text", {
    id: "_216",
    "data-name": 216,
    transform: "translate(485.485 281.9) rotate(-45)",
    fill: "#e0e0e0",
    fontSize: 2,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "216")), /*#__PURE__*/React.createElement("text", {
    id: "_954",
    "data-name": 954,
    transform: "translate(480.628 279.149) rotate(-45)",
    fill: "#e0e0e0",
    fontSize: 1,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "954")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(480.936 283.197) rotate(-45)",
    fill: "#e0e0e0",
    fontSize: 2,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")), /*#__PURE__*/React.createElement("text", {
    id: "_914",
    "data-name": 914,
    transform: "translate(477.373 291.334) rotate(-45)",
    fill: "#e0e0e0",
    fontSize: 2,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "914")), /*#__PURE__*/React.createElement("text", {
    id: "_356",
    "data-name": 356,
    transform: "translate(472.321 288.4) rotate(-45)",
    fill: "#e0e0e0",
    fontSize: 1,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "356")), /*#__PURE__*/React.createElement("text", {
    id: "_984",
    "data-name": 984,
    transform: "translate(468.396 286.227) rotate(-45)",
    fill: "#e0e0e0",
    fontSize: 1,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "984")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "+",
    transform: "translate(468.767 290.242) rotate(-45)",
    fill: "#e0e0e0",
    fontSize: 2,
    fontFamily: "Rubik-Medium, Rubik",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4960",
    "data-name": "Groupe 4960",
    transform: "translate(444.518 279.987)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4959",
    "data-name": "Groupe 4959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4958",
    "data-name": "Groupe 4958",
    clipPath: "url(#clip-path-138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5110",
    "data-name": "Trac\\xE9 5110",
    d: "M325.25,203.83a.5.5,0,0,1,0,.936,1.783,1.783,0,0,1-1.613,0,.494.494,0,0,1,0-.936,1.774,1.774,0,0,1,1.613,0",
    transform: "translate(-323.3 -203.636)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5111",
    "data-name": "Trac\\xE9 5111",
    d: "M320.134,204.158a5.537,5.537,0,0,0,.061.806l.566-.327a3.745,3.745,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.174,1.174,0,0,1,.583-.151,2.049,2.049,0,0,1,.99.3,6.081,6.081,0,0,1,2.433,3.48,1.639,1.639,0,0,0,.594-.072,6.762,6.762,0,0,0-2.729-3.927,2.126,2.126,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.518",
    transform: "translate(120.031 75.516)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5112",
    "data-name": "Trac\\xE9 5112",
    d: "M320.219,204.221a1.117,1.117,0,0,0,.028.14l.1-.065Z",
    transform: "translate(120.062 76.57)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4963",
    "data-name": "Groupe 4963",
    transform: "translate(449.379 277.179)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4962",
    "data-name": "Groupe 4962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4961",
    "data-name": "Groupe 4961",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5113",
    "data-name": "Trac\\xE9 5113",
    d: "M328.785,201.788a.5.5,0,0,1,0,.936,1.783,1.783,0,0,1-1.613,0,.494.494,0,0,1,0-.936,1.774,1.774,0,0,1,1.613,0",
    transform: "translate(-326.836 -201.594)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5114",
    "data-name": "Trac\\xE9 5114",
    d: "M323.671,202.116a5.55,5.55,0,0,0,.059.806l.568-.327a3.724,3.724,0,0,1-.029-.479,2.218,2.218,0,0,1,.818-2,1.173,1.173,0,0,1,.583-.151,2.033,2.033,0,0,1,.99.3,6.073,6.073,0,0,1,2.434,3.479,1.635,1.635,0,0,0,.594-.072,6.761,6.761,0,0,0-2.729-3.927,2.131,2.131,0,0,0-2.171-.151,2.773,2.773,0,0,0-1.117,2.517",
    transform: "translate(121.357 74.75)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4966",
    "data-name": "Groupe 4966",
    transform: "translate(454.243 274.372)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4965",
    "data-name": "Groupe 4965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4964",
    "data-name": "Groupe 4964",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5115",
    "data-name": "Trac\\xE9 5115",
    d: "M332.322,199.746a.5.5,0,0,1,0,.935,1.774,1.774,0,0,1-1.613,0,.493.493,0,0,1,0-.935,1.774,1.774,0,0,1,1.613,0",
    transform: "translate(-330.373 -199.552)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5116",
    "data-name": "Trac\\xE9 5116",
    d: "M327.208,200.074a5.355,5.355,0,0,0,.061.806l.566-.327a3.724,3.724,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.159,1.159,0,0,1,.583-.151,2.045,2.045,0,0,1,.99.3,6.082,6.082,0,0,1,2.434,3.48,1.636,1.636,0,0,0,.594-.072,6.76,6.76,0,0,0-2.729-3.927,2.128,2.128,0,0,0-2.171-.151,2.773,2.773,0,0,0-1.117,2.518",
    transform: "translate(122.683 73.984)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4969",
    "data-name": "Groupe 4969",
    transform: "translate(459.106 271.564)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4968",
    "data-name": "Groupe 4968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4967",
    "data-name": "Groupe 4967",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5117",
    "data-name": "Trac\\xE9 5117",
    d: "M335.86,197.7a.5.5,0,0,1,0,.936,1.782,1.782,0,0,1-1.613,0,.494.494,0,0,1,0-.936,1.777,1.777,0,0,1,1.614,0",
    transform: "translate(-333.91 -197.51)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5118",
    "data-name": "Trac\\xE9 5118",
    d: "M330.744,198.032a5.541,5.541,0,0,0,.059.806l.568-.327a3.711,3.711,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.159,1.159,0,0,1,.583-.151,2.047,2.047,0,0,1,.99.3,6.074,6.074,0,0,1,2.434,3.48,1.639,1.639,0,0,0,.594-.072,6.767,6.767,0,0,0-2.729-3.927,2.129,2.129,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.518",
    transform: "translate(124.009 73.219)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4972",
    "data-name": "Groupe 4972",
    transform: "translate(463.969 268.756)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4971",
    "data-name": "Groupe 4971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4970",
    "data-name": "Groupe 4970",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5119",
    "data-name": "Trac\\xE9 5119",
    d: "M339.4,195.662a.5.5,0,0,1,0,.936,1.782,1.782,0,0,1-1.613,0,.494.494,0,0,1,0-.936,1.774,1.774,0,0,1,1.613,0",
    transform: "translate(-337.447 -195.468)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5120",
    "data-name": "Trac\\xE9 5120",
    d: "M334.281,195.99a5.372,5.372,0,0,0,.06.806l.565-.327a3.967,3.967,0,0,1-.028-.478,2.218,2.218,0,0,1,.818-2,1.172,1.172,0,0,1,.583-.151,2.048,2.048,0,0,1,.99.3,6.074,6.074,0,0,1,2.434,3.48,1.638,1.638,0,0,0,.594-.072,6.768,6.768,0,0,0-2.729-3.927,2.129,2.129,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.518",
    transform: "translate(125.335 72.453)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4975",
    "data-name": "Groupe 4975",
    transform: "translate(468.832 265.949)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4974",
    "data-name": "Groupe 4974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4973",
    "data-name": "Groupe 4973",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5121",
    "data-name": "Trac\\xE9 5121",
    d: "M342.932,193.62a.5.5,0,0,1,0,.936,1.774,1.774,0,0,1-1.613,0,.494.494,0,0,1,0-.936,1.774,1.774,0,0,1,1.613,0",
    transform: "translate(-340.984 -193.426)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5122",
    "data-name": "Trac\\xE9 5122",
    d: "M337.818,193.948a5.736,5.736,0,0,0,.059.806l.568-.327a3.734,3.734,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.159,1.159,0,0,1,.583-.151,2.048,2.048,0,0,1,.99.3,6.081,6.081,0,0,1,2.434,3.48,1.638,1.638,0,0,0,.594-.071,6.767,6.767,0,0,0-2.729-3.927,2.126,2.126,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.517",
    transform: "translate(126.661 71.688)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4978",
    "data-name": "Groupe 4978",
    transform: "translate(473.694 263.143)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4977",
    "data-name": "Groupe 4977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4976",
    "data-name": "Groupe 4976",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5123",
    "data-name": "Trac\\xE9 5123",
    d: "M346.469,191.578a.5.5,0,0,1,0,.938,1.774,1.774,0,0,1-1.613,0,.5.5,0,0,1,0-.938,1.774,1.774,0,0,1,1.613,0",
    transform: "translate(-344.52 -191.385)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5124",
    "data-name": "Trac\\xE9 5124",
    d: "M341.354,191.906a5.377,5.377,0,0,0,.061.806l.566-.327a3.713,3.713,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.173,1.173,0,0,1,.583-.151,2.049,2.049,0,0,1,.99.3,6.081,6.081,0,0,1,2.434,3.48,1.65,1.65,0,0,0,.6-.072,6.768,6.768,0,0,0-2.731-3.927,2.129,2.129,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.518",
    transform: "translate(127.987 70.922)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4981",
    "data-name": "Groupe 4981",
    transform: "translate(440.165 260.079)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4980",
    "data-name": "Groupe 4980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4979",
    "data-name": "Groupe 4979",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5125",
    "data-name": "Trac\\xE9 5125",
    d: "M320.134,204.158a5.537,5.537,0,0,0,.061.806l.566-.327a3.745,3.745,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.174,1.174,0,0,1,.583-.151,2.049,2.049,0,0,1,.99.3,6.081,6.081,0,0,1,2.433,3.48,1.639,1.639,0,0,0,.594-.072,6.762,6.762,0,0,0-2.729-3.927,2.126,2.126,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.518",
    transform: "translate(-320.134 -184.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5126",
    "data-name": "Trac\\xE9 5126",
    d: "M323.671,202.116a5.55,5.55,0,0,0,.059.806l.568-.327a3.724,3.724,0,0,1-.029-.479,2.218,2.218,0,0,1,.818-2,1.173,1.173,0,0,1,.583-.151,2.033,2.033,0,0,1,.99.3,6.073,6.073,0,0,1,2.434,3.479,1.635,1.635,0,0,0,.594-.072,6.761,6.761,0,0,0-2.729-3.927,2.131,2.131,0,0,0-2.171-.151,2.773,2.773,0,0,0-1.117,2.517",
    transform: "translate(-318.808 -185.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5127",
    "data-name": "Trac\\xE9 5127",
    d: "M327.208,200.074a5.355,5.355,0,0,0,.061.806l.566-.327a3.724,3.724,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.159,1.159,0,0,1,.583-.151,2.045,2.045,0,0,1,.99.3,6.082,6.082,0,0,1,2.434,3.48,1.636,1.636,0,0,0,.594-.072,6.76,6.76,0,0,0-2.729-3.927,2.128,2.128,0,0,0-2.171-.151,2.773,2.773,0,0,0-1.117,2.518",
    transform: "translate(-317.482 -186.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5128",
    "data-name": "Trac\\xE9 5128",
    d: "M330.744,198.032a5.541,5.541,0,0,0,.059.806l.568-.327a3.711,3.711,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.159,1.159,0,0,1,.583-.151,2.047,2.047,0,0,1,.99.3,6.074,6.074,0,0,1,2.434,3.48,1.639,1.639,0,0,0,.594-.072,6.767,6.767,0,0,0-2.729-3.927,2.129,2.129,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.518",
    transform: "translate(-316.156 -186.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5129",
    "data-name": "Trac\\xE9 5129",
    d: "M334.281,195.99a5.372,5.372,0,0,0,.06.806l.565-.327a3.967,3.967,0,0,1-.028-.478,2.218,2.218,0,0,1,.818-2,1.172,1.172,0,0,1,.583-.151,2.048,2.048,0,0,1,.99.3,6.074,6.074,0,0,1,2.434,3.48,1.638,1.638,0,0,0,.594-.072,6.768,6.768,0,0,0-2.729-3.927,2.129,2.129,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.518",
    transform: "translate(-314.83 -187.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5130",
    "data-name": "Trac\\xE9 5130",
    d: "M337.818,193.948a5.736,5.736,0,0,0,.059.806l.568-.327a3.734,3.734,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.159,1.159,0,0,1,.583-.151,2.048,2.048,0,0,1,.99.3,6.081,6.081,0,0,1,2.434,3.48,1.638,1.638,0,0,0,.594-.071,6.767,6.767,0,0,0-2.729-3.927,2.126,2.126,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.517",
    transform: "translate(-313.504 -188.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5131",
    "data-name": "Trac\\xE9 5131",
    d: "M341.354,191.906a5.377,5.377,0,0,0,.061.806l.566-.327a3.713,3.713,0,0,1-.029-.478,2.218,2.218,0,0,1,.818-2,1.173,1.173,0,0,1,.583-.151,2.049,2.049,0,0,1,.99.3,6.081,6.081,0,0,1,2.434,3.48,1.65,1.65,0,0,0,.6-.072,6.768,6.768,0,0,0-2.731-3.927,2.129,2.129,0,0,0-2.17-.151,2.77,2.77,0,0,0-1.118,2.518",
    transform: "translate(-312.178 -189.157)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5132",
    "data-name": "Trac\\xE9 5132",
    d: "M360.745,247.288c8.558-.84,39.747-3.188,42.114-9.029,2.919-7.2,15.263-46.21,15.263-46.21s4.063-26.241-8.6-27.328c-5.472,1.088-10.393,3.961-12.464,13.707-1.079,5.08-6.789,25.508-11.371,48.179,0,0-33.219,10.269-35.663,9.425s-2.553-3.153-4.485-5.941-3.33-6.367-4.865-5.387-.569,5.566,0,7.742a5.607,5.607,0,0,1-.828,4.177s-1.453-.543-2.8-.921c-.726-.2-12.151-6.873-12.151-6.873s-1.093,7.251,2.426,10.807c4.419,5.111,10.705,7.011,16.443,7.84,6.634.958,8.417.653,16.975-.187",
    transform: "translate(121.758 61.76)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5133",
    "data-name": "Trac\\xE9 5133",
    d: "M393.883,163.406c-7.427,1.558-12.493,3.506-15.024,13.245s-8.18,32.16-8.18,32.16,11.526,9.3,23.613,9.037l7.487-25.435s6.151-23.164-7.9-29.007",
    transform: "translate(138.982 61.267)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4994",
    "data-name": "Groupe 4994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4993",
    "data-name": "Groupe 4993",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5134",
    "data-name": "Trac\\xE9 5134",
    d: "M414.079,66.306,399.34,74.84,405.194,88a1.336,1.336,0,0,0,.56.627c.7.4,4.836,2.791,5.064,2.923a1.353,1.353,0,0,0,1.977-.786l6.358-21.529Z",
    transform: "translate(149.728 24.861)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4986",
    "data-name": "Groupe 4986",
    transform: "translate(549.067 91.167)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4985",
    "data-name": "Groupe 4985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4984",
    "data-name": "Groupe 4984",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5135",
    "data-name": "Trac\\xE9 5135",
    d: "M414.079,66.306,399.34,74.84,405.194,88a1.336,1.336,0,0,0,.56.627c.7.4,4.836,2.791,5.064,2.923a1.353,1.353,0,0,0,1.977-.786l6.358-21.529Z",
    transform: "translate(-399.339 -66.306)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5136",
    "data-name": "Trac\\xE9 5136",
    d: "M403.029,76.971l5.856,13.161a1.35,1.35,0,0,0,2.527-.166l6.356-21.529Z",
    transform: "translate(151.111 25.66)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5137",
    "data-name": "Trac\\xE9 5137",
    d: "M442.168.34,381.273,35.5a3.089,3.089,0,0,0-1.4,2.42v75.565a3.05,3.05,0,0,0,1.405,2.408l5.008,2.808a3.129,3.129,0,0,0,2.8-.015l60.893-35.154a3.089,3.089,0,0,0,1.4-2.421V5.54a3.054,3.054,0,0,0-1.405-2.408L444.971.327a3.129,3.129,0,0,0-2.8.014",
    transform: "translate(142.43 0.001)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4989",
    "data-name": "Groupe 4989",
    transform: "translate(522.743)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4988",
    "data-name": "Groupe 4988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4987",
    "data-name": "Groupe 4987",
    clipPath: "url(#clip-path-148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5138",
    "data-name": "Trac\\xE9 5138",
    d: "M451.247,5.288c-.11-.7-.685-.956-1.382-.555L388.976,39.89a2.843,2.843,0,0,0-.987,1.046l-7.795-4.447a2.81,2.81,0,0,1,.962-.994L442.052.338a3.123,3.123,0,0,1,2.8-.012l5,2.806a3.085,3.085,0,0,1,1.389,2.156",
    transform: "translate(-380.194 0)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5139",
    "data-name": "Trac\\xE9 5139",
    d: "M385.562,116.636V41.071a3.086,3.086,0,0,1,1.4-2.42L447.854,3.5c.773-.445,1.4-.085,1.4.807V79.867a3.086,3.086,0,0,1-1.4,2.42L386.96,117.443c-.773.445-1.4.084-1.4-.807",
    transform: "translate(144.562 1.239)",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4992",
    "data-name": "Groupe 4992",
    transform: "translate(522.305 36.489)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4991",
    "data-name": "Groupe 4991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4990",
    "data-name": "Groupe 4990",
    clipPath: "url(#clip-path-149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5140",
    "data-name": "Trac\\xE9 5140",
    d: "M389.093,108.731a3.2,3.2,0,0,1-2.8.016l-5-2.813a3.034,3.034,0,0,1-1.408-2.4V27.965a2.879,2.879,0,0,1,.445-1.426l7.788,4.445a2.781,2.781,0,0,0-.414,1.375v75.562c0,.817.576,1.287,1.4.81",
    transform: "translate(-379.875 -26.539)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5141",
    "data-name": "Trac\\xE9 5141",
    d: "M408.775,39.914q.1,2.182.1,3.9t-.1,3.859a21.051,21.051,0,0,1-2.519,9.092,15.636,15.636,0,0,1-5.9,6.244q-3.638,2.1-5.9.564t-2.52-6.183q-.105-2.019-.1-3.738t.1-4.019a20.963,20.963,0,0,1,2.39-9.1,15.558,15.558,0,0,1,6.026-6.318q3.842-2.219,6.025-.639t2.39,6.337M423.536,22.99a9.564,9.564,0,0,1,.754-1.555,3.126,3.126,0,0,1,1.116-1.044l5.4-3.12c.379-.22.683-.247.909-.087a1.133,1.133,0,0,1,.337.965,2.532,2.532,0,0,1-.051.43,4.412,4.412,0,0,1-.157.571l-25.661,66.8a9.436,9.436,0,0,1-.754,1.554,3.116,3.116,0,0,1-1.116,1.045l-5.4,3.118c-.382.221-.685.25-.91.085a1.128,1.128,0,0,1-.337-.965,2.411,2.411,0,0,1,.051-.429,3.949,3.949,0,0,1,.157-.569ZM398.672,53.943a4.667,4.667,0,0,0,.439,1.981q.369.67,1.25.162a2.8,2.8,0,0,0,1.248-1.6,9.2,9.2,0,0,0,.439-2.489q.2-4.587,0-8.63a4.737,4.737,0,0,0-.439-1.983c-.247-.444-.664-.5-1.248-.161a2.8,2.8,0,0,0-1.25,1.6,9.121,9.121,0,0,0-.439,2.489q-.2,4.275,0,8.63m39.733-2.8q.1,2.182.106,3.9T438.4,58.9A21.062,21.062,0,0,1,435.887,68a15.636,15.636,0,0,1-5.9,6.242q-3.638,2.1-5.9.565t-2.52-6.183q-.1-2.019-.1-3.738t.1-4.019a20.975,20.975,0,0,1,2.39-9.1,15.558,15.558,0,0,1,6.026-6.318q3.842-2.219,6.025-.639t2.39,6.337M428.3,65.173a4.672,4.672,0,0,0,.439,1.983c.247.447.664.5,1.25.161a2.8,2.8,0,0,0,1.25-1.6,9.173,9.173,0,0,0,.437-2.49q.206-4.587,0-8.63a4.71,4.71,0,0,0-.437-1.981c-.249-.444-.665-.5-1.25-.162a2.808,2.808,0,0,0-1.25,1.6,9.126,9.126,0,0,0-.439,2.489q-.2,4.279,0,8.63",
    transform: "translate(146.916 6.405)",
    fill: "#fafafa"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWaitingElement);
export default __webpack_public_path__ + "static/media/no-waiting-element.7a9c0d2ed2433e3b217f88619a6acadd.svg";
export { ForwardRef as ReactComponent };